// Translations for 16 languages: de (base), fr, it, en, es, tr, ar, pt, nl, sv, hr, sr, bs, sq, fa, ta
// Uses German as fallback if a key is missing.
// Physical address, phone number and email are kept in original Latin script across all languages.

export const LANGUAGES = [
  { code: "de", label: "Deutsch",     flag: "🇩🇪", dir: "ltr" },
  { code: "fr", label: "Français",    flag: "🇫🇷", dir: "ltr" },
  { code: "it", label: "Italiano",    flag: "🇮🇹", dir: "ltr" },
  { code: "en", label: "English",     flag: "🇬🇧", dir: "ltr" },
  { code: "es", label: "Español",     flag: "🇪🇸", dir: "ltr" },
  { code: "pt", label: "Português",   flag: "🇵🇹", dir: "ltr" },
  { code: "nl", label: "Nederlands",  flag: "🇳🇱", dir: "ltr" },
  { code: "sv", label: "Svenska",     flag: "🇸🇪", dir: "ltr" },
  { code: "hr", label: "Hrvatski",    flag: "🇭🇷", dir: "ltr" },
  { code: "sr", label: "Srpski",      flag: "🇷🇸", dir: "ltr" },
  { code: "bs", label: "Bosanski",    flag: "🇧🇦", dir: "ltr" },
  { code: "sq", label: "Shqip",       flag: "🇦🇱", dir: "ltr" },
  { code: "tr", label: "Türkçe",      flag: "🇹🇷", dir: "ltr" },
  { code: "ar", label: "العربية",     flag: "🇮🇶", dir: "rtl" },
  { code: "fa", label: "فارسی",       flag: "🇮🇷", dir: "rtl" },
  { code: "ta", label: "தமிழ்",       flag: "🇮🇳", dir: "ltr" },
];

export const CURRENCIES = ["CHF","EUR","GBP","USD","SEK","DKK","NOK","PLN","CZK","TRY","IQD"];

// Fixed brand assets kept in Latin script for every language (as requested by user)
const KEEP = {
  contact_phone_value: "+41 (0)55 640 25 43",
  contact_email_value: "info@01co.ch",
  contact_address_value: "Kirchweg 20, 8750 Glarus",
};

const base = {
  brand_tagline: "Friseur & Beauty seit 2011",
  nav_home: "Startseite", nav_shop: "Shop", nav_about: "Über uns", nav_contact: "Kontakt",
  nav_account: "Konto", nav_cart: "Warenkorb", nav_wishlist: "Wunschliste", nav_admin: "Admin",
  nav_tracking: "Bestellung verfolgen", nav_consultation: "Beratung",
  aria_menu: "Menü", aria_wishlist: "Wunschliste", aria_account: "Konto", aria_cart: "Warenkorb",
  aria_close: "Schliessen", aria_remove: "Entfernen", aria_loading: "Laden…",
  aria_logo_home: "Coiffeur Tattoo 01&Co. Startseite", aria_basra: "Basra Assistent",
  aria_send: "Senden",
  since_2011: "Seit 2011", founder_label: "Gründer", address_label: "Adresse", phone_label: "Telefon",
  newsletter_label: "Newsletter", home_studio_alt: "Coiffeur Tattoo 01&Co. Studio in Glarus",
  time_remaining_label: "Verbleibende Zeit", missing_token_error: "Token fehlt.",
  hero_title: "Schweizer Handwerk. Natürliche Pflege.",
  hero_subtitle: "Premium-Pflegeprodukte, natürliche Öle, Aleppo-Seife, Miswak, Henna und mehr – kuratiert vom Team von Coiffeur Tattoo 01&Co. in Glarus.",
  hero_cta: "Kollektion entdecken", hero_secondary: "Unsere Geschichte",
  section_featured: "Ausgewählte Produkte", section_bestsellers: "Bestseller",
  section_oils: "Natürliche Öle", section_new: "Neuheiten",
  section_why_title: "Warum Coiffeur Tattoo 01&Co.",
  reason_swiss: "Schweizer Marke", reason_swiss_desc: "Gegründet in Glarus – Handwerk, das man spürt.",
  reason_natural: "Natürliche Rohstoffe", reason_natural_desc: "Wir wählen jedes Öl mit Bedacht aus.",
  reason_shipping: "Weltweiter Versand", reason_shipping_desc: "Kostenloser Versand ab CHF 100.",
  reason_secure: "Sichere Zahlung", reason_secure_desc: "Verschlüsselt mit Stripe.",
  newsletter_title: "Bleiben Sie inspiriert.",
  newsletter_desc: "Neue Produkte, Pflege-Tipps und exklusive Angebote.",
  newsletter_placeholder: "Ihre E-Mail-Adresse", newsletter_submit: "Abonnieren",
  cart_added: "Hinzugefügt", out_of_stock: "Ausverkauft",
  add_to_cart: "In den Warenkorb", buy_now: "Jetzt kaufen", view_details: "Details ansehen",
  price: "Preis", quantity: "Menge", size: "Größe", variant: "Variante",
  ingredients: "Inhaltsstoffe", benefits: "Vorteile", usage: "Anwendung", warnings: "Hinweise",
  suitable_for: "Geeignet für",
  suitable_haare: "Haare", suitable_bart: "Bart", suitable_gesicht: "Gesicht", suitable_haut: "Haut", suitable_koerper: "Körper",
  reviews: "Bewertungen", write_review: "Bewertung schreiben", verified_purchase: "Verifizierter Kauf",
  no_reviews: "Noch keine Bewertungen.", review_title: "Titel", review_body: "Ihre Erfahrung",
  review_rating: "Bewertung", submit_review: "Bewertung abschicken", review_pending: "Ihre Bewertung wurde eingereicht und wird geprüft.",
  questions_title: "Fragen & Antworten",
  ask_question: "Frage stellen", ask_placeholder: "Ihre Frage …",
  answer_placeholder: "Antworten …", submit_question: "Frage senden", submit_answer: "Antwort senden",
  qa_disclaimer: "Kundenmeinungen sind persönliche Erfahrungen und ersetzen keine professionelle medizinische Beratung.",
  no_questions: "Noch keine Fragen. Seien Sie die erste Person, die fragt.",
  qa_login_required: "Bitte melden Sie sich an, um zu fragen oder zu antworten.",
  question_pending: "Ihre Frage wurde eingereicht und wird geprüft.",
  report_content: "Melden", related_products: "Ähnliche Produkte",
  cart_title: "Warenkorb", cart_empty: "Ihr Warenkorb ist leer.",
  cart_subtotal: "Zwischensumme", cart_shipping: "Versand", cart_discount: "Rabatt", cart_total: "Gesamt", cart_tax_note: "MwSt. an der Kasse berechnet",
  cart_checkout: "Zur Kasse", cart_continue: "Weiter einkaufen", cart_remove: "Entfernen",
  cart_apply: "Anwenden", cart_discount_code: "Rabattcode",
  cart_discount_applied: "Rabatt angewendet", cart_discount_invalid: "Rabattcode ungültig",
  checkout_title: "Kasse", checkout_contact: "Kontakt", checkout_shipping: "Lieferadresse",
  checkout_billing_same: "Rechnungsadresse ist Lieferadresse", checkout_billing: "Rechnungsadresse",
  checkout_payment: "Zahlung", checkout_review: "Überprüfung",
  checkout_email: "E-Mail", checkout_name: "Vollständiger Name",
  checkout_address: "Straße & Nr.", checkout_city: "Stadt", checkout_postal: "PLZ",
  checkout_country: "Land", checkout_phone: "Telefon (optional)", checkout_notes: "Bestellnotizen (optional)",
  checkout_place_order: "Weiter zur Zahlung",
  checkout_secure_note: "Sichere Zahlung mit Stripe – Karten, TWINT, Apple Pay, Google Pay, Klarna & mehr.",
  payment_success: "Zahlung erfolgreich", payment_cancel: "Zahlung abgebrochen",
  payment_success_msg: "Danke für Ihren Einkauf!",
  payment_cancel_msg: "Ihre Zahlung wurde abgebrochen. Sie können es erneut versuchen.",
  order_number: "Bestellnummer",
  about_title: "Coiffeur Tattoo 01&Co.",
  about_intro: "Eine Schweizer Marke aus Glarus – seit 2011 im Zeichen von Stil und Qualität.",
  about_founder: "Gründer: Sajjad Al-Daghir",
  about_address: "Kirchweg 20, 8750 Glarus, Schweiz",
  about_philosophy_title: "Unsere Philosophie",
  about_philosophy_body: "Wir glauben, dass natürliche Produkte mehr als Produkte sind – sie sind eine Verbindung zwischen Menschen, Natur und traditionellem Wissen.\n\nUnser Ziel ist es, sorgfältig ausgewählte Naturprodukte, Öle, Seifen, Henna, Weihrauch, Düfte und traditionelle Körperpflegeprodukte zu Kunden zu bringen, die Qualität, Authentizität und bewusste Entscheidungen schätzen.\n\nWir konzentrieren uns auf sorgfältig gewählte Inhaltsstoffe, ehrliche Produktinformationen und ein Einkaufserlebnis, das auf Vertrauen basiert.",
  about_values_title: "Natürlich. Authentisch. Sorgfältig ausgewählt.",
  contact_title: "Kontakt", contact_phone: "Telefon", contact_email: "E-Mail",
  contact_address: "Adresse", contact_hours: "Öffnungszeiten",
  contact_form_title: "Schreiben Sie uns",
  contact_message: "Ihre Nachricht", contact_send: "Nachricht senden",
  contact_thanks: "Danke – wir melden uns bald.",
  consultation_title: "Beratung anfragen",
  consultation_intro: "Wir beraten Sie gerne persönlich zu Pflege und Produkten.",
  consultation_subject: "Thema", consultation_msg: "Ihre Frage / Anliegen",
  consultation_preferred: "Bevorzugter Kontakt", consultation_preferred_time: "Bevorzugter Termin",
  consultation_submit: "Anfrage senden", consultation_thanks: "Danke – wir kontaktieren Sie in Kürze.",
  channel_email: "E-Mail", channel_phone: "Telefon", channel_whatsapp: "WhatsApp",
  order_tracking_title: "Bestellung verfolgen",
  order_tracking_intro: "Geben Sie Ihre Bestellnummer und E-Mail an.",
  order_tracking_number: "Bestellnummer", order_tracking_email: "E-Mail-Adresse",
  order_tracking_submit: "Verfolgen", order_tracking_not_found: "Bestellung nicht gefunden.",
  order_status_pending: "Ausstehend", order_status_paid: "Bezahlt", order_status_processing: "In Bearbeitung",
  order_status_shipped: "Versendet", order_status_delivered: "Zugestellt",
  order_status_cancelled: "Storniert", order_status_refunded: "Erstattet",
  tracking_number: "Tracking-Nr.", tracking_carrier: "Versanddienst", tracking_link: "Verfolgen bei Anbieter",
  wishlist_title: "Wunschliste", wishlist_empty: "Ihre Wunschliste ist leer.",
  wishlist_add: "Zur Wunschliste hinzufügen", wishlist_remove: "Aus Wunschliste entfernen",
  wishlist_login: "Bitte anmelden, um die Wunschliste zu nutzen.",
  login: "Anmelden", register: "Registrieren", logout: "Abmelden",
  password: "Passwort", email: "E-Mail",
  forgot_password: "Passwort vergessen?", reset_password: "Passwort zurücksetzen",
  new_password: "Neues Passwort", current_password: "Aktuelles Passwort", change_password: "Passwort ändern",
  reset_link_sent: "Wenn ein Konto existiert, haben wir eine Anleitung zum Zurücksetzen erstellt.",
  reset_success: "Passwort erfolgreich zurückgesetzt.",
  delete_account: "Konto löschen", delete_confirm: "Konto wirklich unwiderruflich löschen?",
  my_orders: "Meine Bestellungen", my_profile: "Mein Profil",
  save: "Speichern", saved: "Gespeichert",
  admin_title: "Admin Dashboard",
  admin_products: "Produkte", admin_orders: "Bestellungen", admin_analytics: "Analytik",
  admin_customers: "Kunden", admin_reviews: "Bewertungen", admin_questions: "Fragen",
  admin_discounts: "Rabatte", admin_consultations: "Beratungsanfragen",
  admin_revenue: "Umsatz", admin_total_orders: "Bestellungen gesamt", admin_avg: "Ø Bestellwert",
  view_all: "Alle ansehen",
  footer_shop: "Shop", footer_brand: "Marke", footer_help: "Hilfe", footer_legal: "Rechtliches",
  footer_impressum: "Impressum", footer_datenschutz: "Datenschutz", footer_agb: "AGB",
  footer_shipping: "Versand", footer_returns: "Rückgabe", footer_faq: "FAQ", footer_cookies: "Cookies",
  copyright: "Alle Rechte vorbehalten.",
  free_shipping_over: "Kostenloser Versand ab CHF 100",
  new_badge: "Neu", bestseller_badge: "Bestseller", sale_badge: "Sale",
  stock_in: "Auf Lager", stock_low: "Wenige verfügbar", stock_out: "Ausverkauft", stock_setup: "Zurzeit nicht verfügbar", stock_low_1: "Fast ausverkauft — nur 1 Stück verfügbar", stock_low_2: "Fast ausverkauft — nur 2 Stück verfügbar", stock_low_3: "Fast ausverkauft — nur 3 Stück verfügbar", stock_low_4: "Fast ausverkauft — nur 4 Stück verfügbar",
  search_placeholder: "Produkte suchen …",
  cookie_msg: "Diese Website verwendet ausschliesslich technisch notwendige Cookies sowie – nach Einwilligung – anonyme Nutzungsstatistiken.",
  cookie_accept: "Akzeptieren", cookie_decline: "Nur notwendige",
  medical_disclaimer: "Unsere Produkte ersetzen keine professionelle medizinische Beratung.",
  payments_title: "Zahlungsinformationen",
  // Booking page
  booking_title: "Buchen Sie Ihren Termin", booking_eyebrow: "Terminbuchung",
  book_step_service: "Service", book_step_time: "Termin", book_step_info: "Angaben", book_step_done: "Fertig",
  book_cat_men: "Herren", book_cat_women: "Damen", book_cat_unisex: "Unisex", book_cat_kids: "Kinder & Jugend", book_cat_tattoo: "Tattoo",
  book_pick_length: "Länge wählen", book_next: "Weiter", book_back: "Zurück",
  book_pick_date: "Datum wählen", book_pick_time: "Uhrzeit wählen",
  book_no_slots: "An diesem Tag sind keine Termine verfügbar.",
  book_selected_service: "Gewählter Service", book_appointment_time: "Termin", book_price: "Preis",
  book_your_info: "Ihre Angaben", book_cancel_policy: "Stornierungsbedingungen",
  book_full_name: "Vollständiger Name", book_phone_num: "Telefon",
  book_submit_booking: "Termin verbindlich buchen", book_booking_processing: "Wird gebucht…",
  book_booking_confirmed: "Termin bestätigt", book_email_confirmation: "Wir haben Ihnen eine Bestätigung per E-Mail gesendet.",
  book_appointment_nr: "Termin-Nr.", book_datetime: "Zeitpunkt",
  book_tattoo_title: "Tattoo-Anfrage", book_tattoo_no_price: "Kein fester Preis. Beschreiben Sie Ihr Wunschmotiv – wir kontaktieren Sie für Preis und Termin.",
  book_size: "Grösse", book_colors: "Farben", book_lines: "Linien", book_description: "Beschreibung",
  book_preferred_time: "Wunschtermin (optional)",
  book_send_request: "Anfrage senden", book_sending: "Wird gesendet…",
  book_request_sent: "Anfrage gesendet", book_will_contact: "Wir kontaktieren Sie in Kürze für Preis und Termin.",
  book_termin_agreement: "Termin nach Vereinbarung",
  book_status_free: "Verfügbar", book_status_booked: "Belegt", book_status_pending: "In Bearbeitung",
  book_status_blocked: "Gesperrt", book_status_mine: "Ihr Termin", book_status_needs_conf: "Wartet Bestätigung",
  book_state_free_hover: "🟢 Verfügbar — jetzt buchbar", book_state_booked_hover: "🔴 Belegt — bereits gebucht",
  book_state_blocked_hover: "⚫ Nicht verfügbar — geschlossen oder gesperrt",
  book_state_pending_hover: "🟡 In Bearbeitung — Buchung läuft",
  book_state_mine_hover: "🔵 Ihr Termin",
  book_state_needs_conf_hover: "🟠 Wartet auf Bestätigung",
  book_state_too_soon_hover: "⚫ Zu früh — mind. 30 Minuten Vorlaufzeit",
  book_size_small: "Klein (bis 10 cm)", book_size_medium: "Mittel (10–20 cm)", book_size_large: "Gross (über 20 cm)",
  book_placeholder_colors: "Farben (z.B. Schwarz, Farbig …)", book_placeholder_lines: "Linien (z.B. fein, kräftig …)",
  book_placeholder_desc: "Beschreibung des Motivs …",
  book_policy_free_6h: "Kostenfreie Stornierung bis 6 Stunden vor dem Coiffeur-Termin (Tattoo: 24 Stunden).",
  book_policy_late_fee: "Bei späterer Stornierung fallen 50 % des Preises als Ausfallgebühr an.",
  book_policy_within_6h: "Termine innerhalb der nächsten 6 Stunden können nicht mehr storniert werden.",
  book_policy_5min: "Bei Verspätung von mehr als 5 Minuten ohne vorherige telefonische Ankündigung wird die Ausfallgebühr (50 %) fällig. Wenn Sie uns vor Ablauf der 5 Minuten anrufen, kann der Termin ohne Zusatzkosten verlängert werden.",
  book_price_on_request: "Preis auf Anfrage", book_price_from: "ab",
  book_error_booking: "Fehler bei der Buchung", book_error_generic: "Fehler",
  cat_bartpflege: "Bartpflege", cat_haarpflege: "Haarpflege", cat_sets_bundles: "Sets & Bundles",
};

const overrides = {
  fr: {
    about_address: "Kirchweg 20, 8750 Glaris, Suisse",
    about_founder: "Fondateur : Sajjad Al-Daghir",
    about_intro: "Une marque suisse à Glaris – style et qualité depuis 2011.",
    about_philosophy_body: "Nous croyons que les produits naturels sont bien plus que des produits – ils créent un lien entre les personnes, la nature et un savoir traditionnel.\n\nNotre mission : sélectionner soigneusement des produits naturels, huiles, savons, henné, encens, parfums et soins traditionnels pour des clients exigeants.\n\nNous nous engageons pour des ingrédients choisis, une information produit honnête et une expérience d'achat fondée sur la confiance.",
    about_philosophy_title: "Notre philosophie",
    about_title: "Coiffeur Tattoo 01&Co.",
    about_values_title: "Naturel. Authentique. Choisi avec soin.",
    add_to_cart: "Ajouter au panier",
    address_label: "Adresse",
    admin_analytics: "Analytique",
    admin_avg: "Ø Valeur commande",
    admin_consultations: "Demandes de consultation",
    admin_customers: "Clients",
    admin_discounts: "Réductions",
    admin_orders: "Commandes",
    admin_products: "Produits",
    admin_questions: "Questions",
    admin_revenue: "Chiffre d'affaires",
    admin_reviews: "Avis",
    admin_title: "Tableau admin",
    admin_total_orders: "Total des commandes",
    answer_placeholder: "Répondre…",
    aria_account: "Compte",
    aria_basra: "Assistant Basra",
    aria_cart: "Panier",
    aria_close: "Fermer",
    aria_loading: "Chargement…",
    aria_logo_home: "Coiffeur Tattoo 01&Co. Page d'accueil",
    aria_menu: "Menu",
    aria_remove: "Supprimer",
    aria_send: "Envoyer",
    aria_wishlist: "Liste de souhaits",
    ask_placeholder: "Votre question…",
    ask_question: "Poser une question",
    auth_error: "Erreur lors de la connexion.",
    auth_or: "ou",
    benefits: "Avantages",
    bestseller_badge: "Best-seller",
    book_add: "Ajouter",
    book_added_to_cart: "Ajouté à la réservation",
    book_appointment_nr: "N° de rendez-vous",
    book_appointment_time: "Rendez-vous",
    book_autofilled: "Rempli automatiquement",
    book_back: "Retour",
    book_booking_confirmed: "Rendez-vous confirmé",
    book_booking_processing: "Réservation en cours…",
    book_cancel_policy: "Conditions d'annulation",
    book_cart_empty: "Aucune prestation sélectionnée pour le moment.",
    book_cat_kids: "Enfants & Adolescents",
    book_cat_men: "Hommes",
    book_cat_tattoo: "Tattoo",
    book_cat_unisex: "Unisexe",
    book_cat_women: "Femmes",
    book_colors: "Couleurs",
    book_customer_eyebrow: "Vos coordonnées",
    book_customer_hint: "À remplir une seule fois — lors de votre prochaine visite, vos données seront automatiquement reprises.",
    book_datetime: "Date et heure",
    book_deposit_note_body: "L'acompte sera retenu conformément à notre politique d'annulation et de retard : en cas d'annulation moins de 24 heures avant le rendez-vous, pour les réservations le jour même, en cas d'absence ou de retard de plus de 5 minutes sans notification téléphonique préalable. En cas d'annulation dans les délais (≥ 24 h), l'acompte sera intégralement remboursé.",
    book_deposit_note_title: "Note importante concernant l'acompte (50%)",
    book_deposit_required: "Un acompte en ligne est requis pour les prestations. Continuer vers Stripe…",
    book_description: "Description",
    book_edit: "Modifier",
    book_email_confirmation: "Nous vous avons envoyé une confirmation par e-mail.",
    book_error_booking: "Erreur lors de la réservation",
    book_error_generic: "Erreur",
    book_fill_required: "Veuillez remplir tous les champs obligatoires.",
    book_full_name: "Nom complet",
    book_lines: "Lignes",
    book_loading_details: "Chargement des détails…",
    book_login_hint: "Conseil : Connectez-vous pour que nous puissions reprendre automatiquement vos données la prochaine fois.",
    book_multi_hint: "Sélectionnez autant de prestations que vous le souhaitez dans chaque catégorie. Vous définirez la date et l'heure à l'étape suivante.",
    book_next: "Suivant",
    book_no_slots: "Aucun créneau disponible ce jour-là.",
    book_payment_breakdown: "Détail du paiement",
    book_phone_num: "Téléphone",
    book_pick_date: "Choisir la date",
    book_pick_length: "Choisir la longueur",
    book_pick_time: "Choisir l'heure",
    book_placeholder_colors: "Couleurs (p.ex. Noir, Couleurs …)",
    book_placeholder_desc: "Description du motif …",
    book_placeholder_lines: "Lignes (par ex. fines, épaisses…)",
    book_policy_5min: "En cas de retard de plus de 5 minutes sans avoir prévenu par téléphone, les frais d'annulation (50 %) sont dus. Si vous appelez avant les 5 minutes, le rendez-vous peut être prolongé sans frais.",
    book_policy_free_6h: "Annulation gratuite jusqu'à 6 heures avant le rendez-vous coiffure (tatouage : 24 heures).",
    book_policy_late_fee: "En cas d'annulation plus tardive, 50 % du prix sont facturés.",
    book_policy_within_6h: "Les rendez-vous des 6 prochaines heures ne peuvent plus être annulés.",
    book_preferred_time: "Créneau souhaité (facultatif)",
    book_price: "Prix",
    book_price_from: "dès",
    book_price_on_request: "Prix sur demande",
    book_remove: "Supprimer",
    book_request_sent: "Demande envoyée",
    book_reservation: "Réservation",
    book_review_add_product: "Ajouter un produit",
    book_review_add_service: "Autre prestation",
    book_review_continue_pay: "Continuer vers le paiement",
    book_review_continue_schedule: "Continuer vers le choix du rendez-vous",
    book_review_deposit_now: "Acompte maintenant",
    book_review_due_now: "Montant total maintenant",
    book_review_eyebrow: "Récapitulatif de réservation",
    book_review_products_total: "Total produits",
    book_review_question: "Souhaitez-vous ajouter une autre prestation ou un produit, ou passer directement au choix du rendez-vous ?",
    book_review_rest_at_salon: "Solde au salon",
    book_review_services_total: "Total prestations",
    book_review_split_note: "Pour les prestations, vous payez maintenant 50 % d'acompte, le solde confortablement au salon. Les produits sont payés intégralement en ligne.",
    book_review_summary: "Récapitulatif",
    book_review_title: "Presque terminé — ajouter quelque chose ?",
    book_review_your_products: "Vos produits",
    book_review_your_services: "Vos prestations",
    book_schedule_hint: "Durée totale :",
    book_selected_service: "Service choisi",
    book_send_request: "Envoyer la demande",
    book_sending: "Envoi en cours…",
    book_size: "Taille",
    book_size_large: "Grand (plus de 20 cm)",
    book_size_medium: "Moyen (10–20 cm)",
    book_size_small: "Petit (jusqu'à 10 cm)",
    book_state_blocked_hover: "⚫ Indisponible — fermé ou bloqué",
    book_state_booked_hover: "🔴 Occupé — déjà réservé",
    book_state_free_hover: "🟢 Libre — réservable",
    book_state_mine_hover: "🔵 Votre rendez-vous",
    book_state_needs_conf_hover: "🟠 En attente de confirmation",
    book_state_pending_hover: "🟡 En cours — réservation en cours",
    book_state_too_soon_hover: "⚫ Trop tôt — délai minimum 30 min",
    book_status_blocked: "Bloqué",
    book_status_booked: "Occupé",
    book_status_free: "Libre",
    book_status_mine: "Votre rendez-vous",
    book_status_needs_conf: "En attente de confirmation",
    book_status_pending: "En cours de traitement",
    book_step_done: "Terminé",
    book_step_info: "Informations",
    book_step_service: "Service",
    book_step_time: "Rendez-vous",
    book_submit_booking: "Confirmer le rendez-vous",
    book_tattoo_no_price: "Pas de prix fixe. Décrivez votre motif souhaité – nous vous contacterons pour le prix et le rendez-vous.",
    book_tattoo_title: "Demande de tatouage",
    book_termin_agreement: "Sur rendez-vous",
    book_visit_hint: "Nous nous réjouissons de votre visite. Le solde est à régler au salon.",
    book_will_contact: "Nous vous contacterons sous peu pour le prix et le rendez-vous.",
    book_your_cart: "Votre sélection",
    book_your_info: "Vos coordonnées",
    book_your_visit: "Votre visite",
    booking_eyebrow: "Réservation de rendez-vous",
    booking_title: "Réservez votre rendez-vous",
    brand_tagline: "Coiffure & Beauté depuis 2011",
    buy_now: "Acheter maintenant",
    cart_added: "Ajouté",
    cart_apply: "Appliquer",
    cart_checkout: "Commander",
    cart_continue: "Continuer les achats",
    cart_discount: "Réduction",
    cart_discount_applied: "Réduction appliquée",
    cart_discount_code: "Code de réduction",
    cart_discount_invalid: "Code de réduction invalide",
    cart_empty: "Votre panier est vide.",
    cart_remove: "Retirer",
    cart_shipping: "Livraison",
    cart_subtotal: "Sous-total",
    cart_tax_note: "TVA calculée lors du paiement",
    cart_title: "Panier",
    cart_total: "Total",
    cat_miswak: "Miswak",
    change_password: "Modifier le mot de passe",
    channel_email: "E-mail",
    channel_phone: "Téléphone",
    channel_whatsapp: "WhatsApp",
    checkout_address: "Rue & no.",
    checkout_apartment: "Appartement / Étage (optionnel)",
    checkout_billing: "Adresse de facturation",
    checkout_billing_same: "Adresse de facturation identique",
    checkout_city: "Ville",
    checkout_contact: "Contact",
    checkout_country: "Pays",
    checkout_email: "E-mail",
    checkout_first_name: "Prénom",
    checkout_hold_expired_action: "Choisir un nouveau rendez-vous",
    checkout_hold_expired_body: "Le rendez-vous a été libéré et pourrait avoir été réservé entre-temps par quelqu'un d'autre. Veuillez sélectionner un nouveau créneau.",
    checkout_hold_expired_title: "Votre réservation a expiré",
    checkout_hold_expiring: "La réservation expire bientôt",
    checkout_hold_hint: "Votre rendez-vous sélectionné est réservé pour vous. Veuillez finaliser le paiement avant l'expiration.",
    checkout_hold_title: "Votre réservation",
    checkout_last_name: "Nom",
    checkout_name: "Nom complet",
    checkout_notes: "Notes de commande (facultatif)",
    checkout_pay_in_store: "Payer sur place au salon",
    checkout_pay_in_store_deposit_hint: "Un acompte en ligne est requis pour les rendez-vous. Le solde sera réglé au salon.",
    checkout_pay_in_store_hint: "Réservez maintenant, payez en espèces ou par carte lors du retrait au salon (Kirchweg 20, Glarus).",
    checkout_pay_online: "Payer en ligne",
    checkout_pay_online_hint: "Carte, TWINT, Apple Pay, Klarna – en toute sécurité via Stripe.",
    checkout_payment: "Paiement",
    checkout_phone: "Téléphone (facultatif)",
    checkout_place_order: "Continuer au paiement",
    checkout_postal: "Code postal",
    checkout_return_pledge_label: "Je m'engage à ne pas ouvrir ni utiliser le produit si je souhaite le retourner.",
    checkout_return_pledge_required: "Veuillez confirmer l'engagement de retour pour continuer.",
    checkout_return_policy_body: "Conformément à notre politique de vente, un produit ouvert ou utilisé ne peut pas être retourné.",
    checkout_return_policy_title: "Droit de retour — veuillez lire",
    checkout_review: "Vérification",
    checkout_secure_note: "Paiement Stripe sécurisé.",
    checkout_shipping: "Adresse de livraison",
    checkout_street: "Rue et numéro",
    checkout_title: "Commande",
    consultation_intro: "Nous vous conseillons volontiers.",
    consultation_msg: "Votre question / demande",
    consultation_preferred: "Contact préféré",
    consultation_preferred_time: "Rendez-vous souhaité",
    consultation_subject: "Sujet",
    consultation_submit: "Envoyer",
    consultation_thanks: "Merci – nous vous contacterons sous peu.",
    consultation_title: "Demande de consultation",
    contact_address: "Adresse",
    contact_email: "E-mail",
    contact_form_title: "Écrivez-nous",
    contact_hours: "Heures d'ouverture",
    contact_message: "Votre message",
    contact_phone: "Téléphone",
    contact_send: "Envoyer le message",
    contact_thanks: "Merci – nous revenons vers vous.",
    contact_title: "Contact",
    cookie_accept: "Accepter",
    cookie_decline: "Nécessaires uniquement",
    cookie_msg: "Ce site utilise des cookies techniques et, avec votre consentement, des statistiques anonymes.",
    copyright: "Tous droits réservés.",
    current_password: "Mot de passe actuel",
    delete_account: "Supprimer le compte",
    delete_confirm: "Voulez-vous vraiment supprimer le compte de manière irréversible ?",
    email: "E-mail",
    footer_agb: "CGV",
    footer_brand: "Marque",
    footer_cookies: "Cookies",
    footer_datenschutz: "Confidentialité",
    footer_faq: "FAQ",
    footer_help: "Aide",
    footer_impressum: "Mentions légales",
    footer_legal: "Mentions légales",
    footer_returns: "Retours",
    footer_shipping: "Livraison",
    footer_shop: "Boutique",
    forgot_password: "Mot de passe oublié ?",
    founder_label: "Fondateur",
    free_shipping_over: "Livraison offerte dès 100 CHF",
    hero_cta: "Découvrir la collection",
    hero_secondary: "Notre histoire",
    hero_subtitle: "Produits premium, huiles naturelles, savon d'Alep, miswak, henné et plus – sélectionnés par Coiffeur Tattoo 01&Co. à Glaris.",
    hero_title: "Savoir-faire suisse. Soins naturels.",
    home_studio_alt: "Studio Coiffeur Tattoo 01&Co. à Glarus",
    ingredients: "Ingrédients",
    login: "Connexion",
    login_with_google: "Se connecter avec Google",
    logout: "Se déconnecter",
    medical_disclaimer: "Nos produits ne remplacent pas un avis médical.",
    missing_token_error: "Jeton manquant.",
    my_orders: "Mes commandes",
    my_profile: "Mon profil",
    nav_about: "À propos",
    nav_account: "Compte",
    nav_admin: "Admin",
    nav_cart: "Panier",
    nav_consultation: "Consultation",
    nav_contact: "Contact",
    nav_home: "Accueil",
    nav_shop: "Boutique",
    nav_tracking: "Suivi commande",
    nav_wishlist: "Liste de souhaits",
    new_badge: "Nouveau",
    new_password: "Nouveau mot de passe",
    newsletter_desc: "Nouveautés et offres exclusives.",
    newsletter_label: "Newsletter",
    newsletter_placeholder: "Votre e-mail",
    newsletter_submit: "S'abonner",
    newsletter_title: "Restez inspiré.",
    no_questions: "Aucune question pour le moment.",
    no_reviews: "Aucun avis pour le moment.",
    order_number: "N° de commande",
    order_status_cancelled: "Annulée",
    order_status_delivered: "Livrée",
    order_status_paid: "Payée",
    order_status_pending: "En attente",
    order_status_processing: "En cours de traitement",
    order_status_refunded: "Remboursée",
    order_status_shipped: "Expédiée",
    order_tracking_email: "Adresse e-mail",
    order_tracking_intro: "Entrez votre n° et e-mail.",
    order_tracking_not_found: "Commande introuvable.",
    order_tracking_number: "N° de commande",
    order_tracking_submit: "Suivre",
    order_tracking_title: "Suivi de commande",
    otp_expires_hint: "Le code est valable 10 minutes. Vérifiez éventuellement votre dossier spam.",
    otp_heading: "Saisissez votre code",
    otp_invalid: "Code incorrect. Veuillez réessayer.",
    otp_resend: "Renvoyer le code",
    otp_resent: "Un nouveau code a été envoyé.",
    otp_sent: "Nous vous avons envoyé un code par e-mail.",
    otp_sent_to: "Nous avons envoyé un code à 6 chiffres à :",
    otp_title: "Confirmation par e-mail",
    otp_verified: "E-mail confirmé — bienvenue !",
    otp_verify: "Confirmer",
    out_of_stock: "Épuisé",
    password: "Mot de passe",
    payment_cancel: "Paiement annulé",
    payment_cancel_msg: "Paiement annulé, vous pouvez réessayer.",
    payment_success: "Paiement réussi",
    payment_success_msg: "Merci pour votre commande !",
    payments_title: "Informations de paiement",
    phone_label: "Téléphone",
    price: "Prix",
    qa_disclaimer: "Les avis sont des expériences personnelles et ne remplacent pas un avis médical.",
    qa_login_required: "Connectez-vous pour poser une question.",
    quantity: "Quantité",
    question_pending: "Votre question est en modération.",
    questions_title: "Questions & Réponses",
    reason_natural: "Ingrédients naturels",
    reason_natural_desc: "Nous sélectionnons chaque huile avec soin.",
    reason_secure: "Paiement sécurisé",
    reason_secure_desc: "Crypté avec Stripe.",
    reason_shipping: "Livraison mondiale",
    reason_shipping_desc: "Livraison gratuite dès CHF 100.",
    reason_swiss: "Marque suisse",
    reason_swiss_desc: "Fondé à Glarus – un savoir-faire que l'on ressent.",
    register: "S'inscrire",
    related_products: "Produits similaires",
    report_content: "Signaler",
    reset_link_sent: "Si un compte existe, un lien a été créé.",
    reset_password: "Réinitialiser le mot de passe",
    reset_success: "Mot de passe réinitialisé.",
    ret_created: "Votre demande de retour a été créée.",
    ret_error: "La demande n'a pas pu être créée.",
    ret_existing_hint: "Nous vous contacterons avec les prochaines étapes.",
    ret_existing_title: "Statut de retour",
    ret_info_inspected: "Vérifié le",
    ret_info_order: "Numéro de commande",
    ret_info_products: "Produits retournés",
    ret_info_products_all: "Commande complète",
    ret_info_received: "Reçu le",
    ret_info_refunded: "Remboursé le",
    ret_info_requested: "Demandé le",
    ret_inspection_failed_hint: "Après vérification, nous ne pouvons malheureusement pas accepter votre retour. Veuillez nous contacter pour toute question.",
    ret_modal_intro: "Pour qu'un produit soit éligible au retour, il ne doit avoir été ni ouvert ni utilisé.",
    ret_modal_title: "Retourner un produit",
    ret_only_delivered: "Retour disponible une fois la commande livrée.",
    ret_pledge_label: "Je confirme que le produit n'a pas été ouvert ni utilisé et que je le retourne dans l'état dans lequel je l'ai reçu.",
    ret_pledge_required: "Veuillez confirmer l'engagement de retour.",
    ret_reason_changed_mind: "J'ai changé d'avis",
    ret_reason_damaged: "Le produit est endommagé",
    ret_reason_group_customer: "Raison personnelle",
    ret_reason_group_product: "Problème avec le produit ou la commande",
    ret_reason_no_longer_needed: "Je n'en ai plus besoin",
    ret_reason_order_error: "Erreur dans la commande",
    ret_reason_other: "Autre raison",
    ret_reason_other_issue: "Un autre problème avec le produit",
    ret_reason_placeholder: "Veuillez décrire la raison…",
    ret_reason_shipping_damage: "Il est arrivé endommagé",
    ret_reason_wrong_choice: "J'ai choisi le mauvais produit par erreur",
    ret_reason_wrong_item: "Le produit livré ne correspond pas à la commande",
    ret_refund_amount: "Montant du remboursement",
    ret_refund_bank_note: "Le délai d'affichage du montant sur votre compte dépend de votre banque ou de votre émetteur de carte et peut prendre plusieurs jours ouvrables.",
    ret_refund_issue_body: "Le remboursement n'a pas encore pu être finalisé et est en cours de traitement. Vous n'avez rien à faire — pour toute question, contactez-nous à info@01co.ch.",
    ret_refund_status_failed: "Remboursement en cours de traitement",
    ret_refund_status_processing: "Remboursement en cours",
    ret_refund_status_succeeded: "Remboursement effectué",
    ret_request_btn: "Demander un retour",
    ret_resolution_free: "Retour gratuit · Frais d'expédition pris en charge par le salon",
    ret_resolution_paid: "Retour payé par le client · Frais d'expédition à votre charge",
    ret_rma_code: "Code RMA",
    ret_status_approved: "Retour approuvé",
    ret_status_rejected: "Retour refusé",
    ret_status_requested: "Retour demandé",
    ret_status_under_review: "En cours d'examen",
    ret_step_inspected: "Produit vérifié",
    ret_step_received: "Retour reçu",
    ret_step_refund_complete: "Remboursement finalisé",
    ret_step_refund_initiated: "Remboursement initié",
    ret_step_refund_issue: "Remboursement — problème",
    ret_step_rejected: "Retour refusé",
    ret_step_requested: "Retour demandé",
    ret_submit: "Envoyer la demande",
    review_body: "Votre expérience",
    review_pending: "Votre avis a été soumis et sera examiné.",
    review_rating: "Note",
    review_title: "Titre",
    reviews: "Avis",
    sale_badge: "Soldes",
    save: "Enregistrer",
    saved: "Enregistré",
    search_placeholder: "Rechercher…",
    section_bestsellers: "Meilleures ventes",
    section_featured: "En vedette",
    section_new: "Nouveautés",
    section_oils: "Huiles naturelles",
    section_why_title: "Pourquoi Coiffeur Tattoo 01&Co.",
    since_2011: "Depuis 2011",
    size: "Taille",
    stock_in: "En stock",
    stock_low: "Peu disponible",
    stock_low_1: "Presque épuisé — 1 seule pièce disponible",
    stock_low_2: "Presque épuisé — 2 pièces disponibles",
    stock_low_3: "Presque épuisé — 3 pièces disponibles",
    stock_low_4: "Presque épuisé — 4 pièces disponibles",
    stock_out: "Épuisé",
    stock_setup: "Actuellement indisponible",
    submit_answer: "Envoyer la réponse",
    submit_question: "Envoyer la question",
    submit_review: "Soumettre l'avis",
    suitable_bart: "Barbe",
    suitable_for: "Convient pour",
    suitable_gesicht: "Visage",
    suitable_haare: "Cheveux",
    suitable_haut: "Peau",
    suitable_koerper: "Corps",
    time_remaining_label: "Temps restant",
    tracking_carrier: "Service de livraison",
    tracking_link: "Suivre chez le prestataire",
    tracking_number: "N° de suivi",
    usage: "Utilisation",
    variant: "Variante",
    verified_purchase: "Achat vérifié",
    view_all: "Tout voir",
    view_details: "Voir les détails",
    warnings: "Avertissements",
    welcome: "Bienvenue",
    wishlist_add: "Ajouter aux favoris",
    wishlist_empty: "Votre liste de souhaits est vide.",
    wishlist_login: "Connectez-vous pour utiliser les favoris.",
    wishlist_remove: "Retirer de la liste de souhaits",
    wishlist_title: "Favoris",
    write_review: "Écrire un avis",
      cat_bartpflege: "Soin de la barbe",
    cat_haarpflege: "Soin des cheveux",
    cat_sets_bundles: "Coffrets & Ensembles",
},
  it: {
    about_address: "Kirchweg 20, 8750 Glarona, Svizzera",
    about_founder: "Fondatore: Sajjad Al-Daghir",
    about_intro: "Un marchio svizzero a Glarona – stile e qualità dal 2011.",
    about_philosophy_body: "Crediamo che i prodotti naturali siano più di semplici prodotti – sono un legame tra persone, natura e sapere tradizionale.",
    about_philosophy_title: "La nostra filosofia",
    about_title: "Coiffeur Tattoo 01&Co.",
    about_values_title: "Naturale. Autentico. Scelto con cura.",
    add_to_cart: "Aggiungi al carrello",
    address_label: "Indirizzo",
    admin_analytics: "Analisi",
    admin_avg: "Ø Valore ordine",
    admin_consultations: "Richieste di consulenza",
    admin_customers: "Clienti",
    admin_discounts: "Sconti",
    admin_orders: "Ordini",
    admin_products: "Prodotti",
    admin_questions: "Domande",
    admin_revenue: "Fatturato",
    admin_reviews: "Recensioni",
    admin_title: "Dashboard admin",
    admin_total_orders: "Ordini totali",
    answer_placeholder: "Rispondi…",
    aria_account: "Account",
    aria_basra: "Assistente Basra",
    aria_cart: "Carrello",
    aria_close: "Chiudi",
    aria_loading: "Caricamento…",
    aria_logo_home: "Coiffeur Tattoo 01&Co. Home",
    aria_menu: "Menu",
    aria_remove: "Rimuovi",
    aria_send: "Invia",
    aria_wishlist: "Lista desideri",
    ask_placeholder: "La sua domanda …",
    ask_question: "Fai una domanda",
    auth_error: "Errore durante l'accesso.",
    auth_or: "oppure",
    benefits: "Vantaggi",
    bestseller_badge: "Bestseller",
    book_add: "Aggiungi",
    book_added_to_cart: "Aggiunto alla prenotazione",
    book_appointment_nr: "N° appuntamento",
    book_appointment_time: "Appuntamento",
    book_autofilled: "Compilato automaticamente",
    book_back: "Indietro",
    book_booking_confirmed: "Appuntamento confermato",
    book_booking_processing: "Prenotazione in corso…",
    book_cancel_policy: "Condizioni di cancellazione",
    book_cart_empty: "Nessun servizio selezionato.",
    book_cat_kids: "Bambini & Ragazzi",
    book_cat_men: "Uomo",
    book_cat_tattoo: "Tattoo",
    book_cat_unisex: "Unisex",
    book_cat_women: "Donna",
    book_colors: "Colori",
    book_customer_eyebrow: "I tuoi dati",
    book_customer_hint: "Compila una sola volta — alla prossima visita i tuoi dati saranno automaticamente disponibili.",
    book_datetime: "Data e ora",
    book_deposit_note_body: "L'acconto sarà trattenuto secondo la nostra politica di cancellazione e ritardo: in caso di cancellazione con meno di 24 ore di anticipo, per prenotazioni in giornata, in caso di mancata presentazione o di ritardo superiore a 5 minuti senza preavviso telefonico. In caso di cancellazione tempestiva (≥ 24 h) l'acconto sarà interamente rimborsato.",
    book_deposit_note_title: "Nota importante sull'acconto (50%)",
    book_deposit_required: "Per i servizi è richiesto un acconto online. Prosegui con Stripe …",
    book_description: "Descrizione",
    book_edit: "Modifica",
    book_email_confirmation: "Le abbiamo inviato una conferma via e-mail.",
    book_error_booking: "Errore nella prenotazione",
    book_error_generic: "Errore",
    book_fill_required: "Completa tutti i campi obbligatori.",
    book_full_name: "Nome completo",
    book_lines: "Linee",
    book_loading_details: "Caricamento dettagli …",
    book_login_hint: "Suggerimento: accedi per consentirci di compilare automaticamente i tuoi dati la prossima volta.",
    book_multi_hint: "Scegli tutti i servizi che desideri da ogni categoria. Data e orario li sceglierai al prossimo passaggio.",
    book_next: "Avanti",
    book_no_slots: "Nessun orario disponibile questo giorno.",
    book_payment_breakdown: "Riepilogo pagamento",
    book_phone_num: "Telefono",
    book_pick_date: "Scegli la data",
    book_pick_length: "Scegli la lunghezza",
    book_pick_time: "Scegli l'orario",
    book_placeholder_colors: "Colori (es. nero, colori …)",
    book_placeholder_desc: "Descrizione del motivo …",
    book_placeholder_lines: "Linee (es. sottili, spesse …)",
    book_policy_5min: "In caso di ritardo superiore a 5 minuti senza preavviso telefonico, viene addebitata la penale (50 %). Se ci chiami prima dei 5 minuti, l'appuntamento può essere prolungato senza costi aggiuntivi.",
    book_policy_free_6h: "Cancellazione gratuita fino a 6 ore prima dell'appuntamento parrucchiere (tatuaggio: 24 ore).",
    book_policy_late_fee: "In caso di cancellazione tardiva viene addebitato il 50 % come penale.",
    book_policy_within_6h: "Gli appuntamenti nelle prossime 6 ore non possono più essere cancellati.",
    book_preferred_time: "Orario preferito (opzionale)",
    book_price: "Prezzo",
    book_price_from: "da",
    book_price_on_request: "Prezzo su richiesta",
    book_remove: "Rimuovi",
    book_request_sent: "Richiesta inviata",
    book_reservation: "Prenotazione",
    book_review_add_product: "Aggiungi prodotto",
    book_review_add_service: "Altro servizio",
    book_review_continue_pay: "Procedi al pagamento",
    book_review_continue_schedule: "Scegli data e ora",
    book_review_deposit_now: "Acconto ora",
    book_review_due_now: "Totale ora",
    book_review_eyebrow: "Riepilogo prenotazione",
    book_review_products_total: "Totale prodotti",
    book_review_question: "Desideri aggiungere un altro servizio o un prodotto, oppure procedere alla scelta dell'appuntamento?",
    book_review_rest_at_salon: "Saldo presso il salone",
    book_review_services_total: "Totale servizi",
    book_review_split_note: "Per i servizi paghi ora il 50% come acconto, il resto comodamente in salone. I prodotti vengono pagati interamente online.",
    book_review_summary: "Riepilogo",
    book_review_title: "Quasi fatto — vuoi aggiungere altro?",
    book_review_your_products: "I tuoi prodotti",
    book_review_your_services: "I tuoi servizi",
    book_schedule_hint: "Durata totale:",
    book_selected_service: "Servizio scelto",
    book_send_request: "Invia richiesta",
    book_sending: "Invio in corso…",
    book_size: "Dimensione",
    book_size_large: "Grande (oltre 20 cm)",
    book_size_medium: "Medio (10–20 cm)",
    book_size_small: "Piccolo (fino a 10 cm)",
    book_state_blocked_hover: "⚫ Non disponibile — chiuso o bloccato",
    book_state_booked_hover: "🔴 Occupato — già prenotato",
    book_state_free_hover: "🟢 Libero — prenotabile ora",
    book_state_mine_hover: "🔵 Il tuo appuntamento",
    book_state_needs_conf_hover: "🟠 In attesa di conferma",
    book_state_pending_hover: "🟡 In corso — prenotazione in corso",
    book_state_too_soon_hover: "⚫ Troppo presto — minimo 30 min di anticipo",
    book_status_blocked: "Bloccato",
    book_status_booked: "Occupato",
    book_status_free: "Libero",
    book_status_mine: "Il suo appuntamento",
    book_status_needs_conf: "In attesa di conferma",
    book_status_pending: "In elaborazione",
    book_step_done: "Completato",
    book_step_info: "Informazioni",
    book_step_service: "Servizio",
    book_step_time: "Appuntamento",
    book_submit_booking: "Conferma prenotazione",
    book_tattoo_no_price: "Nessun prezzo fisso. Descrivete il vostro motivo desiderato – vi contatteremo per prezzo e appuntamento.",
    book_tattoo_title: "Richiesta tatuaggio",
    book_termin_agreement: "Su appuntamento",
    book_visit_hint: "Ti aspettiamo. Il saldo è da versare in salone.",
    book_will_contact: "Vi contatteremo a breve per prezzo e appuntamento.",
    book_your_cart: "La tua selezione",
    book_your_info: "I tuoi dati",
    book_your_visit: "La tua visita",
    booking_eyebrow: "Prenotazione appuntamento",
    booking_title: "Prenota il tuo appuntamento",
    brand_tagline: "Parrucchiere & Beauty dal 2011",
    buy_now: "Acquista ora",
    cart_added: "Aggiunto",
    cart_apply: "Applica",
    cart_checkout: "Vai al pagamento",
    cart_continue: "Continua lo shopping",
    cart_discount: "Sconto",
    cart_discount_applied: "Sconto applicato",
    cart_discount_code: "Codice sconto",
    cart_discount_invalid: "Codice sconto non valido",
    cart_empty: "Il vostro carrello è vuoto.",
    cart_remove: "Rimuovi",
    cart_shipping: "Spedizione",
    cart_subtotal: "Subtotale",
    cart_tax_note: "IVA calcolata al checkout",
    cart_title: "Carrello",
    cart_total: "Totale",
    cat_miswak: "Miswak",
    change_password: "Cambia password",
    channel_email: "E-mail",
    channel_phone: "Telefono",
    channel_whatsapp: "WhatsApp",
    checkout_address: "Via & n.",
    checkout_apartment: "Appartamento / Piano (opzionale)",
    checkout_billing: "Indirizzo di fatturazione",
    checkout_billing_same: "Fatturazione uguale a consegna",
    checkout_city: "Città",
    checkout_contact: "Contatto",
    checkout_country: "Paese",
    checkout_email: "E-mail",
    checkout_first_name: "Nome",
    checkout_hold_expired_action: "Scegli un nuovo appuntamento",
    checkout_hold_expired_body: "L'appuntamento è stato rilasciato e potrebbe essere stato nel frattempo scelto da qualcun altro. Scegli un nuovo orario.",
    checkout_hold_expired_title: "La tua prenotazione è scaduta",
    checkout_hold_expiring: "Prenotazione in scadenza",
    checkout_hold_hint: "L'appuntamento scelto è riservato per te. Completa il pagamento prima della scadenza.",
    checkout_hold_title: "La tua prenotazione",
    checkout_last_name: "Cognome",
    checkout_name: "Nome completo",
    checkout_notes: "Note ordine (opzionale)",
    checkout_pay_in_store: "Paga in salone",
    checkout_pay_in_store_deposit_hint: "Per gli appuntamenti è richiesto un acconto online. Il saldo sarà versato in salone.",
    checkout_pay_in_store_hint: "Prenota ora, paga in contanti o con carta al ritiro in salone (Kirchweg 20, Glarus).",
    checkout_pay_online: "Paga online",
    checkout_pay_online_hint: "Carta, TWINT, Apple Pay, Klarna – in sicurezza tramite Stripe.",
    checkout_payment: "Pagamento",
    checkout_phone: "Telefono (opzionale)",
    checkout_place_order: "Procedi al pagamento",
    checkout_postal: "CAP",
    checkout_return_pledge_label: "Mi impegno a non aprire e non utilizzare il prodotto se desidero restituirlo.",
    checkout_return_pledge_required: "Conferma l'impegno per il reso per procedere.",
    checkout_return_policy_body: "Secondo le nostre condizioni di vendita, un prodotto aperto o utilizzato non può essere restituito.",
    checkout_return_policy_title: "Diritto di reso — da leggere",
    checkout_review: "Verifica",
    checkout_secure_note: "Pagamento Stripe sicuro.",
    checkout_shipping: "Indirizzo di consegna",
    checkout_street: "Via e numero civico",
    checkout_title: "Cassa",
    consultation_intro: "Ti consigliamo volentieri.",
    consultation_msg: "La vostra domanda / richiesta",
    consultation_preferred: "Contatto preferito",
    consultation_preferred_time: "Appuntamento preferito",
    consultation_subject: "Argomento",
    consultation_submit: "Invia richiesta",
    consultation_thanks: "Grazie – vi contatteremo a breve.",
    consultation_title: "Richiedi consulenza",
    contact_address: "Indirizzo",
    contact_email: "E-mail",
    contact_form_title: "Scrivici",
    contact_hours: "Orari di apertura",
    contact_message: "Il tuo messaggio",
    contact_phone: "Telefono",
    contact_send: "Invia messaggio",
    contact_thanks: "Grazie – ti risponderemo presto.",
    contact_title: "Contatti",
    cookie_accept: "Accetta",
    cookie_decline: "Solo necessari",
    cookie_msg: "Questo sito usa cookie tecnici e, con il consenso, statistiche anonime.",
    copyright: "Tutti i diritti riservati.",
    current_password: "Password attuale",
    delete_account: "Elimina account",
    delete_confirm: "Eliminare definitivamente l'account?",
    email: "E-mail",
    footer_agb: "CGV",
    footer_brand: "Marca",
    footer_cookies: "Cookies",
    footer_datenschutz: "Privacy",
    footer_faq: "FAQ",
    footer_help: "Aiuto",
    footer_impressum: "Colophon",
    footer_legal: "Note legali",
    footer_returns: "Resi",
    footer_shipping: "Spedizione",
    footer_shop: "Negozio",
    forgot_password: "Password dimenticata?",
    founder_label: "Fondatore",
    free_shipping_over: "Spedizione gratuita da CHF 100",
    hero_cta: "Scopri la collezione",
    hero_secondary: "La nostra storia",
    hero_subtitle: "Prodotti premium, oli naturali, sapone di Aleppo, miswak, hennè e altro – da Coiffeur Tattoo 01&Co. a Glarona.",
    hero_title: "Artigianato svizzero. Cura naturale.",
    home_studio_alt: "Studio Coiffeur Tattoo 01&Co. a Glarus",
    ingredients: "Ingredienti",
    login: "Accedi",
    login_with_google: "Accedi con Google",
    logout: "Esci",
    medical_disclaimer: "I nostri prodotti non sostituiscono un consulto medico.",
    missing_token_error: "Token mancante.",
    my_orders: "I miei ordini",
    my_profile: "Il mio profilo",
    nav_about: "Chi siamo",
    nav_account: "Account",
    nav_admin: "Admin",
    nav_cart: "Carrello",
    nav_consultation: "Consulenza",
    nav_contact: "Contatto",
    nav_home: "Home",
    nav_shop: "Shop",
    nav_tracking: "Tracciamento",
    nav_wishlist: "Lista desideri",
    new_badge: "Nuovo",
    new_password: "Nuova password",
    newsletter_desc: "Novità e offerte esclusive.",
    newsletter_label: "Newsletter",
    newsletter_placeholder: "La tua e-mail",
    newsletter_submit: "Iscriviti",
    newsletter_title: "Resta ispirato.",
    no_questions: "Nessuna domanda ancora.",
    no_reviews: "Ancora nessuna recensione.",
    order_number: "N° ordine",
    order_status_cancelled: "Annullato",
    order_status_delivered: "Consegnato",
    order_status_paid: "Pagato",
    order_status_pending: "In attesa",
    order_status_processing: "In elaborazione",
    order_status_refunded: "Rimborsato",
    order_status_shipped: "Spedito",
    order_tracking_email: "Indirizzo e-mail",
    order_tracking_intro: "Inserisci n° ordine e e-mail.",
    order_tracking_not_found: "Ordine non trovato.",
    order_tracking_number: "N° ordine",
    order_tracking_submit: "Traccia",
    order_tracking_title: "Traccia ordine",
    otp_expires_hint: "Il codice è valido per 10 minuti. Controlla eventualmente la cartella spam.",
    otp_heading: "Inserisci il tuo codice",
    otp_invalid: "Codice errato. Riprova.",
    otp_resend: "Invia nuovamente il codice",
    otp_resent: "Nuovo codice inviato.",
    otp_sent: "Ti abbiamo inviato un codice via email.",
    otp_sent_to: "Abbiamo inviato un codice a 6 cifre a:",
    otp_title: "Conferma email",
    otp_verified: "Email confermata — benvenuto!",
    otp_verify: "Conferma",
    out_of_stock: "Esaurito",
    password: "Password",
    payment_cancel: "Pagamento annullato",
    payment_cancel_msg: "Pagamento annullato. Riprova.",
    payment_success: "Pagamento riuscito",
    payment_success_msg: "Grazie per l'ordine!",
    payments_title: "Informazioni di pagamento",
    phone_label: "Telefono",
    price: "Prezzo",
    qa_disclaimer: "Le opinioni sono esperienze personali e non sostituiscono un parere medico.",
    qa_login_required: "Accedi per fare o rispondere.",
    quantity: "Quantità",
    question_pending: "La tua domanda è in revisione.",
    questions_title: "Domande & Risposte",
    reason_natural: "Ingredienti naturali",
    reason_natural_desc: "Selezioniamo ogni olio con cura.",
    reason_secure: "Pagamento sicuro",
    reason_secure_desc: "Crittografia sicura con Stripe.",
    reason_shipping: "Spedizione mondiale",
    reason_shipping_desc: "Spedizione gratuita da CHF 100.",
    reason_swiss: "Marchio svizzero",
    reason_swiss_desc: "Fondato a Glarus – artigianalità che si sente.",
    register: "Registrati",
    related_products: "Prodotti simili",
    report_content: "Segnala",
    reset_link_sent: "Se esiste un account, un link è stato creato.",
    reset_password: "Reimposta password",
    reset_success: "Password reimpostata.",
    ret_created: "La tua richiesta di reso è stata creata.",
    ret_error: "Impossibile creare la richiesta.",
    ret_existing_hint: "Ti contatteremo con i prossimi passaggi.",
    ret_existing_title: "Stato del reso",
    ret_info_inspected: "Verificato il",
    ret_info_order: "Numero d'ordine",
    ret_info_products: "Prodotti restituiti",
    ret_info_products_all: "Ordine completo",
    ret_info_received: "Ricevuto il",
    ret_info_refunded: "Rimborsato il",
    ret_info_requested: "Richiesto il",
    ret_inspection_failed_hint: "Dopo la verifica non abbiamo potuto accettare il tuo reso. Contattaci per qualsiasi domanda.",
    ret_modal_intro: "Perché il prodotto possa essere restituito, non deve essere stato aperto né utilizzato.",
    ret_modal_title: "Restituisci prodotto",
    ret_only_delivered: "Reso disponibile dopo la consegna dell'ordine.",
    ret_pledge_label: "Confermo che il prodotto non è stato aperto né utilizzato e che lo restituisco nello stato in cui l'ho ricevuto.",
    ret_pledge_required: "Conferma l'impegno per il reso.",
    ret_reason_changed_mind: "Ho cambiato idea",
    ret_reason_damaged: "Il prodotto è danneggiato",
    ret_reason_group_customer: "Motivo personale",
    ret_reason_group_product: "Problema con il prodotto o l'ordine",
    ret_reason_no_longer_needed: "Non ne ho più bisogno",
    ret_reason_order_error: "Errore nell'ordine",
    ret_reason_other: "Altro motivo",
    ret_reason_other_issue: "Un altro problema con il prodotto",
    ret_reason_placeholder: "Descrivi il motivo…",
    ret_reason_shipping_damage: "È arrivato danneggiato",
    ret_reason_wrong_choice: "Ho scelto per errore il prodotto sbagliato",
    ret_reason_wrong_item: "Il prodotto consegnato non corrisponde all'ordine",
    ret_refund_amount: "Importo del rimborso",
    ret_refund_bank_note: "Il tempo necessario affinché l'importo sia visibile sul tuo conto dipende dalla tua banca o dal fornitore della carta e può richiedere diversi giorni lavorativi.",
    ret_refund_issue_body: "Il rimborso non è ancora stato completato ed è in elaborazione. Non è necessaria alcuna azione da parte tua — per domande contattaci a info@01co.ch.",
    ret_refund_status_failed: "Rimborso ancora in elaborazione",
    ret_refund_status_processing: "Rimborso in elaborazione",
    ret_refund_status_succeeded: "Rimborso eseguito",
    ret_request_btn: "Richiedi reso",
    ret_resolution_free: "Reso gratuito · Spedizione a carico del salone",
    ret_resolution_paid: "Reso a carico del cliente · Spedizione a tue spese",
    ret_rma_code: "Codice RMA",
    ret_status_approved: "Reso approvato",
    ret_status_rejected: "Reso rifiutato",
    ret_status_requested: "Reso richiesto",
    ret_status_under_review: "In verifica",
    ret_step_inspected: "Prodotto verificato",
    ret_step_received: "Reso ricevuto",
    ret_step_refund_complete: "Rimborso completato",
    ret_step_refund_initiated: "Rimborso avviato",
    ret_step_refund_issue: "Rimborso — problema",
    ret_step_rejected: "Reso rifiutato",
    ret_step_requested: "Reso richiesto",
    ret_submit: "Invia richiesta",
    review_body: "La tua esperienza",
    review_pending: "La tua recensione è stata inviata ed è in fase di verifica.",
    review_rating: "Valutazione",
    review_title: "Titolo",
    reviews: "Recensioni",
    sale_badge: "Saldi",
    save: "Salva",
    saved: "Salvato",
    search_placeholder: "Cerca prodotti…",
    section_bestsellers: "Bestseller",
    section_featured: "In evidenza",
    section_new: "Novità",
    section_oils: "Oli naturali",
    section_why_title: "Perché Coiffeur Tattoo 01&Co.",
    since_2011: "Dal 2011",
    size: "Taglia",
    stock_in: "Disponibile",
    stock_low: "Pochi disponibili",
    stock_low_1: "Quasi esaurito — solo 1 pezzo disponibile",
    stock_low_2: "Quasi esaurito — solo 2 pezzi disponibili",
    stock_low_3: "Quasi esaurito — solo 3 pezzi disponibili",
    stock_low_4: "Quasi esaurito — solo 4 pezzi disponibili",
    stock_out: "Esaurito",
    stock_setup: "Attualmente non disponibile",
    submit_answer: "Invia risposta",
    submit_question: "Invia domanda",
    submit_review: "Invia recensione",
    suitable_bart: "Barba",
    suitable_for: "Adatto a",
    suitable_gesicht: "Viso",
    suitable_haare: "Capelli",
    suitable_haut: "Pelle",
    suitable_koerper: "Corpo",
    time_remaining_label: "Tempo rimanente",
    tracking_carrier: "Corriere",
    tracking_link: "Traccia con il corriere",
    tracking_number: "N° tracciamento",
    usage: "Utilizzo",
    variant: "Variante",
    verified_purchase: "Acquisto verificato",
    view_all: "Vedi tutto",
    view_details: "Vedi dettagli",
    warnings: "Avvertenze",
    welcome: "Benvenuto",
    wishlist_add: "Aggiungi ai preferiti",
    wishlist_empty: "La tua lista dei desideri è vuota.",
    wishlist_login: "Accedi per usare i preferiti.",
    wishlist_remove: "Rimuovi dalla lista dei desideri",
    wishlist_title: "Preferiti",
    write_review: "Scrivi una recensione",
      cat_bartpflege: "Cura della barba",
    cat_haarpflege: "Cura dei capelli",
    cat_sets_bundles: "Set & Confezioni",
},
  en: {
    about_address: "Kirchweg 20, 8750 Glarus, Switzerland",
    about_founder: "Founder: Sajjad Al-Daghir",
    about_intro: "A Swiss brand from Glarus – style and quality since 2011.",
    about_philosophy_body: "We believe natural products are more than products – they are a connection between people, nature and traditional knowledge.\n\nOur goal is to bring carefully selected natural products, oils, soaps, henna, incense, fragrances and traditional personal-care products to customers who value quality, authenticity and conscious choices.\n\nWe focus on carefully selected ingredients, honest product information and a shopping experience built around trust.",
    about_philosophy_title: "Our philosophy",
    about_title: "Coiffeur Tattoo 01&Co.",
    about_values_title: "Natural. Authentic. Carefully selected.",
    add_to_cart: "Add to cart",
    address_label: "Address",
    admin_analytics: "Analytics",
    admin_avg: "Ø Order Value",
    admin_consultations: "Consultation Requests",
    admin_customers: "Customers",
    admin_discounts: "Discounts",
    admin_orders: "Orders",
    admin_products: "Products",
    admin_questions: "Questions",
    admin_revenue: "Revenue",
    admin_reviews: "Reviews",
    admin_title: "Admin Dashboard",
    admin_total_orders: "Total Orders",
    answer_placeholder: "Answer…",
    aria_account: "Account",
    aria_basra: "Basra Assistant",
    aria_cart: "Cart",
    aria_close: "Close",
    aria_loading: "Loading…",
    aria_logo_home: "Coiffeur Tattoo 01&Co. Home",
    aria_menu: "Menu",
    aria_remove: "Remove",
    aria_send: "Send",
    aria_wishlist: "Wishlist",
    ask_placeholder: "Your question …",
    ask_question: "Ask a question",
    benefits: "Benefits",
    bestseller_badge: "Bestseller",
    book_appointment_nr: "Appointment no.",
    book_appointment_time: "Appointment",
    book_back: "Back",
    book_booking_confirmed: "Appointment confirmed",
    book_booking_processing: "Booking…",
    book_cancel_policy: "Cancellation Policy",
    book_cat_kids: "Kids & Youth",
    book_cat_men: "Men",
    book_cat_tattoo: "Tattoo",
    book_cat_unisex: "Unisex",
    book_cat_women: "Women",
    book_colors: "Colors",
    book_datetime: "Date & Time",
    book_description: "Description",
    book_email_confirmation: "We have sent you a confirmation email.",
    book_error_booking: "Booking failed",
    book_error_generic: "Error",
    book_full_name: "Full name",
    book_lines: "Lines",
    book_next: "Next",
    book_no_slots: "No slots available on this day.",
    book_phone_num: "Phone",
    book_pick_date: "Pick a date",
    book_pick_length: "Choose length",
    book_pick_time: "Select Time",
    book_placeholder_colors: "Colours (e.g. black, coloured …)",
    book_placeholder_desc: "Motif description …",
    book_placeholder_lines: "Lines (e.g. fine, bold …)",
    book_policy_5min: "A no-show fee (50%) applies if you arrive more than 5 minutes late without calling ahead. If you call before the 5 minutes elapse, the appointment can be extended at no extra cost.",
    book_policy_free_6h: "Free cancellation up to 6 hours before your haircut appointment (tattoo: 24 hours).",
    book_policy_late_fee: "Later cancellations incur a 50% fee.",
    book_policy_within_6h: "Appointments within the next 6 hours can no longer be cancelled.",
    book_preferred_time: "Preferred time (optional)",
    book_price: "Price",
    book_price_from: "from",
    book_price_on_request: "Price on request",
    book_request_sent: "Request sent",
    book_selected_service: "Chosen service",
    book_send_request: "Send request",
    book_sending: "Sending…",
    book_size: "Size",
    book_size_large: "Large (over 20 cm)",
    book_size_medium: "Medium (10–20 cm)",
    book_size_small: "Small (up to 10 cm)",
    book_state_blocked_hover: "⚫ Unavailable — closed or blocked",
    book_state_booked_hover: "🔴 Unavailable — already booked",
    book_state_free_hover: "🟢 Free — book now",
    book_state_mine_hover: "🔵 Your appointment",
    book_state_needs_conf_hover: "🟠 Awaiting confirmation",
    book_state_pending_hover: "🟡 In progress — booking underway",
    book_state_too_soon_hover: "⚫ Too soon — minimum 30 min lead time",
    book_status_blocked: "Blocked",
    book_status_booked: "Booked",
    book_status_free: "Free",
    book_status_mine: "Your Appointment",
    book_status_needs_conf: "Awaiting Confirmation",
    book_status_pending: "Processing",
    book_step_done: "Done",
    book_step_info: "Details",
    book_step_service: "Service",
    book_step_time: "Appointment",
    book_submit_booking: "Confirm booking",
    book_tattoo_no_price: "No fixed price. Describe your desired design – we'll contact you regarding price and appointment.",
    book_tattoo_title: "Tattoo enquiry",
    book_termin_agreement: "By appointment",
    book_will_contact: "We'll contact you shortly regarding price and appointment.",
    book_your_info: "Your details",
    booking_eyebrow: "Appointment Booking",
    booking_title: "Book your appointment",
    brand_tagline: "Hair & Beauty since 2011",
    buy_now: "Buy Now",
    cart_added: "Added",
    cart_apply: "Apply",
    cart_checkout: "Checkout",
    cart_continue: "Continue Shopping",
    cart_discount: "Discount",
    cart_discount_applied: "Discount applied",
    cart_discount_code: "Discount Code",
    cart_discount_invalid: "Discount code invalid",
    cart_empty: "Your cart is empty.",
    cart_remove: "Remove",
    cart_shipping: "Shipping",
    cart_subtotal: "Subtotal",
    cart_tax_note: "VAT calculated at checkout",
    cart_title: "Cart",
    cart_total: "Total",
    cat_henna: "Henna",
    cat_miswak: "Miswak",
    change_password: "Change Password",
    channel_email: "Email",
    channel_phone: "Phone",
    channel_whatsapp: "WhatsApp",
    checkout_address: "Street & no.",
    checkout_billing: "Billing Address",
    checkout_billing_same: "Billing same as shipping",
    checkout_city: "City",
    checkout_contact: "Contact",
    checkout_country: "Country",
    checkout_email: "Email",
    checkout_name: "Full Name",
    checkout_notes: "Order Notes (optional)",
    checkout_payment: "Payment",
    checkout_phone: "Phone (optional)",
    checkout_place_order: "Continue to payment",
    checkout_postal: "Postal Code",
    checkout_review: "Review",
    checkout_secure_note: "Secure Stripe checkout.",
    checkout_shipping: "Delivery Address",
    checkout_title: "Checkout",
    consultation_intro: "We're happy to advise you.",
    consultation_msg: "Your Question / Inquiry",
    consultation_preferred: "Preferred contact",
    consultation_preferred_time: "Preferred Appointment",
    consultation_subject: "Subject",
    consultation_submit: "Send request",
    consultation_thanks: "Thank you – we'll contact you shortly.",
    consultation_title: "Request a consultation",
    contact_address: "Address",
    contact_email: "Email",
    contact_form_title: "Write to us",
    contact_hours: "Opening Hours",
    contact_message: "Your message",
    contact_phone: "Phone",
    contact_send: "Send Message",
    contact_thanks: "Thanks – we'll be in touch.",
    contact_title: "Contact",
    cookie_accept: "Accept",
    cookie_decline: "Essential Only",
    cookie_msg: "This site uses only technical cookies and – with your consent – anonymous usage statistics.",
    copyright: "All rights reserved.",
    current_password: "Current Password",
    delete_account: "Delete account",
    delete_confirm: "Really delete account permanently?",
    email: "Email",
    footer_agb: "Terms & Conditions",
    footer_brand: "Brand",
    footer_cookies: "Cookies",
    footer_datenschutz: "Privacy",
    footer_faq: "FAQ",
    footer_help: "Help",
    footer_impressum: "Imprint",
    footer_legal: "Legal",
    footer_returns: "Returns",
    footer_shipping: "Shipping",
    footer_shop: "Shop",
    forgot_password: "Forgot password?",
    founder_label: "Founder",
    free_shipping_over: "Free shipping over CHF 100",
    hero_cta: "Explore collection",
    hero_secondary: "Our Story",
    hero_subtitle: "Premium hair, beard and skin care, natural oils, Aleppo soap, miswak, henna and more – curated by the Coiffeur Tattoo 01&Co. team in Glarus.",
    hero_title: "Swiss craft. Natural care.",
    home_studio_alt: "Coiffeur Tattoo 01&Co. Studio in Glarus",
    ingredients: "Ingredients",
    login: "Login",
    logout: "Sign Out",
    medical_disclaimer: "Our products do not replace professional medical advice.",
    missing_token_error: "Token missing.",
    my_orders: "My orders",
    my_profile: "My Profile",
    nav_about: "About Us",
    nav_account: "Account",
    nav_admin: "Admin",
    nav_cart: "Cart",
    nav_consultation: "Consultation",
    nav_contact: "Contact",
    nav_home: "Home",
    nav_shop: "Shop",
    nav_tracking: "Order tracking",
    nav_wishlist: "Wishlist",
    new_badge: "New",
    new_password: "New password",
    newsletter_desc: "New products, care tips and exclusive offers.",
    newsletter_label: "Newsletter",
    newsletter_placeholder: "Your email",
    newsletter_submit: "Subscribe",
    newsletter_title: "Stay inspired.",
    no_questions: "No questions yet. Be the first to ask.",
    no_reviews: "No reviews yet.",
    order_number: "Order number",
    order_status_cancelled: "Cancelled",
    order_status_delivered: "Delivered",
    order_status_paid: "Paid",
    order_status_pending: "Pending",
    order_status_processing: "Processing",
    order_status_refunded: "Refunded",
    order_status_shipped: "Shipped",
    order_tracking_email: "Email Address",
    order_tracking_intro: "Enter your order number and email.",
    order_tracking_not_found: "Order not found.",
    order_tracking_number: "Order number",
    order_tracking_submit: "Track",
    order_tracking_title: "Order tracking",
    out_of_stock: "Out of Stock",
    password: "Password",
    payment_cancel: "Payment Cancelled",
    payment_cancel_msg: "Your payment was cancelled. You can try again.",
    payment_success: "Payment successful",
    payment_success_msg: "Thank you for your order!",
    payments_title: "Payment information",
    phone_label: "Phone",
    price: "Price",
    qa_disclaimer: "Customer opinions are personal experiences and are not professional medical advice.",
    qa_login_required: "Please log in to ask or answer.",
    quantity: "Quantity",
    question_pending: "Your question has been submitted and is being reviewed.",
    questions_title: "Questions & Answers",
    reason_natural: "Natural ingredients",
    reason_natural_desc: "We select each oil with care.",
    reason_secure: "Secure payment",
    reason_secure_desc: "Encrypted with Stripe.",
    reason_shipping: "Worldwide shipping",
    reason_shipping_desc: "Free shipping over CHF 100.",
    reason_swiss: "Swiss brand",
    reason_swiss_desc: "Founded in Glarus – craftsmanship you can feel.",
    register: "Register",
    related_products: "Related Products",
    report_content: "Report",
    reset_link_sent: "If an account exists, a reset link has been created.",
    reset_password: "Reset Password",
    reset_success: "Password reset successful.",
    review_body: "Your Experience",
    review_pending: "Your review has been submitted and is under review.",
    review_rating: "Rating",
    review_title: "Title",
    reviews: "Reviews",
    sale_badge: "Sale",
    save: "Save",
    saved: "Saved",
    search_placeholder: "Search products…",
    section_bestsellers: "Bestsellers",
    section_featured: "Featured",
    section_new: "New Arrivals",
    section_oils: "Natural oils",
    section_why_title: "Why Coiffeur Tattoo 01&Co.",
    since_2011: "Since 2011",
    size: "Size",
    stock_in: "In stock",
    stock_low: "Low stock",
    stock_low_1: "Almost sold out — only 1 piece available",
    stock_low_2: "Almost sold out — only 2 pieces available",
    stock_low_3: "Almost sold out — only 3 pieces available",
    stock_low_4: "Almost sold out — only 4 pieces available",
    stock_out: "Sold out",
    stock_setup: "Currently unavailable",
    submit_answer: "Submit answer",
    submit_question: "Submit question",
    submit_review: "Submit review",
    suitable_bart: "Beard",
    suitable_for: "Suitable for",
    suitable_gesicht: "Face",
    suitable_haare: "Hair",
    suitable_haut: "Skin",
    suitable_koerper: "Body",
    time_remaining_label: "Time Remaining",
    tracking_carrier: "Shipping carrier",
    tracking_link: "Track with carrier",
    tracking_number: "Tracking no.",
    usage: "Application",
    variant: "Variant",
    verified_purchase: "Verified purchase",
    view_all: "View all",
    view_details: "View details",
    warnings: "Warnings",
    wishlist_add: "Add to wishlist",
    wishlist_empty: "Your wishlist is empty.",
    wishlist_login: "Please log in to use the wishlist.",
    wishlist_remove: "Remove from wishlist",
    wishlist_title: "Wishlist",
    write_review: "Write a review",
      cat_bartpflege: "Beard Care",
    cat_haarpflege: "Hair Care",
    cat_sets_bundles: "Sets & Bundles",
},
  es: {
    about_address: "Kirchweg 20, 8750 Glarus, Suiza",
    about_founder: "Fundador: Sajjad Al-Daghir",
    about_intro: "Una marca suiza de Glarus – estilo y calidad desde 2011.",
    about_philosophy_body: "Creemos que los productos naturales son más que productos: son un puente entre personas, naturaleza y saber tradicional.",
    about_philosophy_title: "Nuestra filosofía",
    about_title: "Coiffeur Tattoo 01&Co.",
    about_values_title: "Natural. Auténtico. Seleccionado con cuidado.",
    add_to_cart: "Añadir al carrito",
    address_label: "Dirección",
    admin_analytics: "Analítica",
    admin_avg: "Ø Valor pedido",
    admin_consultations: "Solicitudes de consulta",
    admin_customers: "Clientes",
    admin_discounts: "Descuentos",
    admin_orders: "Pedidos",
    admin_products: "Productos",
    admin_questions: "Preguntas",
    admin_revenue: "Ingresos",
    admin_reviews: "Valoraciones",
    admin_title: "Panel admin",
    admin_total_orders: "Pedidos totales",
    answer_placeholder: "Responder…",
    aria_account: "Cuenta",
    aria_basra: "Asistente Basra",
    aria_cart: "Cesta",
    aria_close: "Cerrar",
    aria_loading: "Cargando…",
    aria_logo_home: "Página de inicio de Coiffeur Tattoo 01&Co.",
    aria_menu: "Menú",
    aria_remove: "Eliminar",
    aria_send: "Enviar",
    aria_wishlist: "Lista de deseos",
    ask_placeholder: "Su pregunta…",
    ask_question: "Hacer una pregunta",
    auth_error: "Error al iniciar sesión.",
    auth_or: "o",
    benefits: "Ventajas",
    bestseller_badge: "Más vendido",
    book_add: "Añadir",
    book_added_to_cart: "Añadido a la reserva",
    book_appointment_nr: "N° de cita",
    book_appointment_time: "Cita",
    book_autofilled: "Completado automáticamente",
    book_back: "Atrás",
    book_booking_confirmed: "Cita confirmada",
    book_booking_processing: "Reservando…",
    book_cancel_policy: "Condiciones de cancelación",
    book_cart_empty: "Aún no se han seleccionado servicios.",
    book_cat_kids: "Niños y Jóvenes",
    book_cat_men: "Hombres",
    book_cat_tattoo: "Tattoo",
    book_cat_unisex: "Unisex",
    book_cat_women: "Señoras",
    book_colors: "Colores",
    book_customer_eyebrow: "Tus datos",
    book_customer_hint: "Por favor, completa esta información una sola vez. En tu próxima visita, tus datos se completarán automáticamente.",
    book_datetime: "Fecha y hora",
    book_deposit_note_body: "El depósito se retendrá según nuestra política de cancelación y retrasos: en caso de cancelación con menos de 24 horas de antelación, reservas del mismo día, no presentación o retraso superior a 5 minutos sin aviso telefónico previo. En caso de cancelación con la debida antelación (≥ 24 h), el depósito se reembolsará íntegramente.",
    book_deposit_note_title: "Nota importante sobre el depósito (50%)",
    book_deposit_required: "Los servicios requieren un depósito online. Continuar a Stripe…",
    book_description: "Descripción",
    book_edit: "Modificar",
    book_email_confirmation: "Le hemos enviado una confirmación por correo electrónico.",
    book_error_booking: "Error en la reserva",
    book_error_generic: "Error",
    book_fill_required: "Por favor, completa todos los campos obligatorios.",
    book_full_name: "Nombre completo",
    book_lines: "Líneas",
    book_loading_details: "Cargando detalles…",
    book_login_hint: "Consejo: inicia sesión para que completemos automáticamente tus datos la próxima vez.",
    book_multi_hint: "Selecciona todos los servicios que desees de cada categoría. La fecha y hora se elegirán en el siguiente paso.",
    book_next: "Continuar",
    book_no_slots: "No hay horarios disponibles este día.",
    book_payment_breakdown: "Desglose de pago",
    book_phone_num: "Teléfono",
    book_pick_date: "Elegir fecha",
    book_pick_length: "Elegir longitud",
    book_pick_time: "Seleccionar hora",
    book_placeholder_colors: "Colores (p. ej. negro, colores …)",
    book_placeholder_desc: "Descripción del motivo …",
    book_placeholder_lines: "Líneas (p. ej. finas, gruesas…)",
    book_policy_5min: "Con más de 5 minutos de retraso sin aviso telefónico previo, se cobra la penalización (50 %). Si llamas antes de los 5 minutos, la cita puede prolongarse sin coste adicional.",
    book_policy_free_6h: "Cancelación gratuita hasta 6 horas antes de la cita de peluquería (tatuaje: 24 horas).",
    book_policy_late_fee: "En caso de cancelación posterior se cobra el 50 % como penalización.",
    book_policy_within_6h: "Las citas dentro de las próximas 6 horas ya no se pueden cancelar.",
    book_preferred_time: "Horario preferido (opcional)",
    book_price: "Precio",
    book_price_from: "desde",
    book_price_on_request: "Precio a consultar",
    book_remove: "Eliminar",
    book_request_sent: "Solicitud enviada",
    book_reservation: "Reserva",
    book_review_add_product: "Añadir producto",
    book_review_add_service: "Otro servicio",
    book_review_continue_pay: "Continuar al pago",
    book_review_continue_schedule: "Continuar a selección de cita",
    book_review_deposit_now: "Depósito ahora",
    book_review_due_now: "Importe total ahora",
    book_review_eyebrow: "Resumen de la reserva",
    book_review_products_total: "Total productos",
    book_review_question: "¿Deseas añadir otro servicio o producto, o continuar directamente a la selección de cita?",
    book_review_rest_at_salon: "Resto en el salón",
    book_review_services_total: "Total servicios",
    book_review_split_note: "Para los servicios, pagas ahora el 50 % como depósito y el resto cómodamente en el salón. Los productos se pagan íntegramente online.",
    book_review_summary: "Resumen",
    book_review_title: "Casi listo. ¿Deseas añadir algo más?",
    book_review_your_products: "Tus productos",
    book_review_your_services: "Tus servicios",
    book_schedule_hint: "Duración total:",
    book_selected_service: "Servicio elegido",
    book_send_request: "Enviar solicitud",
    book_sending: "Enviando…",
    book_size: "Tamaño",
    book_size_large: "Grande (más de 20 cm)",
    book_size_medium: "Mediano (10–20 cm)",
    book_size_small: "Pequeño (hasta 10 cm)",
    book_state_blocked_hover: "⚫ No disponible — cerrado o bloqueado",
    book_state_booked_hover: "🔴 Ocupado — ya reservado",
    book_state_free_hover: "🟢 Libre — reservable ahora",
    book_state_mine_hover: "🔵 Tu cita",
    book_state_needs_conf_hover: "🟠 A la espera de confirmación",
    book_state_pending_hover: "🟡 En curso — reserva en proceso",
    book_state_too_soon_hover: "⚫ Demasiado pronto — mínimo 30 min de antelación",
    book_status_blocked: "Bloqueado",
    book_status_booked: "Ocupado",
    book_status_free: "Libre",
    book_status_mine: "Su cita",
    book_status_needs_conf: "Pendiente de confirmación",
    book_status_pending: "En proceso",
    book_step_done: "Finalizado",
    book_step_info: "Información",
    book_step_service: "Servicio",
    book_step_time: "Cita",
    book_submit_booking: "Confirmar cita",
    book_tattoo_no_price: "Sin precio fijo. Describa el diseño que desea y le contactaremos para precio y cita.",
    book_tattoo_title: "Consulta de tatuaje",
    book_termin_agreement: "Con cita previa",
    book_visit_hint: "Te esperamos con ilusión. El resto del importe se abona en el salón.",
    book_will_contact: "Le contactaremos en breve para precio y cita.",
    book_your_cart: "Tu selección",
    book_your_info: "Tus datos",
    book_your_visit: "Tu visita",
    booking_eyebrow: "Reserva de cita",
    booking_title: "Reserva tu cita",
    brand_tagline: "Peluquería y Belleza desde 2011",
    buy_now: "Comprar ahora",
    cart_added: "Añadido",
    cart_apply: "Aplicar",
    cart_checkout: "Finalizar compra",
    cart_continue: "Seguir comprando",
    cart_discount: "Descuento",
    cart_discount_applied: "Descuento aplicado",
    cart_discount_code: "Código de descuento",
    cart_discount_invalid: "Código de descuento no válido",
    cart_empty: "Su cesta está vacía.",
    cart_remove: "Eliminar",
    cart_shipping: "Envío",
    cart_subtotal: "Subtotal",
    cart_tax_note: "IVA calculado al finalizar la compra",
    cart_title: "Carrito",
    cart_total: "Total",
    cat_henna: "Henna",
    cat_miswak: "Miswak",
    change_password: "Cambiar contraseña",
    channel_email: "E-mail",
    channel_phone: "Teléfono",
    channel_whatsapp: "WhatsApp",
    checkout_address: "Calle y n°",
    checkout_apartment: "Piso / Planta (opcional)",
    checkout_billing: "Dirección de facturación",
    checkout_billing_same: "Facturación igual que envío",
    checkout_city: "Ciudad",
    checkout_contact: "Contacto",
    checkout_country: "País",
    checkout_email: "E-mail",
    checkout_first_name: "Nombre",
    checkout_hold_expired_action: "Elegir nueva cita",
    checkout_hold_expired_body: "La cita ha sido liberada y podría haber sido seleccionada por otra persona. Por favor, elige un nuevo horario.",
    checkout_hold_expired_title: "Tu reserva ha caducado",
    checkout_hold_expiring: "La reserva está a punto de caducar",
    checkout_hold_hint: "Tu cita elegida está reservada para ti. Por favor, completa el pago antes de que expire.",
    checkout_hold_title: "Tu reserva",
    checkout_last_name: "Apellidos",
    checkout_name: "Nombre completo",
    checkout_notes: "Notas del pedido (opcional)",
    checkout_pay_in_store: "Pagar en el salón",
    checkout_pay_in_store_deposit_hint: "Las citas requieren un depósito online. El resto se abona en el salón.",
    checkout_pay_in_store_hint: "Reserva ahora, paga en efectivo o con tarjeta al recoger en el salón (Kirchweg 20, Glarus).",
    checkout_pay_online: "Pagar online",
    checkout_pay_online_hint: "Tarjeta, TWINT, Apple Pay, Klarna: seguro a través de Stripe.",
    checkout_payment: "Pago",
    checkout_phone: "Teléfono (opcional)",
    checkout_place_order: "Continuar al pago",
    checkout_postal: "Código postal",
    checkout_return_pledge_label: "Me comprometo a no abrir ni usar el producto si deseo devolverlo.",
    checkout_return_pledge_required: "Por favor, confirma el compromiso de devolución para continuar.",
    checkout_return_policy_body: "Según las normas de nuestra tienda, no se puede devolver un producto que haya sido abierto o usado.",
    checkout_return_policy_title: "Derecho de devolución: por favor, lee",
    checkout_review: "Revisión",
    checkout_secure_note: "Pago seguro con Stripe.",
    checkout_shipping: "Dirección de envío",
    checkout_street: "Calle y número",
    checkout_title: "Pago",
    consultation_intro: "Estaremos encantados de asesorarte.",
    consultation_msg: "Su consulta / solicitud",
    consultation_preferred: "Contacto preferido",
    consultation_preferred_time: "Cita preferida",
    consultation_subject: "Tema",
    consultation_submit: "Enviar solicitud",
    consultation_thanks: "Gracias. Le contactaremos en breve.",
    consultation_title: "Solicitar consulta",
    contact_address: "Dirección",
    contact_email: "Correo electrónico",
    contact_form_title: "Escríbenos",
    contact_hours: "Horario de apertura",
    contact_message: "Tu mensaje",
    contact_phone: "Teléfono",
    contact_send: "Enviar mensaje",
    contact_thanks: "Gracias – te contactaremos pronto.",
    contact_title: "Contacto",
    cookie_accept: "Aceptar",
    cookie_decline: "Solo necesarias",
    cookie_msg: "Este sitio usa cookies técnicas y, con tu consentimiento, estadísticas anónimas.",
    copyright: "Todos los derechos reservados.",
    current_password: "Contraseña actual",
    delete_account: "Eliminar cuenta",
    delete_confirm: "¿Confirma que desea eliminar su cuenta de forma permanente?",
    email: "Correo electrónico",
    footer_agb: "Términos y Condiciones",
    footer_brand: "Marca",
    footer_cookies: "Cookies",
    footer_datenschutz: "Privacidad",
    footer_faq: "Preguntas frecuentes",
    footer_help: "Ayuda",
    footer_impressum: "Aviso legal",
    footer_legal: "Legal",
    footer_returns: "Devoluciones",
    footer_shipping: "Envío",
    footer_shop: "Tienda",
    forgot_password: "¿Olvidaste tu contraseña?",
    founder_label: "Fundador",
    free_shipping_over: "Envío gratis desde CHF 100",
    hero_cta: "Ver colección",
    hero_secondary: "Nuestra historia",
    hero_subtitle: "Productos premium, aceites, jabón de Alepo, miswak, henna y más – de Coiffeur Tattoo 01&Co. en Glarus.",
    hero_title: "Artesanía suiza. Cuidado natural.",
    home_studio_alt: "Estudio Coiffeur Tattoo 01&Co. en Glarus",
    ingredients: "Ingredientes",
    login: "Iniciar sesión",
    login_with_google: "Iniciar sesión con Google",
    logout: "Cerrar sesión",
    medical_disclaimer: "Nuestros productos no sustituyen el consejo médico profesional.",
    missing_token_error: "Falta el token.",
    my_orders: "Mis pedidos",
    my_profile: "Mi perfil",
    nav_about: "Sobre nosotros",
    nav_account: "Cuenta",
    nav_admin: "Admin",
    nav_cart: "Carrito",
    nav_consultation: "Consultoría",
    nav_contact: "Contacto",
    nav_home: "Inicio",
    nav_shop: "Tienda",
    nav_tracking: "Seguimiento",
    nav_wishlist: "Lista de deseos",
    new_badge: "Nuevo",
    new_password: "Nueva contraseña",
    newsletter_desc: "Novedades y ofertas exclusivas.",
    newsletter_label: "Boletín",
    newsletter_placeholder: "Tu e-mail",
    newsletter_submit: "Suscribirse",
    newsletter_title: "Mantente inspirado.",
    no_questions: "Sin preguntas todavía.",
    no_reviews: "Aún no hay reseñas.",
    order_number: "N° de pedido",
    order_status_cancelled: "Cancelado",
    order_status_delivered: "Entregado",
    order_status_paid: "Pagado",
    order_status_pending: "Pendiente",
    order_status_processing: "En proceso",
    order_status_refunded: "Reembolsado",
    order_status_shipped: "Enviado",
    order_tracking_email: "Dirección de correo electrónico",
    order_tracking_intro: "Introduce tu n° y e-mail.",
    order_tracking_not_found: "Pedido no encontrado.",
    order_tracking_number: "N° de pedido",
    order_tracking_submit: "Seguir",
    order_tracking_title: "Seguimiento de pedido",
    otp_expires_hint: "El código es válido durante 10 minutos. Comprueba tu carpeta de spam si es necesario.",
    otp_heading: "Introduce tu código",
    otp_invalid: "Código incorrecto. Por favor, inténtalo de nuevo.",
    otp_resend: "Reenviar código",
    otp_resent: "Se ha enviado un nuevo código.",
    otp_sent: "Te hemos enviado un código por correo electrónico.",
    otp_sent_to: "Hemos enviado un código de 6 dígitos a:",
    otp_title: "Confirmación de correo electrónico",
    otp_verified: "Correo confirmado. ¡Bienvenido!",
    otp_verify: "Confirmar",
    out_of_stock: "Agotado",
    password: "Contraseña",
    payment_cancel: "Pago cancelado",
    payment_cancel_msg: "Pago cancelado. Puedes reintentar.",
    payment_success: "Pago exitoso",
    payment_success_msg: "¡Gracias por tu pedido!",
    payments_title: "Información de pago",
    phone_label: "Teléfono",
    price: "Precio",
    qa_disclaimer: "Las opiniones son experiencias personales y no son consejo médico.",
    qa_login_required: "Inicia sesión para preguntar.",
    quantity: "Cantidad",
    question_pending: "Tu pregunta está en revisión.",
    questions_title: "Preguntas y respuestas",
    reason_natural: "Ingredientes naturales",
    reason_natural_desc: "Seleccionamos cada aceite con cuidado.",
    reason_secure: "Pago seguro",
    reason_secure_desc: "Cifrado con Stripe.",
    reason_shipping: "Envío mundial",
    reason_shipping_desc: "Envío gratuito a partir de CHF 100.",
    reason_swiss: "Marca suiza",
    reason_swiss_desc: "Fundado en Glarus – artesanía que se siente.",
    register: "Registrarse",
    related_products: "Productos relacionados",
    report_content: "Reportar",
    reset_link_sent: "Si existe una cuenta, se ha creado un enlace.",
    reset_password: "Restablecer contraseña",
    reset_success: "Contraseña restablecida.",
    ret_created: "Tu solicitud de devolución ha sido creada.",
    ret_error: "No se ha podido crear la solicitud.",
    ret_existing_hint: "Nos pondremos en contacto contigo con los siguientes pasos.",
    ret_existing_title: "Estado de devolución",
    ret_info_inspected: "Revisado el",
    ret_info_order: "Número de pedido",
    ret_info_products: "Productos devueltos",
    ret_info_products_all: "Pedido completo",
    ret_info_received: "Recibido el",
    ret_info_refunded: "Reembolsado el",
    ret_info_requested: "Solicitado el",
    ret_inspection_failed_hint: "Tras la revisión, lamentablemente no hemos podido aceptar tu devolución. Por favor, contáctanos si tienes preguntas.",
    ret_modal_intro: "Para que tu producto pueda ser devuelto, no debe haber sido abierto ni usado.",
    ret_modal_title: "Devolver producto",
    ret_only_delivered: "Devolución disponible una vez que el pedido haya sido entregado.",
    ret_pledge_label: "Confirmo que el producto no ha sido abierto ni usado y que lo devuelvo en el mismo estado en que lo recibí.",
    ret_pledge_required: "Por favor, confirma el compromiso de devolución.",
    ret_reason_changed_mind: "He cambiado de opinión",
    ret_reason_damaged: "El producto está dañado",
    ret_reason_group_customer: "Motivo personal",
    ret_reason_group_product: "Problema con el producto o el pedido",
    ret_reason_no_longer_needed: "Ya no lo necesito",
    ret_reason_order_error: "Error en el pedido",
    ret_reason_other: "Otro motivo",
    ret_reason_other_issue: "Otro problema con el producto",
    ret_reason_placeholder: "Por favor, describe el motivo…",
    ret_reason_shipping_damage: "Llegó dañado",
    ret_reason_wrong_choice: "He elegido el producto equivocado por error",
    ret_reason_wrong_item: "El producto recibido no corresponde al pedido",
    ret_refund_amount: "Importe del reembolso",
    ret_refund_bank_note: "El tiempo en que el importe sea visible en tu cuenta depende de tu banco o proveedor de tarjeta y puede tardar varios días laborables.",
    ret_refund_issue_body: "El reembolso aún no se ha podido completar y sigue en proceso. No necesitas hacer nada. Si tienes preguntas, contáctanos en info@01co.ch.",
    ret_refund_status_failed: "Reembolso aún en proceso",
    ret_refund_status_processing: "Reembolso en proceso",
    ret_refund_status_succeeded: "Reembolso realizado",
    ret_request_btn: "Solicitar devolución",
    ret_resolution_free: "Devolución gratuita · Envío a cargo del salón",
    ret_resolution_paid: "Devolución pagada por el cliente · Envío a tu cargo",
    ret_rma_code: "Código RMA",
    ret_status_approved: "Devolución aprobada",
    ret_status_rejected: "Devolución rechazada",
    ret_status_requested: "Devolución solicitada",
    ret_status_under_review: "En revisión",
    ret_step_inspected: "Producto revisado",
    ret_step_received: "Devolución recibida",
    ret_step_refund_complete: "Reembolso completado",
    ret_step_refund_initiated: "Reembolso iniciado",
    ret_step_refund_issue: "Reembolso: problema",
    ret_step_rejected: "Devolución rechazada",
    ret_step_requested: "Devolución solicitada",
    ret_submit: "Enviar solicitud",
    review_body: "Su experiencia",
    review_pending: "Su valoración ha sido enviada y está siendo revisada.",
    review_rating: "Valoración",
    review_title: "Título",
    reviews: "Reseñas",
    sale_badge: "Oferta",
    save: "Guardar",
    saved: "Guardado",
    search_placeholder: "Buscar productos…",
    section_bestsellers: "Más vendidos",
    section_featured: "Destacados",
    section_new: "Novedades",
    section_oils: "Aceites naturales",
    section_why_title: "Por qué Coiffeur Tattoo 01&Co.",
    since_2011: "Desde 2011",
    size: "Talla",
    stock_in: "En stock",
    stock_low: "Pocas unidades disponibles",
    stock_low_1: "Casi agotado — solo 1 unidad disponible",
    stock_low_2: "Casi agotado — solo 2 unidades disponibles",
    stock_low_3: "Casi agotado — solo 3 unidades disponibles",
    stock_low_4: "Casi agotado — solo 4 unidades disponibles",
    stock_out: "Agotado",
    stock_setup: "No disponible actualmente",
    submit_answer: "Enviar respuesta",
    submit_question: "Enviar pregunta",
    submit_review: "Enviar valoración",
    suitable_bart: "Barba",
    suitable_for: "Apto para",
    suitable_gesicht: "Rostro",
    suitable_haare: "Cabello",
    suitable_haut: "Piel",
    suitable_koerper: "Cuerpo",
    time_remaining_label: "Tiempo restante",
    tracking_carrier: "Servicio de envío",
    tracking_link: "Seguimiento en proveedor",
    tracking_number: "N° seguimiento",
    usage: "Modo de empleo",
    variant: "Variante",
    verified_purchase: "Compra verificada",
    view_all: "Ver todo",
    view_details: "Ver detalles",
    warnings: "Advertencias",
    welcome: "Bienvenido",
    wishlist_add: "Añadir a favoritos",
    wishlist_empty: "Su lista de deseos está vacía.",
    wishlist_login: "Inicia sesión para usar favoritos.",
    wishlist_remove: "Eliminar de lista de deseos",
    wishlist_title: "Favoritos",
    write_review: "Escribir valoración",
      cat_bartpflege: "Cuidado de la barba",
    cat_haarpflege: "Cuidado del cabello",
    cat_sets_bundles: "Sets y Packs",
},
  pt: {
    about_address: "Kirchweg 20, 8750 Glarus, Suíça",
    about_founder: "Fundador: Sajjad Al-Daghir",
    about_intro: "Uma marca suíça de Glarus – estilo e qualidade desde 2011.",
    about_philosophy_body: "Acreditamos que os produtos naturais são mais do que produtos – são uma ligação entre pessoas, natureza e saber tradicional.",
    about_philosophy_title: "A nossa filosofia",
    about_title: "Coiffeur Tattoo 01&Co.",
    about_values_title: "Natural. Autêntico. Escolhido com cuidado.",
    add_to_cart: "Adicionar ao carrinho",
    address_label: "Endereço",
    admin_analytics: "Análise",
    admin_avg: "Ø Valor do pedido",
    admin_consultations: "Pedidos de consulta",
    admin_customers: "Clientes",
    admin_discounts: "Descontos",
    admin_orders: "Encomendas",
    admin_products: "Produtos",
    admin_questions: "Perguntas",
    admin_revenue: "Receita",
    admin_reviews: "Avaliações",
    admin_title: "Painel admin",
    admin_total_orders: "Encomendas totais",
    answer_placeholder: "Responder…",
    aria_account: "Conta",
    aria_basra: "Assistente Basra",
    aria_cart: "Carrinho",
    aria_close: "Fechar",
    aria_loading: "A carregar…",
    aria_logo_home: "Coiffeur Tattoo 01&Co. Página Inicial",
    aria_menu: "Menu",
    aria_remove: "Remover",
    aria_send: "Enviar",
    aria_wishlist: "Lista de Desejos",
    ask_placeholder: "A sua pergunta…",
    ask_question: "Fazer uma pergunta",
    auth_error: "Erro no início de sessão.",
    auth_or: "ou",
    benefits: "Vantagens",
    bestseller_badge: "Bestseller",
    book_add: "Adicionar",
    book_added_to_cart: "Adicionado à reserva",
    book_appointment_nr: "N.º de marcação",
    book_appointment_time: "Marcação",
    book_autofilled: "Preenchido automaticamente",
    book_back: "Voltar",
    book_booking_confirmed: "Marcação confirmada",
    book_booking_processing: "A marcar…",
    book_cancel_policy: "Condições de cancelamento",
    book_cart_empty: "Ainda não selecionou nenhum serviço.",
    book_cat_kids: "Crianças e jovens",
    book_cat_men: "Homens",
    book_cat_tattoo: "Tattoo",
    book_cat_unisex: "Unisexo",
    book_cat_women: "Senhoras",
    book_colors: "Cores",
    book_customer_eyebrow: "Os seus dados",
    book_customer_hint: "Por favor, preencha apenas uma vez — na próxima visita, os seus dados serão automaticamente preenchidos.",
    book_datetime: "Data e hora",
    book_deposit_note_body: "O depósito será retido de acordo com a nossa política de cancelamento e atrasos: em caso de cancelamento com menos de 24 horas de antecedência, reservas no mesmo dia, não comparência, ou atraso superior a 5 minutos sem aviso prévio por telefone. Em caso de cancelamento dentro do prazo (≥ 24 h), o depósito será totalmente reembolsado.",
    book_deposit_note_title: "Informação importante sobre o depósito (50%)",
    book_deposit_required: "É necessário um depósito online para os serviços. Continuar para Stripe …",
    book_description: "Descrição",
    book_edit: "Alterar",
    book_email_confirmation: "Enviámos uma confirmação por e-mail.",
    book_error_booking: "Erro na marcação",
    book_error_generic: "Erro",
    book_fill_required: "Por favor, preencha todos os campos obrigatórios.",
    book_full_name: "Nome completo",
    book_lines: "Linhas",
    book_loading_details: "A carregar detalhes …",
    book_login_hint: "Sugestão: Inicie sessão para que possamos preencher automaticamente os seus dados na próxima vez.",
    book_multi_hint: "Selecione quantos serviços desejar de cada categoria. A data e hora serão definidas no próximo passo.",
    book_next: "Continuar",
    book_no_slots: "Sem horários disponíveis neste dia.",
    book_payment_breakdown: "Resumo de pagamento",
    book_phone_num: "Telefone",
    book_pick_date: "Escolher data",
    book_pick_length: "Escolher comprimento",
    book_pick_time: "Escolher hora",
    book_placeholder_colors: "Cores (p. ex. preto, coloridas …)",
    book_placeholder_desc: "Descrição do motivo …",
    book_placeholder_lines: "Linhas (p. ex. finas, espessas…)",
    book_policy_5min: "Em caso de atraso superior a 5 minutos sem aviso telefónico prévio, é cobrada a taxa (50 %). Se ligar antes dos 5 minutos, o horário pode ser prolongado sem custos adicionais.",
    book_policy_free_6h: "Cancelamento gratuito até 6 horas antes do horário de cabeleireiro (tatuagem: 24 horas).",
    book_policy_late_fee: "Em caso de cancelamento tardio, é cobrada uma taxa de 50 %.",
    book_policy_within_6h: "As marcações nas próximas 6 horas já não podem ser canceladas.",
    book_preferred_time: "Horário preferido (opcional)",
    book_price: "Preço",
    book_price_from: "desde",
    book_price_on_request: "Preço sob consulta",
    book_remove: "Remover",
    book_request_sent: "Pedido enviado",
    book_reservation: "Reserva",
    book_review_add_product: "Adicionar produto",
    book_review_add_service: "Adicionar outro serviço",
    book_review_continue_pay: "Continuar para pagamento",
    book_review_continue_schedule: "Continuar para escolha de horário",
    book_review_deposit_now: "Depósito agora",
    book_review_due_now: "Montante total agora",
    book_review_eyebrow: "Resumo da reserva",
    book_review_products_total: "Total de produtos",
    book_review_question: "Deseja adicionar outro serviço ou produto, ou avançar diretamente para a escolha de horário?",
    book_review_rest_at_salon: "Restante no salão",
    book_review_services_total: "Total de serviços",
    book_review_split_note: "Para os serviços, paga agora 50 % como depósito e o restante comodamente no salão. Os produtos são pagos integralmente online.",
    book_review_summary: "Resumo",
    book_review_title: "Quase pronto — deseja adicionar mais algo?",
    book_review_your_products: "Os seus produtos",
    book_review_your_services: "Os seus serviços",
    book_schedule_hint: "Duração total:",
    book_selected_service: "Serviço escolhido",
    book_send_request: "Enviar pedido",
    book_sending: "A enviar…",
    book_size: "Tamanho",
    book_size_large: "Grande (mais de 20 cm)",
    book_size_medium: "Médio (10–20 cm)",
    book_size_small: "Pequeno (até 10 cm)",
    book_state_blocked_hover: "⚫ Indisponível — fechado ou bloqueado",
    book_state_booked_hover: "🔴 Ocupado — já marcado",
    book_state_free_hover: "🟢 Livre — reservável agora",
    book_state_mine_hover: "🔵 A sua marcação",
    book_state_needs_conf_hover: "🟠 A aguardar confirmação",
    book_state_pending_hover: "🟡 Em curso — reserva a decorrer",
    book_state_too_soon_hover: "⚫ Demasiado cedo — mínimo 30 min de antecedência",
    book_status_blocked: "Bloqueado",
    book_status_booked: "Ocupado",
    book_status_free: "Livre",
    book_status_mine: "A sua marcação",
    book_status_needs_conf: "Aguarda confirmação",
    book_status_pending: "Em processamento",
    book_step_done: "Concluído",
    book_step_info: "Dados",
    book_step_service: "Serviço",
    book_step_time: "Marcação",
    book_submit_booking: "Confirmar marcação",
    book_tattoo_no_price: "Sem preço fixo. Descreva o motivo desejado – entraremos em contacto para preço e marcação.",
    book_tattoo_title: "Pedido de tatuagem",
    book_termin_agreement: "Mediante marcação",
    book_visit_hint: "Aguardamos a sua visita. O montante restante será pago no salão.",
    book_will_contact: "Entraremos em contacto brevemente para preço e marcação.",
    book_your_cart: "A sua seleção",
    book_your_info: "Os seus dados",
    book_your_visit: "A sua visita",
    booking_eyebrow: "Marcação de Consulta",
    booking_title: "Reserve o seu horário",
    brand_tagline: "Cabelo & Beleza desde 2011",
    buy_now: "Comprar agora",
    cart_added: "Adicionado",
    cart_apply: "Aplicar",
    cart_checkout: "Finalizar compra",
    cart_continue: "Continuar a comprar",
    cart_discount: "Desconto",
    cart_discount_applied: "Desconto aplicado",
    cart_discount_code: "Código de desconto",
    cart_discount_invalid: "Código de desconto inválido",
    cart_empty: "O seu carrinho está vazio.",
    cart_remove: "Remover",
    cart_shipping: "Envio",
    cart_subtotal: "Subtotal",
    cart_tax_note: "IVA calculado na finalização",
    cart_title: "Carrinho",
    cart_total: "Total",
    cat_henna: "Henna",
    cat_miswak: "Miswak",
    change_password: "Alterar palavra-passe",
    channel_email: "E-mail",
    channel_phone: "Telefone",
    channel_whatsapp: "WhatsApp",
    checkout_address: "Rua e n.º",
    checkout_apartment: "Apartamento / Piso (opcional)",
    checkout_billing: "Morada de faturação",
    checkout_billing_same: "Faturação igual ao envio",
    checkout_city: "Cidade",
    checkout_contact: "Contacto",
    checkout_country: "País",
    checkout_email: "E-mail",
    checkout_first_name: "Nome próprio",
    checkout_hold_expired_action: "Escolher novo horário",
    checkout_hold_expired_body: "O horário foi libertado e pode ter sido entretanto escolhido por outra pessoa. Por favor, selecione um novo horário.",
    checkout_hold_expired_title: "A sua reserva expirou",
    checkout_hold_expiring: "Reserva prestes a expirar",
    checkout_hold_hint: "O horário escolhido está reservado para si. Por favor, conclua o pagamento antes de expirar.",
    checkout_hold_title: "A sua reserva",
    checkout_last_name: "Apelido",
    checkout_name: "Nome completo",
    checkout_notes: "Notas do pedido (opcional)",
    checkout_pay_in_store: "Pagar no salão",
    checkout_pay_in_store_deposit_hint: "Para marcações é necessário um depósito online. O montante restante será pago no salão.",
    checkout_pay_in_store_hint: "Reserve agora, pague em dinheiro ou cartão ao levantar no salão (Kirchweg 20, Glarus).",
    checkout_pay_online: "Pagar online",
    checkout_pay_online_hint: "Cartão, TWINT, Apple Pay, Klarna – seguro através de Stripe.",
    checkout_payment: "Pagamento",
    checkout_phone: "Telefone (opcional)",
    checkout_place_order: "Continuar para pagamento",
    checkout_postal: "Código postal",
    checkout_return_pledge_label: "Comprometo-me a não abrir nem usar o produto caso deseje devolvê-lo.",
    checkout_return_pledge_required: "Por favor, confirme o compromisso de devolução para continuar.",
    checkout_return_policy_body: "De acordo com a nossa política de loja, um produto que tenha sido aberto ou usado não pode ser devolvido.",
    checkout_return_policy_title: "Direito de devolução — por favor, leia",
    checkout_review: "Revisão",
    checkout_secure_note: "Checkout Stripe seguro.",
    checkout_shipping: "Morada de entrega",
    checkout_street: "Rua e número",
    checkout_title: "Checkout",
    consultation_intro: "Teremos todo o gosto em aconselhá-lo.",
    consultation_msg: "A sua questão / assunto",
    consultation_preferred: "Contato preferido",
    consultation_preferred_time: "Data preferida",
    consultation_subject: "Assunto",
    consultation_submit: "Enviar pedido",
    consultation_thanks: "Obrigado – entraremos em contacto brevemente.",
    consultation_title: "Pedir consulta",
    contact_address: "Endereço",
    contact_email: "E-mail",
    contact_form_title: "Escreva-nos",
    contact_hours: "Horário de funcionamento",
    contact_message: "A sua mensagem",
    contact_phone: "Telefone",
    contact_send: "Enviar mensagem",
    contact_thanks: "Obrigado – entraremos em contato.",
    contact_title: "Contato",
    cookie_accept: "Aceitar",
    cookie_decline: "Apenas necessários",
    cookie_msg: "Este site usa apenas cookies técnicos e, com o seu consentimento, estatísticas anónimas.",
    copyright: "Todos os direitos reservados.",
    current_password: "Palavra-passe atual",
    delete_account: "Eliminar conta",
    delete_confirm: "Tem a certeza de que pretende eliminar permanentemente a conta?",
    email: "E-mail",
    footer_agb: "Termos e Condições",
    footer_brand: "Marca",
    footer_cookies: "Cookies",
    footer_datenschutz: "Privacidade",
    footer_faq: "FAQ",
    footer_help: "Ajuda",
    footer_impressum: "Ficha técnica",
    footer_legal: "Informação Legal",
    footer_returns: "Devoluções",
    footer_shipping: "Envio",
    footer_shop: "Loja",
    forgot_password: "Esqueceu a palavra-passe?",
    founder_label: "Fundador",
    free_shipping_over: "Envio grátis a partir de CHF 100",
    hero_cta: "Ver coleção",
    hero_secondary: "A Nossa História",
    hero_subtitle: "Cuidados premium para cabelo, barba e pele, óleos naturais, sabonete de Alepo, miswak, henna e mais – selecionados pela equipa Coiffeur Tattoo 01&Co. em Glarus.",
    hero_title: "Artesanato suíço. Cuidado natural.",
    home_studio_alt: "Estúdio Coiffeur Tattoo 01&Co. em Glarus",
    ingredients: "Ingredientes",
    login: "Entrar",
    login_with_google: "Iniciar sessão com Google",
    logout: "Terminar Sessão",
    medical_disclaimer: "Os nossos produtos não substituem aconselhamento médico profissional.",
    missing_token_error: "Token em falta.",
    my_orders: "As minhas encomendas",
    my_profile: "O Meu Perfil",
    nav_about: "Sobre Nós",
    nav_account: "Conta",
    nav_admin: "Admin",
    nav_cart: "Carrinho",
    nav_consultation: "Consulta",
    nav_contact: "Contacto",
    nav_home: "Início",
    nav_shop: "Loja",
    nav_tracking: "Rastreio",
    nav_wishlist: "Lista de Desejos",
    new_badge: "Novo",
    new_password: "Nova palavra-passe",
    newsletter_desc: "Novidades e ofertas exclusivas.",
    newsletter_label: "Newsletter",
    newsletter_placeholder: "O seu e-mail",
    newsletter_submit: "Subscrever",
    newsletter_title: "Fique inspirado.",
    no_questions: "Sem perguntas ainda.",
    no_reviews: "Ainda sem avaliações.",
    order_number: "N.º de encomenda",
    order_status_cancelled: "Cancelada",
    order_status_delivered: "Entregue",
    order_status_paid: "Pago",
    order_status_pending: "Pendente",
    order_status_processing: "Em Processamento",
    order_status_refunded: "Reembolsado",
    order_status_shipped: "Enviada",
    order_tracking_email: "Endereço de e-mail",
    order_tracking_intro: "Insira o n.º da encomenda e e-mail.",
    order_tracking_not_found: "Encomenda não encontrada.",
    order_tracking_number: "N.º de encomenda",
    order_tracking_submit: "Rastrear",
    order_tracking_title: "Rastreio de encomenda",
    otp_expires_hint: "O código é válido durante 10 minutos. Verifique a sua pasta de spam, se necessário.",
    otp_heading: "Introduza o seu código",
    otp_invalid: "Código incorreto. Por favor, tente novamente.",
    otp_resend: "Reenviar código",
    otp_resent: "Novo código enviado.",
    otp_sent: "Enviámos-lhe um código por e-mail.",
    otp_sent_to: "Enviámos um código de 6 dígitos para:",
    otp_title: "Confirmação de e-mail",
    otp_verified: "E-mail confirmado — bem-vindo!",
    otp_verify: "Confirmar",
    out_of_stock: "Esgotado",
    password: "Palavra-passe",
    payment_cancel: "Pagamento cancelado",
    payment_cancel_msg: "Pagamento cancelado. Pode tentar novamente.",
    payment_success: "Pagamento bem-sucedido",
    payment_success_msg: "Obrigado pela sua encomenda!",
    payments_title: "Informações de pagamento",
    phone_label: "Telefone",
    price: "Preço",
    qa_disclaimer: "As opiniões são experiências pessoais e não substituem aconselhamento médico.",
    qa_login_required: "Inicie sessão para perguntar.",
    quantity: "Quantidade",
    question_pending: "A sua pergunta está em revisão.",
    questions_title: "Perguntas e Respostas",
    reason_natural: "Ingredientes naturais",
    reason_natural_desc: "Selecionamos cada óleo com o maior cuidado.",
    reason_secure: "Pagamento seguro",
    reason_secure_desc: "Encriptação por Stripe.",
    reason_shipping: "Envio mundial",
    reason_shipping_desc: "Envio gratuito a partir de CHF 100.",
    reason_swiss: "Marca suíça",
    reason_swiss_desc: "Fundado em Glarus – artesanato que se sente.",
    register: "Registar",
    related_products: "Produtos Relacionados",
    report_content: "Reportar",
    reset_link_sent: "Se existir uma conta, foi criado um link.",
    reset_password: "Redefinir Palavra-passe",
    reset_success: "Palavra-passe redefinida.",
    ret_created: "O seu pedido de devolução foi criado.",
    ret_error: "Não foi possível criar o pedido.",
    ret_existing_hint: "Entraremos em contacto consigo com os próximos passos.",
    ret_existing_title: "Estado da devolução",
    ret_info_inspected: "Inspecionado a",
    ret_info_order: "Número de encomenda",
    ret_info_products: "Produtos devolvidos",
    ret_info_products_all: "Encomenda completa",
    ret_info_received: "Recebido a",
    ret_info_refunded: "Reembolsado a",
    ret_info_requested: "Solicitado a",
    ret_inspection_failed_hint: "Após inspeção, infelizmente não pudemos aceitar a sua devolução. Por favor, contacte-nos para esclarecimentos.",
    ret_modal_intro: "Para que o seu produto seja elegível para devolução, não pode ter sido aberto nem usado.",
    ret_modal_title: "Devolver produto",
    ret_only_delivered: "Devolução disponível assim que a encomenda for entregue.",
    ret_pledge_label: "Confirmo que o produto não foi aberto nem usado e que o devolvo no estado em que o recebi.",
    ret_pledge_required: "Por favor, confirme o compromisso de devolução.",
    ret_reason_changed_mind: "Mudei de ideias",
    ret_reason_damaged: "O produto está danificado",
    ret_reason_group_customer: "Motivo pessoal",
    ret_reason_group_product: "Problema com o produto ou encomenda",
    ret_reason_no_longer_needed: "Já não preciso",
    ret_reason_order_error: "Erro na encomenda",
    ret_reason_other: "Outro motivo",
    ret_reason_other_issue: "Outro problema com o produto",
    ret_reason_placeholder: "Por favor, descreva o motivo…",
    ret_reason_shipping_damage: "Chegou danificado",
    ret_reason_wrong_choice: "Escolhi o produto errado por engano",
    ret_reason_wrong_item: "O produto entregue não corresponde à encomenda",
    ret_refund_amount: "Montante do reembolso",
    ret_refund_bank_note: "O tempo até o montante ficar visível na sua conta depende do seu banco ou operador de cartão e pode demorar vários dias úteis.",
    ret_refund_issue_body: "O reembolso ainda não pôde ser concluído e continua a ser processado. Não precisa de fazer nada — para questões, contacte-nos em info@01co.ch.",
    ret_refund_status_failed: "Reembolso ainda em processamento",
    ret_refund_status_processing: "Reembolso a ser processado",
    ret_refund_status_succeeded: "Reembolso efetuado",
    ret_request_btn: "Solicitar devolução",
    ret_resolution_free: "Devolução gratuita · Envio assumido pelo salão",
    ret_resolution_paid: "Devolução paga pelo cliente · Envio a seu cargo",
    ret_rma_code: "Código RMA",
    ret_status_approved: "Devolução aprovada",
    ret_status_rejected: "Devolução recusada",
    ret_status_requested: "Devolução solicitada",
    ret_status_under_review: "Em análise",
    ret_step_inspected: "Produto inspecionado",
    ret_step_received: "Devolução recebida",
    ret_step_refund_complete: "Reembolso concluído",
    ret_step_refund_initiated: "Reembolso iniciado",
    ret_step_refund_issue: "Reembolso — problema",
    ret_step_rejected: "Devolução recusada",
    ret_step_requested: "Devolução solicitada",
    ret_submit: "Enviar pedido",
    review_body: "A Sua Experiência",
    review_pending: "A sua avaliação foi submetida e está a ser analisada.",
    review_rating: "Nota",
    review_title: "Título",
    reviews: "Avaliações",
    sale_badge: "Promoção",
    save: "Guardar",
    saved: "Guardado",
    search_placeholder: "Pesquisar produtos…",
    section_bestsellers: "Bestsellers",
    section_featured: "Destaques",
    section_new: "Novidades",
    section_oils: "Óleos naturais",
    section_why_title: "Porquê Coiffeur Tattoo 01&Co.",
    since_2011: "Desde 2011",
    size: "Tamanho",
    stock_in: "Em stock",
    stock_low: "Poucos disponíveis",
    stock_low_1: "Quase esgotado — apenas 1 unidade disponível",
    stock_low_2: "Quase esgotado — apenas 2 unidades disponíveis",
    stock_low_3: "Quase esgotado — apenas 3 unidades disponíveis",
    stock_low_4: "Quase esgotado — apenas 4 unidades disponíveis",
    stock_out: "Esgotado",
    stock_setup: "Indisponível de momento",
    submit_answer: "Enviar resposta",
    submit_question: "Enviar pergunta",
    submit_review: "Enviar avaliação",
    suitable_bart: "Barba",
    suitable_for: "Adequado para",
    suitable_gesicht: "Rosto",
    suitable_haare: "Cabelo",
    suitable_haut: "Pele",
    suitable_koerper: "Corpo",
    time_remaining_label: "Tempo restante",
    tracking_carrier: "Transportadora",
    tracking_link: "Rastrear no fornecedor",
    tracking_number: "N.º de rastreio",
    usage: "Modo de uso",
    variant: "Variante",
    verified_purchase: "Compra verificada",
    view_all: "Ver tudo",
    view_details: "Ver detalhes",
    warnings: "Avisos",
    welcome: "Bem-vindo",
    wishlist_add: "Adicionar aos favoritos",
    wishlist_empty: "A sua lista de desejos está vazia.",
    wishlist_login: "Inicie sessão para usar os favoritos.",
    wishlist_remove: "Remover da lista de desejos",
    wishlist_title: "Favoritos",
    write_review: "Escrever avaliação",
      cat_bartpflege: "Cuidado da barba",
    cat_haarpflege: "Cuidado capilar",
    cat_sets_bundles: "Kits & Conjuntos",
},
  nl: {
    about_address: "Kirchweg 20, 8750 Glarus, Zwitserland",
    about_founder: "Oprichter: Sajjad Al-Daghir",
    about_intro: "Een Zwitsers merk uit Glarus – stijl en kwaliteit sinds 2011.",
    about_philosophy_body: "Wij geloven dat natuurlijke producten meer zijn dan producten – ze verbinden mensen, natuur en traditionele kennis.",
    about_philosophy_title: "Onze filosofie",
    about_title: "Coiffeur Tattoo 01&Co.",
    about_values_title: "Natuurlijk. Authentiek. Zorgvuldig gekozen.",
    add_to_cart: "In winkelmand",
    address_label: "Adres",
    admin_analytics: "Analyses",
    admin_avg: "Ø Bestelwaarde",
    admin_consultations: "Adviesaanvragen",
    admin_customers: "Klanten",
    admin_discounts: "Kortingen",
    admin_orders: "Bestellingen",
    admin_products: "Producten",
    admin_questions: "Vragen",
    admin_revenue: "Omzet",
    admin_reviews: "Beoordelingen",
    admin_title: "Beheerdersdashboard",
    admin_total_orders: "Bestellingen totaal",
    answer_placeholder: "Beantwoorden…",
    aria_account: "Account",
    aria_basra: "Basra Assistent",
    aria_cart: "Winkelwagen",
    aria_close: "Sluiten",
    aria_loading: "Laden…",
    aria_logo_home: "Coiffeur Tattoo 01&Co. Startpagina",
    aria_menu: "Menu",
    aria_remove: "Verwijderen",
    aria_send: "Verzenden",
    aria_wishlist: "Verlanglijst",
    ask_placeholder: "Uw vraag …",
    ask_question: "Stel een vraag",
    auth_error: "Fout bij aanmelding.",
    auth_or: "of",
    benefits: "Voordelen",
    bestseller_badge: "Bestseller",
    book_add: "Toevoegen",
    book_added_to_cart: "Toegevoegd aan boeking",
    book_appointment_nr: "Afspraaknr.",
    book_appointment_time: "Afspraak",
    book_autofilled: "Automatisch ingevuld",
    book_back: "Terug",
    book_booking_confirmed: "Afspraak bevestigd",
    book_booking_processing: "Wordt geboekt…",
    book_cancel_policy: "Annuleringsvoorwaarden",
    book_cart_empty: "Nog geen diensten geselecteerd.",
    book_cat_kids: "Kinderen & Jongeren",
    book_cat_men: "Heren",
    book_cat_tattoo: "Tattoo",
    book_cat_unisex: "Unisex",
    book_cat_women: "Dames",
    book_colors: "Kleuren",
    book_customer_eyebrow: "Uw gegevens",
    book_customer_hint: "Vul dit eenmalig in — bij uw volgende bezoek worden uw gegevens automatisch overgenomen.",
    book_datetime: "Tijdstip",
    book_deposit_note_body: "De aanbetaling wordt ingehouden conform ons annulerings- en te-laat-beleid: bij annulering minder dan 24 uur voor de afspraak, bij boekingen op dezelfde dag, bij niet-verschijnen en bij meer dan 5 minuten te laat zonder tijdige telefonische melding. Bij tijdige annulering (≥ 24 u) wordt de aanbetaling volledig terugbetaald.",
    book_deposit_note_title: "Belangrijke informatie over de aanbetaling (50%)",
    book_deposit_required: "Voor diensten is een online aanbetaling vereist. Ga verder naar Stripe …",
    book_description: "Beschrijving",
    book_edit: "Wijzigen",
    book_email_confirmation: "Wij hebben u een bevestiging per e-mail gestuurd.",
    book_error_booking: "Fout bij boeken",
    book_error_generic: "Fout",
    book_fill_required: "Vul alle verplichte velden in.",
    book_full_name: "Volledige naam",
    book_lines: "Lijnen",
    book_loading_details: "Details worden geladen …",
    book_login_hint: "Tip: Meld u aan, zodat wij uw gegevens de volgende keer automatisch overnemen.",
    book_multi_hint: "Selecteer naar wens meerdere diensten uit elke categorie. Datum en tijdstip bepaalt u in de volgende stap.",
    book_next: "Verder",
    book_no_slots: "Geen tijdstippen beschikbaar op deze dag.",
    book_payment_breakdown: "Betalingsoverzicht",
    book_phone_num: "Telefoon",
    book_pick_date: "Kies datum",
    book_pick_length: "Kies lengte",
    book_pick_time: "Tijd kiezen",
    book_placeholder_colors: "Kleuren (bijv. zwart, kleur …)",
    book_placeholder_desc: "Beschrijving van het motief …",
    book_placeholder_lines: "Lijnen (bijv. fijn, krachtig …)",
    book_policy_5min: "Bij vertraging van meer dan 5 minuten zonder telefonische aankondiging wordt de vergoeding (50 %) in rekening gebracht. Als u binnen 5 minuten belt, kan de afspraak zonder extra kosten worden verlengd.",
    book_policy_free_6h: "Gratis annuleren tot 6 uur voor uw kappersafspraak (tattoo: 24 uur).",
    book_policy_late_fee: "Bij latere annulering wordt 50 % als vergoeding in rekening gebracht.",
    book_policy_within_6h: "Afspraken binnen de komende 6 uur kunnen niet meer worden geannuleerd.",
    book_preferred_time: "Gewenste tijd (optioneel)",
    book_price: "Prijs",
    book_price_from: "vanaf",
    book_price_on_request: "Prijs op aanvraag",
    book_remove: "Verwijderen",
    book_request_sent: "Aanvraag verzonden",
    book_reservation: "Reservering",
    book_review_add_product: "Product toevoegen",
    book_review_add_service: "Nog een dienst",
    book_review_continue_pay: "Ga verder naar betaling",
    book_review_continue_schedule: "Ga verder naar afspraakkeuze",
    book_review_deposit_now: "Aanbetaling nu",
    book_review_due_now: "Totaalbedrag nu",
    book_review_eyebrow: "Boekingsoverzicht",
    book_review_products_total: "Producten totaal",
    book_review_question: "Wilt u nog een dienst of product toevoegen, of direct naar de afspraakkeuze?",
    book_review_rest_at_salon: "Restbedrag in salon",
    book_review_services_total: "Diensten totaal",
    book_review_split_note: "Voor diensten betaalt u nu 50 % als aanbetaling, het restant eenvoudig in de salon. Producten worden volledig online betaald.",
    book_review_summary: "Overzicht",
    book_review_title: "Bijna klaar — nog iets toevoegen?",
    book_review_your_products: "Uw producten",
    book_review_your_services: "Uw diensten",
    book_schedule_hint: "Totale duur:",
    book_selected_service: "Gekozen dienst",
    book_send_request: "Aanvraag versturen",
    book_sending: "Wordt verzonden…",
    book_size: "Grootte",
    book_size_large: "Groot (boven 20 cm)",
    book_size_medium: "Middelgroot (10–20 cm)",
    book_size_small: "Klein (tot 10 cm)",
    book_state_blocked_hover: "⚫ Niet beschikbaar — gesloten of geblokkeerd",
    book_state_booked_hover: "🔴 Bezet — reeds geboekt",
    book_state_free_hover: "🟢 Vrij — nu boekbaar",
    book_state_mine_hover: "🔵 Uw afspraak",
    book_state_needs_conf_hover: "🟠 Wacht op bevestiging",
    book_state_pending_hover: "🟡 Loopt — boeking in behandeling",
    book_state_too_soon_hover: "⚫ Te snel — minimaal 30 min voorafgaand",
    book_status_blocked: "Geblokkeerd",
    book_status_booked: "Bezet",
    book_status_free: "Vrij",
    book_status_mine: "Uw afspraak",
    book_status_needs_conf: "Wacht op bevestiging",
    book_status_pending: "In behandeling",
    book_step_done: "Klaar",
    book_step_info: "Gegevens",
    book_step_service: "Dienst",
    book_step_time: "Afspraak",
    book_submit_booking: "Afspraak bevestigen",
    book_tattoo_no_price: "Geen vaste prijs. Beschrijf uw gewenste ontwerp – wij nemen contact met u op voor prijs en afspraak.",
    book_tattoo_title: "Tattoo-aanvraag",
    book_termin_agreement: "Op afspraak",
    book_visit_hint: "Wij kijken uit naar uw bezoek. Het restbedrag is in de salon te betalen.",
    book_will_contact: "Wij nemen spoedig contact met u op voor prijs en afspraak.",
    book_your_cart: "Uw selectie",
    book_your_info: "Uw gegevens",
    book_your_visit: "Uw bezoek",
    booking_eyebrow: "Afspraak maken",
    booking_title: "Boek uw afspraak",
    brand_tagline: "Haar & Beauty sinds 2011",
    buy_now: "Nu kopen",
    cart_added: "Toegevoegd",
    cart_apply: "Toepassen",
    cart_checkout: "Afrekenen",
    cart_continue: "Verder winkelen",
    cart_discount: "Korting",
    cart_discount_applied: "Korting toegepast",
    cart_discount_code: "Kortingscode",
    cart_discount_invalid: "Kortingscode ongeldig",
    cart_empty: "Uw winkelwagen is leeg.",
    cart_remove: "Verwijderen",
    cart_shipping: "Verzending",
    cart_subtotal: "Subtotaal",
    cart_tax_note: "BTW berekend bij afrekenen",
    cart_title: "Winkelmand",
    cart_total: "Totaal",
    cat_henna: "Henna",
    cat_miswak: "Miswak",
    change_password: "Wachtwoord wijzigen",
    channel_email: "E-mail",
    channel_phone: "Telefoon",
    channel_whatsapp: "WhatsApp",
    checkout_address: "Straat & nr.",
    checkout_apartment: "Appartement / verdieping (optioneel)",
    checkout_billing: "Factuuradres",
    checkout_billing_same: "Factuuradres gelijk aan verzendadres",
    checkout_city: "Plaats",
    checkout_contact: "Contact",
    checkout_country: "Land",
    checkout_email: "E-mail",
    checkout_first_name: "Voornaam",
    checkout_hold_expired_action: "Nieuwe afspraak kiezen",
    checkout_hold_expired_body: "De afspraak is vrijgegeven en kan inmiddels door iemand anders zijn gekozen. Kies een nieuw tijdstip.",
    checkout_hold_expired_title: "Uw reservering is verlopen",
    checkout_hold_expiring: "Reservering verloopt binnenkort",
    checkout_hold_hint: "Uw gekozen afspraak is voor u gereserveerd. Rond de betaling af vóór het verlopen van de reservering.",
    checkout_hold_title: "Uw reservering",
    checkout_last_name: "Achternaam",
    checkout_name: "Volledige naam",
    checkout_notes: "Opmerkingen bij bestelling (optioneel)",
    checkout_pay_in_store: "Betalen in de salon",
    checkout_pay_in_store_deposit_hint: "Voor afspraken is een online aanbetaling vereist. Het restbedrag wordt in de salon betaald.",
    checkout_pay_in_store_hint: "Nu reserveren, betalen bij afhalen in de salon (Kirchweg 20, Glarus) met contant of pin.",
    checkout_pay_online: "Online betalen",
    checkout_pay_online_hint: "Kaart, TWINT, Apple Pay, Klarna – veilig via Stripe.",
    checkout_payment: "Betaling",
    checkout_phone: "Telefoon (optioneel)",
    checkout_place_order: "Verder naar betaling",
    checkout_postal: "Postcode",
    checkout_return_pledge_label: "Ik verplicht mij het product niet te openen en niet te gebruiken indien ik het wil retourneren.",
    checkout_return_pledge_required: "Bevestig de retourbelofte om verder te gaan.",
    checkout_return_policy_body: "Conform ons winkelbeleid kan een product dat geopend of gebruikt is niet worden geretourneerd.",
    checkout_return_policy_title: "Retourrecht — lees dit",
    checkout_review: "Controle",
    checkout_secure_note: "Veilig Stripe afrekenen.",
    checkout_shipping: "Bezorgadres",
    checkout_street: "Straat & huisnummer",
    checkout_title: "Afrekenen",
    consultation_intro: "Wij adviseren u graag persoonlijk.",
    consultation_msg: "Uw vraag / verzoek",
    consultation_preferred: "Gewenst contact",
    consultation_preferred_time: "Gewenste afspraak",
    consultation_subject: "Onderwerp",
    consultation_submit: "Aanvraag verzenden",
    consultation_thanks: "Dank u – wij nemen spoedig contact met u op.",
    consultation_title: "Adviesaanvraag",
    contact_address: "Adres",
    contact_email: "E-mail",
    contact_form_title: "Schrijf ons",
    contact_hours: "Openingstijden",
    contact_message: "Uw bericht",
    contact_phone: "Telefoon",
    contact_send: "Bericht versturen",
    contact_thanks: "Bedankt – we nemen spoedig contact op.",
    contact_title: "Contact",
    cookie_accept: "Accepteren",
    cookie_decline: "Alleen noodzakelijke",
    cookie_msg: "Deze site gebruikt alleen technische cookies en – met uw toestemming – anonieme statistieken.",
    copyright: "Alle rechten voorbehouden.",
    current_password: "Huidig wachtwoord",
    delete_account: "Account verwijderen",
    delete_confirm: "Account definitief verwijderen?",
    email: "E-mail",
    footer_agb: "Algemene voorwaarden",
    footer_brand: "Merk",
    footer_cookies: "Cookies",
    footer_datenschutz: "Privacy",
    footer_faq: "FAQ",
    footer_help: "Hulp",
    footer_impressum: "Colofon",
    footer_legal: "Juridisch",
    footer_returns: "Retourneren",
    footer_shipping: "Verzending",
    footer_shop: "Winkel",
    forgot_password: "Wachtwoord vergeten?",
    founder_label: "Oprichter",
    free_shipping_over: "Gratis verzending vanaf CHF 100",
    hero_cta: "Ontdek de collectie",
    hero_secondary: "Ons verhaal",
    hero_subtitle: "Premium haar-, baard- en huidverzorging, natuurlijke oliën, Aleppo-zeep, miswak, henna en meer – samengesteld door het team van Coiffeur Tattoo 01&Co. in Glarus.",
    hero_title: "Zwitsers vakmanschap. Natuurlijke verzorging.",
    home_studio_alt: "Coiffeur Tattoo 01&Co. Studio in Glarus",
    ingredients: "Ingrediënten",
    login: "Inloggen",
    login_with_google: "Aanmelden met Google",
    logout: "Afmelden",
    medical_disclaimer: "Onze producten vervangen geen professioneel medisch advies.",
    missing_token_error: "Token ontbreekt.",
    my_orders: "Mijn bestellingen",
    my_profile: "Mijn profiel",
    nav_about: "Over ons",
    nav_account: "Account",
    nav_admin: "Admin",
    nav_cart: "Winkelwagen",
    nav_consultation: "Advies",
    nav_contact: "Contact",
    nav_home: "Home",
    nav_shop: "Shop",
    nav_tracking: "Bestelling volgen",
    nav_wishlist: "Verlanglijst",
    new_badge: "Nieuw",
    new_password: "Nieuw wachtwoord",
    newsletter_desc: "Nieuwe producten en exclusieve aanbiedingen.",
    newsletter_label: "Nieuwsbrief",
    newsletter_placeholder: "Uw e-mail",
    newsletter_submit: "Abonneren",
    newsletter_title: "Blijf geïnspireerd.",
    no_questions: "Nog geen vragen.",
    no_reviews: "Nog geen beoordelingen.",
    order_number: "Bestelnummer",
    order_status_cancelled: "Geannuleerd",
    order_status_delivered: "Afgeleverd",
    order_status_paid: "Betaald",
    order_status_pending: "In afwachting",
    order_status_processing: "In behandeling",
    order_status_refunded: "Terugbetaald",
    order_status_shipped: "Verzonden",
    order_tracking_email: "E-mailadres",
    order_tracking_intro: "Voer uw bestelnummer en e-mail in.",
    order_tracking_not_found: "Bestelling niet gevonden.",
    order_tracking_number: "Bestelnummer",
    order_tracking_submit: "Volgen",
    order_tracking_title: "Bestelling volgen",
    otp_expires_hint: "De code is 10 minuten geldig. Controleer eventueel uw spam-map.",
    otp_heading: "Voer uw code in",
    otp_invalid: "Onjuiste code. Probeer het opnieuw.",
    otp_resend: "Code opnieuw verzenden",
    otp_resent: "Nieuwe code is verzonden.",
    otp_sent: "Wij hebben u een code per e-mail gestuurd.",
    otp_sent_to: "Wij hebben een 6-cijferige code verzonden naar:",
    otp_title: "E-mailbevestiging",
    otp_verified: "E-mail bevestigd — welkom!",
    otp_verify: "Bevestigen",
    out_of_stock: "Uitverkocht",
    password: "Wachtwoord",
    payment_cancel: "Betaling geannuleerd",
    payment_cancel_msg: "Uw betaling is geannuleerd. U kunt het opnieuw proberen.",
    payment_success: "Betaling geslaagd",
    payment_success_msg: "Bedankt voor uw bestelling!",
    payments_title: "Betaalinformatie",
    phone_label: "Telefoon",
    price: "Prijs",
    qa_disclaimer: "Meningen zijn persoonlijke ervaringen en geen medisch advies.",
    qa_login_required: "Log in om te vragen of antwoorden.",
    quantity: "Aantal",
    question_pending: "Uw vraag wordt beoordeeld.",
    questions_title: "Vragen & Antwoorden",
    reason_natural: "Natuurlijke ingrediënten",
    reason_natural_desc: "Wij selecteren elke olie met zorg.",
    reason_secure: "Veilig betalen",
    reason_secure_desc: "Beveiligd met Stripe.",
    reason_shipping: "Wereldwijde verzending",
    reason_shipping_desc: "Gratis verzending vanaf CHF 100.",
    reason_swiss: "Zwitsers merk",
    reason_swiss_desc: "Opgericht in Glarus – vakmanschap dat u voelt.",
    register: "Registreren",
    related_products: "Vergelijkbare producten",
    report_content: "Melden",
    reset_link_sent: "Als een account bestaat, is een link aangemaakt.",
    reset_password: "Wachtwoord resetten",
    reset_success: "Wachtwoord gereset.",
    ret_created: "Uw retourverzoek is aangemaakt.",
    ret_error: "Verzoek kon niet worden aangemaakt.",
    ret_existing_hint: "Wij nemen contact met u op met de volgende stappen.",
    ret_existing_title: "Retourstatus",
    ret_info_inspected: "Gecontroleerd op",
    ret_info_order: "Bestelnummer",
    ret_info_products: "Geretourneerde producten",
    ret_info_products_all: "Gehele bestelling",
    ret_info_received: "Ontvangen op",
    ret_info_refunded: "Terugbetaald op",
    ret_info_requested: "Aangevraagd op",
    ret_inspection_failed_hint: "Na controle konden wij uw retour helaas niet accepteren. Neem bij vragen contact met ons op.",
    ret_modal_intro: "Om in aanmerking te komen voor retournering mag het product niet geopend of gebruikt zijn.",
    ret_modal_title: "Product retourneren",
    ret_only_delivered: "Retourneren mogelijk zodra de bestelling is geleverd.",
    ret_pledge_label: "Ik bevestig dat het product niet is geopend en niet is gebruikt en dat ik het retourneer in de staat waarin ik het heb ontvangen.",
    ret_pledge_required: "Bevestig de retourbelofte.",
    ret_reason_changed_mind: "Ik ben van gedachten veranderd",
    ret_reason_damaged: "Het product is beschadigd",
    ret_reason_group_customer: "Persoonlijke reden",
    ret_reason_group_product: "Probleem met het product of de bestelling",
    ret_reason_no_longer_needed: "Ik heb het niet meer nodig",
    ret_reason_order_error: "Fout in de bestelling",
    ret_reason_other: "Andere reden",
    ret_reason_other_issue: "Een ander probleem met het product",
    ret_reason_placeholder: "Beschrijf de reden…",
    ret_reason_shipping_damage: "Het kwam beschadigd aan",
    ret_reason_wrong_choice: "Ik heb per ongeluk het verkeerde product gekozen",
    ret_reason_wrong_item: "Het geleverde product komt niet overeen met de bestelling",
    ret_refund_amount: "Restitutie bedrag",
    ret_refund_bank_note: "Hoe lang het duurt voordat het bedrag op uw rekening zichtbaar is, hangt af van uw bank of kaartaanbieder en kan enkele werkdagen duren.",
    ret_refund_issue_body: "De restitutie kon nog niet worden afgerond en wordt verder verwerkt. U hoeft niets te doen — bij vragen kunt u ons bereiken via info@01co.ch.",
    ret_refund_status_failed: "Restitutie nog in verwerking",
    ret_refund_status_processing: "Restitutie wordt verwerkt",
    ret_refund_status_succeeded: "Restitutie uitgevoerd",
    ret_request_btn: "Retour aanvragen",
    ret_resolution_free: "Gratis retour · verzending door salon",
    ret_resolution_paid: "Retour voor rekening klant · verzending voor uw rekening",
    ret_rma_code: "RMA-code",
    ret_status_approved: "Retour goedgekeurd",
    ret_status_rejected: "Retour afgewezen",
    ret_status_requested: "Retour aangevraagd",
    ret_status_under_review: "In behandeling",
    ret_step_inspected: "Product gecontroleerd",
    ret_step_received: "Retourzending ontvangen",
    ret_step_refund_complete: "Restitutie afgerond",
    ret_step_refund_initiated: "Restitutie gestart",
    ret_step_refund_issue: "Restitutie — probleem",
    ret_step_rejected: "Retour afgewezen",
    ret_step_requested: "Retour aangevraagd",
    ret_submit: "Verzoek verzenden",
    review_body: "Uw ervaring",
    review_pending: "Uw beoordeling is ingediend en wordt beoordeeld.",
    review_rating: "Score",
    review_title: "Titel",
    reviews: "Beoordelingen",
    sale_badge: "Sale",
    save: "Opslaan",
    saved: "Opgeslagen",
    search_placeholder: "Producten zoeken…",
    section_bestsellers: "Bestsellers",
    section_featured: "Uitgelicht",
    section_new: "Nieuw",
    section_oils: "Natuurlijke oliën",
    section_why_title: "Waarom Coiffeur Tattoo 01&Co.",
    since_2011: "Sinds 2011",
    size: "Maat",
    stock_in: "Op voorraad",
    stock_low: "Beperkte voorraad",
    stock_low_1: "Bijna uitverkocht — nog 1 stuk beschikbaar",
    stock_low_2: "Bijna uitverkocht — nog 2 stuks beschikbaar",
    stock_low_3: "Bijna uitverkocht — nog 3 stuks beschikbaar",
    stock_low_4: "Bijna uitverkocht — nog 4 stuks beschikbaar",
    stock_out: "Uitverkocht",
    stock_setup: "Momenteel niet beschikbaar",
    submit_answer: "Antwoord versturen",
    submit_question: "Vraag versturen",
    submit_review: "Beoordeling versturen",
    suitable_bart: "Baard",
    suitable_for: "Geschikt voor",
    suitable_gesicht: "Gezicht",
    suitable_haare: "Haar",
    suitable_haut: "Huid",
    suitable_koerper: "Lichaam",
    time_remaining_label: "Resterende tijd",
    tracking_carrier: "Vervoerder",
    tracking_link: "Volgen bij vervoerder",
    tracking_number: "Track & trace",
    usage: "Gebruik",
    variant: "Variant",
    verified_purchase: "Geverifieerde aankoop",
    view_all: "Alles bekijken",
    view_details: "Details bekijken",
    warnings: "Waarschuwingen",
    welcome: "Welkom",
    wishlist_add: "Aan verlanglijst toevoegen",
    wishlist_empty: "Uw verlanglijst is leeg.",
    wishlist_login: "Log in om de verlanglijst te gebruiken.",
    wishlist_remove: "Verwijderen van verlanglijst",
    wishlist_title: "Verlanglijst",
    write_review: "Beoordeling schrijven",
      cat_bartpflege: "Baardverzorging",
    cat_haarpflege: "Haarverzorging",
    cat_sets_bundles: "Sets & Pakketten",
},
  sv: {
    about_address: "Kirchweg 20, 8750 Glarus, Schweiz",
    about_founder: "Grundare: Sajjad Al-Daghir",
    about_intro: "Ett schweiziskt varumärke från Glarus – stil och kvalitet sedan 2011.",
    about_philosophy_body: "Vi tror att naturliga produkter är mer än produkter – de är en länk mellan människor, natur och traditionell kunskap.",
    about_philosophy_title: "Vår filosofi",
    about_title: "Coiffeur Tattoo 01&Co.",
    about_values_title: "Naturligt. Äkta. Utvalt med omsorg.",
    add_to_cart: "Lägg i varukorg",
    address_label: "Adress",
    admin_analytics: "Analys",
    admin_avg: "Ø Ordervärde",
    admin_consultations: "Konsultationsförfrågningar",
    admin_customers: "Kunder",
    admin_discounts: "Rabatter",
    admin_orders: "Beställningar",
    admin_products: "Produkter",
    admin_questions: "Frågor",
    admin_revenue: "Intäkter",
    admin_reviews: "Recensioner",
    admin_title: "Admin Dashboard",
    admin_total_orders: "Totalt antal beställningar",
    answer_placeholder: "Svara…",
    aria_account: "Konto",
    aria_basra: "Basra-assistent",
    aria_cart: "Varukorg",
    aria_close: "Stäng",
    aria_loading: "Laddar…",
    aria_logo_home: "Coiffeur Tattoo 01&Co. startsida",
    aria_menu: "Meny",
    aria_remove: "Ta bort",
    aria_send: "Skicka",
    aria_wishlist: "Önskelista",
    ask_placeholder: "Din fråga …",
    ask_question: "Ställ en fråga",
    auth_error: "Fel vid inloggning.",
    auth_or: "eller",
    benefits: "Fördelar",
    bestseller_badge: "Bästsäljare",
    book_add: "Lägg till",
    book_added_to_cart: "Tillagt i bokningen",
    book_appointment_nr: "Bokningsnr.",
    book_appointment_time: "Tid",
    book_autofilled: "Automatiskt ifylld",
    book_back: "Tillbaka",
    book_booking_confirmed: "Bokning bekräftad",
    book_booking_processing: "Bokar…",
    book_cancel_policy: "Avbokningsvillkor",
    book_cart_empty: "Inga tjänster valda ännu.",
    book_cat_kids: "Barn & Ungdom",
    book_cat_men: "Herr",
    book_cat_tattoo: "Tattoo",
    book_cat_unisex: "Unisex",
    book_cat_women: "Dam",
    book_colors: "Färger",
    book_customer_eyebrow: "Dina uppgifter",
    book_customer_hint: "Vänligen fyll i en gång — vid nästa besök fylls dina uppgifter i automatiskt.",
    book_datetime: "Tidpunkt",
    book_deposit_note_body: "Handpenningen innehålls enligt vår avboknings- och förseningspolicy: vid avbokning mindre än 24 timmar före besöket, vid bokning samma dag, vid uteblivet besök samt vid försening mer än 5 minuter utan föregående telefonbesked. Vid avbokning i god tid (≥ 24 h) återbetalas handpenningen i sin helhet.",
    book_deposit_note_title: "Viktig information om handpenning (50%)",
    book_deposit_required: "För tjänster krävs en handpenning online. Vidare till Stripe …",
    book_description: "Beskrivning",
    book_edit: "Ändra",
    book_email_confirmation: "Vi har skickat en bekräftelse till din e-post.",
    book_error_booking: "Fel vid bokning",
    book_error_generic: "Fel",
    book_fill_required: "Vänligen fyll i alla obligatoriska fält.",
    book_full_name: "Fullständigt namn",
    book_lines: "Linjer",
    book_loading_details: "Laddar detaljer …",
    book_login_hint: "Tips: Logga in så att vi automatiskt kan fylla i dina uppgifter nästa gång.",
    book_multi_hint: "Välj fritt antal tjänster från varje kategori. Datum och tid väljer du i nästa steg.",
    book_next: "Nästa",
    book_no_slots: "Inga lediga tider denna dag.",
    book_payment_breakdown: "Betalningsöversikt",
    book_phone_num: "Telefon",
    book_pick_date: "Välj datum",
    book_pick_length: "Välj längd",
    book_pick_time: "Välj tid",
    book_placeholder_colors: "Färger (t.ex. svart, färger …)",
    book_placeholder_desc: "Beskrivning av motivet …",
    book_placeholder_lines: "Linjer (t.ex. fina, kraftiga …)",
    book_policy_5min: "Vid mer än 5 minuters försening utan telefonanmälan debiteras avgiften (50 %). Om du ringer inom 5 minuter kan tiden förlängas utan extra kostnad.",
    book_policy_free_6h: "Kostnadsfri avbokning upp till 6 timmar före frisörtiden (tatuering: 24 timmar).",
    book_policy_late_fee: "Vid senare avbokning debiteras 50 % av priset som avgift.",
    book_policy_within_6h: "Tider inom de kommande 6 timmarna kan inte längre avbokas.",
    book_preferred_time: "Önskad tid (valfritt)",
    book_price: "Pris",
    book_price_from: "från",
    book_price_on_request: "Pris på förfrågan",
    book_remove: "Ta bort",
    book_request_sent: "Förfrågan skickad",
    book_reservation: "Reservation",
    book_review_add_product: "Lägg till produkt",
    book_review_add_service: "Ytterligare tjänst",
    book_review_continue_pay: "Vidare till betalning",
    book_review_continue_schedule: "Vidare till tidsbokning",
    book_review_deposit_now: "Handpenning nu",
    book_review_due_now: "Totalt nu",
    book_review_eyebrow: "Bokningsöversikt",
    book_review_products_total: "Produkter totalt",
    book_review_question: "Vill du lägga till ytterligare en tjänst eller produkt, eller gå vidare till tidsbokning?",
    book_review_rest_at_salon: "Resterande hos Coiffeur Tattoo 01&Co.",
    book_review_services_total: "Tjänster totalt",
    book_review_split_note: "För tjänster betalar du nu 50 % som handpenning, resten bekvämt hos oss. Produkter betalas online i sin helhet.",
    book_review_summary: "Översikt",
    book_review_title: "Nästan klart — vill du lägga till något mer?",
    book_review_your_products: "Dina produkter",
    book_review_your_services: "Dina tjänster",
    book_schedule_hint: "Total tid:",
    book_selected_service: "Vald tjänst",
    book_send_request: "Skicka förfrågan",
    book_sending: "Skickar…",
    book_size: "Storlek",
    book_size_large: "Stor (över 20 cm)",
    book_size_medium: "Mellan (10–20 cm)",
    book_size_small: "Liten (upp till 10 cm)",
    book_state_blocked_hover: "⚫ Inte tillgänglig — stängt eller blockerat",
    book_state_booked_hover: "🔴 Upptagen — redan bokad",
    book_state_free_hover: "🟢 Ledig — kan bokas",
    book_state_mine_hover: "🔵 Din tid",
    book_state_needs_conf_hover: "🟠 Väntar på bekräftelse",
    book_state_pending_hover: "🟡 Pågår — bokning under bearbetning",
    book_state_too_soon_hover: "⚫ För snart — minst 30 min framförhållning",
    book_status_blocked: "Blockerad",
    book_status_booked: "Upptagen",
    book_status_free: "Ledig",
    book_status_mine: "Din bokning",
    book_status_needs_conf: "Väntar på bekräftelse",
    book_status_pending: "Under behandling",
    book_step_done: "Klar",
    book_step_info: "Uppgifter",
    book_step_service: "Tjänst",
    book_step_time: "Tid",
    book_submit_booking: "Bekräfta bokning",
    book_tattoo_no_price: "Inget fast pris. Beskriv ditt önskade motiv – vi kontaktar dig för pris och tid.",
    book_tattoo_title: "Tatueringsförfrågan",
    book_termin_agreement: "Enligt överenskommelse",
    book_visit_hint: "Vi ser fram emot ditt besök. Resterande belopp betalas hos oss.",
    book_will_contact: "Vi kontaktar dig inom kort för pris och tid.",
    book_your_cart: "Ditt val",
    book_your_info: "Dina uppgifter",
    book_your_visit: "Ditt besök",
    booking_eyebrow: "Tidbokning",
    booking_title: "Boka din tid",
    brand_tagline: "Hår & Skönhet sedan 2011",
    buy_now: "Köp nu",
    cart_added: "Tillagd",
    cart_apply: "Använd",
    cart_checkout: "Till kassan",
    cart_continue: "Fortsätt handla",
    cart_discount: "Rabatt",
    cart_discount_applied: "Rabatt tillagd",
    cart_discount_code: "Rabattkod",
    cart_discount_invalid: "Ogiltig rabattkod",
    cart_empty: "Din varukorg är tom.",
    cart_remove: "Ta bort",
    cart_shipping: "Frakt",
    cart_subtotal: "Delsumma",
    cart_tax_note: "Moms beräknas vid kassan",
    cart_title: "Varukorg",
    cart_total: "Totalt",
    cat_henna: "Henna",
    cat_miswak: "Miswak",
    change_password: "Ändra lösenord",
    channel_email: "E-post",
    channel_phone: "Telefon",
    channel_whatsapp: "WhatsApp",
    checkout_address: "Gata & nr.",
    checkout_apartment: "Lägenhet / Våning (valfritt)",
    checkout_billing: "Fakturaadress",
    checkout_billing_same: "Fakturaadress samma som leverans",
    checkout_city: "Stad",
    checkout_contact: "Kontakt",
    checkout_country: "Land",
    checkout_email: "E-post",
    checkout_first_name: "Förnamn",
    checkout_hold_expired_action: "Välj ny tid",
    checkout_hold_expired_body: "Tidsbokningen har släppts och kan ha valts av någon annan under tiden. Vänligen välj en ny tid.",
    checkout_hold_expired_title: "Din reservation har löpt ut",
    checkout_hold_expiring: "Reservationen löper snart ut",
    checkout_hold_hint: "Din valda tid är reserverad för dig. Vänligen slutför betalningen innan tiden löper ut.",
    checkout_hold_title: "Din reservation",
    checkout_last_name: "Efternamn",
    checkout_name: "Fullständigt namn",
    checkout_notes: "Orderkommentarer (valfritt)",
    checkout_pay_in_store: "Betala hos oss",
    checkout_pay_in_store_deposit_hint: "För tidsbokning krävs en handpenning online. Resterande belopp betalas hos oss.",
    checkout_pay_in_store_hint: "Reservera nu, betala kontant eller med kort vid avhämtning hos oss (Kirchweg 20, Glarus).",
    checkout_pay_online: "Betala online",
    checkout_pay_online_hint: "Kort, TWINT, Apple Pay, Klarna – säkert via Stripe.",
    checkout_payment: "Betalning",
    checkout_phone: "Telefon (valfritt)",
    checkout_place_order: "Fortsätt till betalning",
    checkout_postal: "Postnummer",
    checkout_return_pledge_label: "Jag förbinder mig att inte öppna eller använda produkten om jag vill returnera den.",
    checkout_return_pledge_required: "Vänligen bekräfta returlöftet för att fortsätta.",
    checkout_return_policy_body: "Enligt våra butiksregler kan en produkt som öppnats eller använts inte returneras.",
    checkout_return_policy_title: "Returrätt — vänligen läs",
    checkout_review: "Granska",
    checkout_secure_note: "Säker Stripe-kassa.",
    checkout_shipping: "Leveransadress",
    checkout_street: "Gatuadress & nummer",
    checkout_title: "Kassa",
    consultation_intro: "Vi ger dig gärna personlig rådgivning.",
    consultation_msg: "Din fråga / ditt ärende",
    consultation_preferred: "Föredragen kontakt",
    consultation_preferred_time: "Önskad tid",
    consultation_subject: "Ämne",
    consultation_submit: "Skicka förfrågan",
    consultation_thanks: "Tack – vi kontaktar dig inom kort.",
    consultation_title: "Boka rådgivning",
    contact_address: "Adress",
    contact_email: "E-post",
    contact_form_title: "Skriv till oss",
    contact_hours: "Öppettider",
    contact_message: "Ditt meddelande",
    contact_phone: "Telefon",
    contact_send: "Skicka meddelande",
    contact_short: "Kirchweg 20 · 8750 Glarus · Schweiz",
    contact_thanks: "Tack – vi hör av oss.",
    contact_title: "Kontakt",
    cookie_accept: "Acceptera",
    cookie_decline: "Endast nödvändiga",
    cookie_msg: "Denna webbplats använder endast tekniska cookies och – med ditt samtycke – anonym statistik.",
    copyright: "Alla rättigheter förbehållna.",
    current_password: "Nuvarande lösenord",
    delete_account: "Radera konto",
    delete_confirm: "Vill du verkligen radera kontot permanent?",
    email: "E-post",
    footer_agb: "Villkor",
    footer_brand: "Varumärke",
    footer_cookies: "Cookies",
    footer_datenschutz: "Integritet",
    footer_faq: "FAQ",
    footer_help: "Hjälp",
    footer_impressum: "Utgivare",
    footer_legal: "Juridiskt",
    footer_returns: "Returer",
    footer_shipping: "Frakt",
    footer_shop: "Butik",
    forgot_password: "Glömt lösenord?",
    founder_label: "Grundare",
    free_shipping_over: "Fri frakt över CHF 100",
    hero_cta: "Utforska kollektionen",
    hero_secondary: "Vår historia",
    hero_subtitle: "Premium hår-, skägg- och hudvård, naturliga oljor, Aleppo-tvål, miswak, henna och mer – utvalt av Coiffeur Tattoo 01&Co. i Glarus.",
    hero_title: "Schweiziskt hantverk. Naturlig omvårdnad.",
    home_studio_alt: "Coiffeur Tattoo 01&Co. studio i Glarus",
    ingredients: "Ingredienser",
    login: "Logga in",
    login_with_google: "Logga in med Google",
    logout: "Logga ut",
    medical_disclaimer: "Våra produkter ersätter inte professionell medicinsk rådgivning.",
    missing_token_error: "Token saknas.",
    my_orders: "Mina beställningar",
    my_profile: "Min profil",
    nav_about: "Om oss",
    nav_account: "Konto",
    nav_admin: "Admin",
    nav_cart: "Varukorg",
    nav_consultation: "Rådgivning",
    nav_contact: "Kontakt",
    nav_home: "Hem",
    nav_shop: "Shop",
    nav_tracking: "Spåra order",
    nav_wishlist: "Önskelista",
    new_badge: "Ny",
    new_password: "Nytt lösenord",
    newsletter_desc: "Nyheter och exklusiva erbjudanden.",
    newsletter_label: "Nyhetsbrev",
    newsletter_placeholder: "Din e-post",
    newsletter_submit: "Prenumerera",
    newsletter_title: "Bli inspirerad.",
    no_questions: "Inga frågor ännu.",
    no_reviews: "Inga recensioner ännu.",
    order_number: "Ordernummer",
    order_status_cancelled: "Avbruten",
    order_status_delivered: "Levererad",
    order_status_paid: "Betald",
    order_status_pending: "Väntar",
    order_status_processing: "Behandlas",
    order_status_refunded: "Återbetald",
    order_status_shipped: "Skickad",
    order_tracking_email: "E-postadress",
    order_tracking_intro: "Ange ordernummer och e-post.",
    order_tracking_not_found: "Order hittades inte.",
    order_tracking_number: "Ordernummer",
    order_tracking_submit: "Spåra",
    order_tracking_title: "Spåra order",
    otp_expires_hint: "Koden är giltig i 10 minuter. Kontrollera eventuellt din skräppost.",
    otp_heading: "Ange din kod",
    otp_invalid: "Felaktig kod. Vänligen försök igen.",
    otp_resend: "Skicka kod igen",
    otp_resent: "Ny kod har skickats.",
    otp_sent: "Vi har skickat en kod till din e-post.",
    otp_sent_to: "Vi har skickat en 6-siffrig kod till:",
    otp_title: "E-postbekräftelse",
    otp_verified: "E-post bekräftad – välkommen!",
    otp_verify: "Bekräfta",
    out_of_stock: "Slutsåld",
    password: "Lösenord",
    payment_cancel: "Betalning avbruten",
    payment_cancel_msg: "Betalning avbruten. Du kan försöka igen.",
    payment_success: "Betalning genomförd",
    payment_success_msg: "Tack för din beställning!",
    payments_title: "Betalningsinformation",
    phone_label: "Telefon",
    price: "Pris",
    qa_disclaimer: "Åsikter är personliga erfarenheter och inte medicinsk rådgivning.",
    qa_login_required: "Logga in för att fråga eller svara.",
    quantity: "Antal",
    question_pending: "Din fråga granskas.",
    questions_title: "Frågor & Svar",
    reason_natural: "Naturliga ingredienser",
    reason_natural_desc: "Vi väljer varje olja med omsorg.",
    reason_secure: "Säker betalning",
    reason_secure_desc: "Krypterad med Stripe.",
    reason_shipping: "Frakt över hela världen",
    reason_shipping_desc: "Fri frakt över CHF 100.",
    reason_swiss: "Schweiziskt varumärke",
    reason_swiss_desc: "Grundat i Glarus – hantverk du kan känna.",
    register: "Registrera",
    related_products: "Liknande produkter",
    report_content: "Anmäl",
    reset_link_sent: "Om ett konto finns har en länk skapats.",
    reset_password: "Återställ lösenord",
    reset_success: "Lösenord återställt.",
    ret_created: "Din returförfrågan har skapats.",
    ret_error: "Förfrågan kunde inte skapas.",
    ret_existing_hint: "Vi hör av oss med nästa steg.",
    ret_existing_title: "Returstatus",
    ret_info_inspected: "Granskad den",
    ret_info_order: "Ordernummer",
    ret_info_products: "Returnerade produkter",
    ret_info_products_all: "Hela beställningen",
    ret_info_received: "Mottagen den",
    ret_info_refunded: "Återbetald den",
    ret_info_requested: "Begärd den",
    ret_inspection_failed_hint: "Efter granskning kunde vi tyvärr inte godkänna din retur. Vänligen kontakta oss vid frågor.",
    ret_modal_intro: "För att din produkt ska kunna returneras får den varken ha öppnats eller använts.",
    ret_modal_title: "Returnera produkt",
    ret_only_delivered: "Retur möjlig när beställningen har levererats.",
    ret_pledge_label: "Jag bekräftar att produkten inte har öppnats eller använts och att jag returnerar den i samma skick som jag mottog den.",
    ret_pledge_required: "Vänligen bekräfta returlöftet.",
    ret_reason_changed_mind: "Jag har ändrat mig",
    ret_reason_damaged: "Produkten är skadad",
    ret_reason_group_customer: "Personlig anledning",
    ret_reason_group_product: "Problem med produkten eller beställningen",
    ret_reason_no_longer_needed: "Jag behöver den inte längre",
    ret_reason_order_error: "Fel i beställningen",
    ret_reason_other: "Annan anledning",
    ret_reason_other_issue: "Ett annat problem med produkten",
    ret_reason_placeholder: "Vänligen beskriv anledningen…",
    ret_reason_shipping_damage: "Den anlände skadad",
    ret_reason_wrong_choice: "Jag valde fel produkt av misstag",
    ret_reason_wrong_item: "Den levererade produkten motsvarar inte beställningen",
    ret_refund_amount: "Återbetalningsbelopp",
    ret_refund_bank_note: "Hur lång tid det tar innan beloppet syns på ditt konto beror på din bank eller kortutgivare och kan ta flera arbetsdagar.",
    ret_refund_issue_body: "Återbetalningen kunde inte slutföras ännu och behandlas vidare. Du behöver inte göra något — vid frågor når du oss på info@01co.ch.",
    ret_refund_status_failed: "Återbetalning behandlas fortfarande",
    ret_refund_status_processing: "Återbetalning behandlas",
    ret_refund_status_succeeded: "Återbetalning genomförd",
    ret_request_btn: "Begär retur",
    ret_resolution_free: "Fri retur · Frakt betalas av Coiffeur Tattoo 01&Co.",
    ret_resolution_paid: "Kundbetald retur · Frakt på din bekostnad",
    ret_rma_code: "RMA-kod",
    ret_status_approved: "Retur godkänd",
    ret_status_rejected: "Retur avvisad",
    ret_status_requested: "Retur begärd",
    ret_status_under_review: "Under granskning",
    ret_step_inspected: "Produkt granskad",
    ret_step_received: "Retur mottagen",
    ret_step_refund_complete: "Återbetalning slutförd",
    ret_step_refund_initiated: "Återbetalning påbörjad",
    ret_step_refund_issue: "Återbetalning — problem",
    ret_step_rejected: "Retur avvisad",
    ret_step_requested: "Retur begärd",
    ret_submit: "Skicka förfrågan",
    review_body: "Din upplevelse",
    review_pending: "Din recension har skickats in och granskas.",
    review_rating: "Betyg",
    review_title: "Titel",
    reviews: "Recensioner",
    sale_badge: "Rea",
    save: "Spara",
    saved: "Sparad",
    search_placeholder: "Sök produkter…",
    section_bestsellers: "Bästsäljare",
    section_featured: "Utvalda",
    section_new: "Nyheter",
    section_oils: "Naturliga oljor",
    section_why_title: "Varför Coiffeur Tattoo 01&Co.",
    since_2011: "Sedan 2011",
    size: "Storlek",
    stock_in: "I lager",
    stock_low: "Få kvar",
    stock_low_1: "Nästan slutsåld — endast 1 exemplar kvar",
    stock_low_2: "Nästan slutsåld — endast 2 exemplar kvar",
    stock_low_3: "Nästan slutsåld — endast 3 exemplar kvar",
    stock_low_4: "Nästan slutsåld — endast 4 exemplar kvar",
    stock_out: "Slutsåld",
    stock_setup: "Ej tillgänglig för tillfället",
    submit_answer: "Skicka svar",
    submit_question: "Skicka fråga",
    submit_review: "Skicka recension",
    suitable_bart: "Skägg",
    suitable_for: "Passar för",
    suitable_gesicht: "Ansikte",
    suitable_haare: "Hår",
    suitable_haut: "Hud",
    suitable_koerper: "Kropp",
    time_remaining_label: "Återstående tid",
    tracking_carrier: "Fraktbolag",
    tracking_link: "Spåra hos leverantör",
    tracking_number: "Spårningsnr.",
    usage: "Användning",
    variant: "Variant",
    verified_purchase: "Verifierat köp",
    view_all: "Visa alla",
    view_details: "Visa detaljer",
    warnings: "Anmärkningar",
    welcome: "Välkommen",
    wishlist_add: "Lägg till på önskelista",
    wishlist_empty: "Din önskelista är tom.",
    wishlist_login: "Logga in för att använda önskelistan.",
    wishlist_remove: "Ta bort från önskelista",
    wishlist_title: "Önskelista",
    write_review: "Skriv recension",
      cat_bartpflege: "Skäggvård",
    cat_haarpflege: "Hårvård",
    cat_sets_bundles: "Set & Paket",
},
  hr: {
    about_address: "Kirchweg 20, 8750 Glarus, Švicarska",
    about_founder: "Osnivač: Sajjad Al-Daghir",
    about_intro: "Švicarski brend iz Glarusa – stil i kvaliteta od 2011.",
    about_philosophy_body: "Vjerujemo da su prirodni proizvodi više od proizvoda – oni su veza između ljudi, prirode i tradicionalnog znanja.",
    about_philosophy_title: "Naša filozofija",
    about_title: "Coiffeur Tattoo 01&Co.",
    about_values_title: "Prirodno. Autentično. Pažljivo odabrano.",
    add_to_cart: "Dodaj u košaricu",
    address_label: "Adresa",
    admin_analytics: "Analitika",
    admin_avg: "Ø Vrijednost narudžbe",
    admin_consultations: "Zahtjevi za savjetovanje",
    admin_customers: "Kupci",
    admin_discounts: "Popusti",
    admin_orders: "Narudžbe",
    admin_products: "Proizvodi",
    admin_questions: "Pitanja",
    admin_revenue: "Prihod",
    admin_reviews: "Recenzije",
    admin_title: "Admin ploča",
    admin_total_orders: "Ukupno narudžbi",
    answer_placeholder: "Odgovori…",
    aria_account: "Račun",
    aria_basra: "Basra asistent",
    aria_cart: "Košarica",
    aria_close: "Zatvori",
    aria_loading: "Učitavanje…",
    aria_logo_home: "Coiffeur Tattoo 01&Co. Početna stranica",
    aria_menu: "Izbornik",
    aria_remove: "Ukloni",
    aria_send: "Pošalji",
    aria_wishlist: "Lista želja",
    ask_placeholder: "Vaše pitanje …",
    ask_question: "Postavi pitanje",
    auth_error: "Greška pri prijavi.",
    auth_or: "ili",
    benefits: "Prednosti",
    bestseller_badge: "Najprodavanije",
    book_add: "Dodaj",
    book_added_to_cart: "Dodano u rezervaciju",
    book_appointment_nr: "Broj termina",
    book_appointment_time: "Termin",
    book_autofilled: "Automatski popunjeno",
    book_back: "Natrag",
    book_booking_confirmed: "Termin potvrđen",
    book_booking_processing: "Rezervacija u tijeku…",
    book_cancel_policy: "Uvjeti otkazivanja",
    book_cart_empty: "Još nisu odabrane usluge.",
    book_cat_kids: "Djeca i mladi",
    book_cat_men: "Muškarci",
    book_cat_tattoo: "Tetovaža",
    book_cat_unisex: "Unisex",
    book_cat_women: "Dame",
    book_colors: "Boje",
    book_customer_eyebrow: "Vaši podaci",
    book_customer_hint: "Molimo ispunite jednokratno — pri sljedećem posjetu vaši podaci bit će automatski preuzeti.",
    book_datetime: "Vrijeme",
    book_deposit_note_body: "Polog se zadržava prema našim pravilima o otkazivanju i kašnjenju: u slučaju otkazivanja manje od 24 sata prije termina, kod rezervacija isti dan, nedolaska te kašnjenja većeg od 5 minuta bez pravovremene telefonske najave. Kod pravovremenog otkazivanja (≥ 24 h) polog se u potpunosti vraća.",
    book_deposit_note_title: "Važna napomena o pologu (50%)",
    book_deposit_required: "Za usluge je potrebna online uplata pologa. Nastavak na Stripe …",
    book_description: "Opis",
    book_edit: "Promijeni",
    book_email_confirmation: "Poslali smo Vam potvrdu putem e-pošte.",
    book_error_booking: "Greška pri rezervaciji",
    book_error_generic: "Greška",
    book_fill_required: "Molimo ispunite sva obavezna polja.",
    book_full_name: "Puno ime",
    book_lines: "Linije",
    book_loading_details: "Učitavanje detalja …",
    book_login_hint: "Savjet: Prijavite se kako bismo sljedeći put automatski preuzeli vaše podatke.",
    book_multi_hint: "Odaberite željeni broj usluga iz svake kategorije. Datum i vrijeme određujete u sljedećem koraku.",
    book_next: "Dalje",
    book_no_slots: "Nema slobodnih termina za ovaj dan.",
    book_payment_breakdown: "Pregled plaćanja",
    book_phone_num: "Telefon",
    book_pick_date: "Odaberi datum",
    book_pick_length: "Odaberi dužinu",
    book_pick_time: "Odaberite vrijeme",
    book_placeholder_colors: "Boje (npr. crna, u boji …)",
    book_placeholder_desc: "Opis motiva …",
    book_placeholder_lines: "Linije (npr. fine, debele …)",
    book_policy_5min: "Kod kašnjenja duljeg od 5 minuta bez prethodne telefonske najave naplaćuje se naknada (50 %). Ako nas nazovete unutar 5 minuta, termin se može produljiti bez dodatnih troškova.",
    book_policy_free_6h: "Besplatno otkazivanje do 6 sati prije termina kod frizera (tetovaža: 24 sata).",
    book_policy_late_fee: "U slučaju kasnijeg otkazivanja naplaćuje se 50 % cijene kao naknada.",
    book_policy_within_6h: "Termini u sljedećih 6 sati više se ne mogu otkazati.",
    book_preferred_time: "Željeni termin (nije obavezno)",
    book_price: "Cijena",
    book_price_from: "od",
    book_price_on_request: "Cijena na upit",
    book_remove: "Ukloni",
    book_request_sent: "Upit poslan",
    book_reservation: "Rezervacija",
    book_review_add_product: "Dodaj proizvod",
    book_review_add_service: "Dodatna usluga",
    book_review_continue_pay: "Nastavak na plaćanje",
    book_review_continue_schedule: "Nastavak na izbor termina",
    book_review_deposit_now: "Polog sada",
    book_review_due_now: "Ukupan iznos sada",
    book_review_eyebrow: "Pregled rezervacije",
    book_review_products_total: "Proizvodi ukupno",
    book_review_question: "Želite li dodati dodatnu uslugu ili proizvod, ili izravno na izbor termina?",
    book_review_rest_at_salon: "Preostali iznos u salonu",
    book_review_services_total: "Usluge ukupno",
    book_review_split_note: "Za usluge plaćate sada 50 % kao polog, ostatak u salonu. Proizvodi se plaćaju u potpunosti online.",
    book_review_summary: "Pregled",
    book_review_title: "Gotovo — želite li još nešto dodati?",
    book_review_your_products: "Vaši proizvodi",
    book_review_your_services: "Vaše usluge",
    book_schedule_hint: "Ukupno trajanje:",
    book_selected_service: "Odabrana usluga",
    book_send_request: "Pošalji upit",
    book_sending: "Slanje u tijeku…",
    book_size: "Veličina",
    book_size_large: "Veliko (preko 20 cm)",
    book_size_medium: "Srednje (10–20 cm)",
    book_size_small: "Malo (do 10 cm)",
    book_state_blocked_hover: "⚫ Nije dostupno — zatvoreno ili blokirano",
    book_state_booked_hover: "🔴 Zauzeto — već rezervirano",
    book_state_free_hover: "🟢 Slobodno — može se rezervirati",
    book_state_mine_hover: "🔵 Vaš termin",
    book_state_needs_conf_hover: "🟠 Čeka potvrdu",
    book_state_pending_hover: "🟡 U tijeku — rezervacija u obradi",
    book_state_too_soon_hover: "⚫ Prerano — najmanje 30 min unaprijed",
    book_status_blocked: "Blokirano",
    book_status_booked: "Zauzeto",
    book_status_free: "Slobodno",
    book_status_mine: "Vaš termin",
    book_status_needs_conf: "Čeka potvrdu",
    book_status_pending: "U obradi",
    book_step_done: "Gotovo",
    book_step_info: "Podaci",
    book_step_service: "Usluga",
    book_step_time: "Termin",
    book_submit_booking: "Potvrdi rezervaciju",
    book_tattoo_no_price: "Nema fiksne cijene. Opišite željeni motiv – kontaktirat ćemo vas za cijenu i termin.",
    book_tattoo_title: "Upit za tetovažu",
    book_termin_agreement: "Po dogovoru",
    book_visit_hint: "Radujemo se vašem dolasku. Preostali iznos plaća se u salonu.",
    book_will_contact: "Uskoro ćemo vas kontaktirati za cijenu i termin.",
    book_your_cart: "Vaš odabir",
    book_your_info: "Vaši podaci",
    book_your_visit: "Vaš posjet",
    booking_eyebrow: "Rezervacija termina",
    booking_title: "Rezervirajte svoj termin",
    brand_tagline: "Kosa i ljepota od 2011.",
    buy_now: "Kupi odmah",
    cart_added: "Dodano",
    cart_apply: "Primijeni",
    cart_checkout: "Na naplatu",
    cart_continue: "Nastavi kupovinu",
    cart_discount: "Popust",
    cart_discount_applied: "Popust primijenjen",
    cart_discount_code: "Kod za popust",
    cart_discount_invalid: "Kod za popust nije važeći",
    cart_empty: "Vaša košarica je prazna.",
    cart_remove: "Ukloni",
    cart_shipping: "Dostava",
    cart_subtotal: "Međuzbroj",
    cart_tax_note: "PDV se obračunava pri naplati",
    cart_title: "Košarica",
    cart_total: "Ukupno",
    cat_miswak: "Miswak",
    change_password: "Promijeni lozinku",
    channel_email: "E-pošta",
    channel_phone: "Telefon",
    channel_whatsapp: "WhatsApp",
    checkout_address: "Ulica i broj",
    checkout_apartment: "Stan / kat (neobavezno)",
    checkout_billing: "Adresa za račun",
    checkout_billing_same: "Adresa za račun ista kao dostava",
    checkout_city: "Grad",
    checkout_contact: "Kontakt",
    checkout_country: "Država",
    checkout_email: "E-pošta",
    checkout_first_name: "Ime",
    checkout_hold_expired_action: "Odaberite novi termin",
    checkout_hold_expired_body: "Termin je oslobođen i možda ga je netko drugi već odabrao. Molimo odaberite novo vrijeme.",
    checkout_hold_expired_title: "Vaša rezervacija je istekla",
    checkout_hold_expiring: "Rezervacija uskoro ističe",
    checkout_hold_hint: "Vaš odabrani termin rezerviran je za vas. Molimo dovršite plaćanje prije isteka.",
    checkout_hold_title: "Vaša rezervacija",
    checkout_last_name: "Prezime",
    checkout_name: "Puno ime i prezime",
    checkout_notes: "Napomene uz narudžbu (neobavezno)",
    checkout_pay_in_store: "Plaćanje u salonu",
    checkout_pay_in_store_deposit_hint: "Za termine je potrebna online uplata pologa. Preostali iznos plaća se u salonu.",
    checkout_pay_in_store_hint: "Rezervirajte sada, platite gotovinom ili karticom pri preuzimanju u salonu (Kirchweg 20, Glarus).",
    checkout_pay_online: "Online plaćanje",
    checkout_pay_online_hint: "Kartica, TWINT, Apple Pay, Klarna – sigurno putem Stripe.",
    checkout_payment: "Plaćanje",
    checkout_phone: "Telefon (neobavezno)",
    checkout_place_order: "Nastavi na plaćanje",
    checkout_postal: "Poštanski broj",
    checkout_return_pledge_label: "Obvezujem se da neću otvoriti niti koristiti proizvod ako ga želim vratiti.",
    checkout_return_pledge_required: "Molimo potvrdite obvezu za povrat kako biste nastavili.",
    checkout_return_policy_body: "Prema našim pravilima prodavaonice, proizvod koji je otvoren ili korišten ne može se vratiti.",
    checkout_return_policy_title: "Pravo na povrat – molimo pročitajte",
    checkout_review: "Pregled",
    checkout_secure_note: "Sigurno Stripe plaćanje.",
    checkout_shipping: "Adresa za dostavu",
    checkout_street: "Ulica i kućni broj",
    checkout_title: "Naplata",
    consultation_intro: "Rado ćemo vas savjetovati.",
    consultation_msg: "Vaše pitanje / potreba",
    consultation_preferred: "Preferirani kontakt",
    consultation_preferred_time: "Željeni termin",
    consultation_subject: "Tema",
    consultation_submit: "Pošalji upit",
    consultation_thanks: "Hvala – uskoro ćemo vas kontaktirati.",
    consultation_title: "Zatraži savjetovanje",
    contact_address: "Adresa",
    contact_email: "E-mail",
    contact_form_title: "Pišite nam",
    contact_hours: "Radno vrijeme",
    contact_message: "Vaša poruka",
    contact_phone: "Telefon",
    contact_send: "Pošalji poruku",
    contact_thanks: "Hvala – javit ćemo se uskoro.",
    contact_title: "Kontakt",
    cookie_accept: "Prihvati",
    cookie_decline: "Samo nužni",
    cookie_msg: "Ova stranica koristi samo tehničke kolačiće i, uz vaš pristanak, anonimne statistike.",
    copyright: "Sva prava pridržana.",
    current_password: "Trenutna lozinka",
    delete_account: "Obriši račun",
    delete_confirm: "Želite li zaista trajno izbrisati račun?",
    email: "E-mail",
    footer_agb: "Uvjeti poslovanja",
    footer_brand: "Brend",
    footer_cookies: "Kolačići",
    footer_datenschutz: "Privatnost",
    footer_faq: "Česta pitanja",
    footer_help: "Pomoć",
    footer_impressum: "Impresum",
    footer_legal: "Pravne informacije",
    footer_returns: "Povrat",
    footer_shipping: "Dostava",
    footer_shop: "Trgovina",
    forgot_password: "Zaboravili ste lozinku?",
    founder_label: "Osnivač",
    free_shipping_over: "Besplatna dostava iznad CHF 100",
    hero_cta: "Istražite kolekciju",
    hero_secondary: "Naša priča",
    hero_subtitle: "Premium njega za kosu, bradu i kožu, prirodna ulja, Aleppo sapun, miswak, kana i više – odabir tima Coiffeur Tattoo 01&Co. u Glarusu.",
    hero_title: "Švicarski zanat. Prirodna njega.",
    home_studio_alt: "Coiffeur Tattoo 01&Co. studio u Glasusu",
    ingredients: "Sastojci",
    login: "Prijava",
    login_with_google: "Prijava putem Google",
    logout: "Odjava",
    medical_disclaimer: "Naši proizvodi ne zamjenjuju stručan medicinski savjet.",
    missing_token_error: "Token nedostaje.",
    my_orders: "Moje narudžbe",
    my_profile: "Moj profil",
    nav_about: "O nama",
    nav_account: "Račun",
    nav_admin: "Admin",
    nav_cart: "Košarica",
    nav_consultation: "Savjetovanje",
    nav_contact: "Kontakt",
    nav_home: "Početna",
    nav_shop: "Trgovina",
    nav_tracking: "Praćenje narudžbe",
    nav_wishlist: "Lista želja",
    new_badge: "Novo",
    new_password: "Nova lozinka",
    newsletter_desc: "Novosti i ekskluzivne ponude.",
    newsletter_label: "Newsletter",
    newsletter_placeholder: "Vaša e-pošta",
    newsletter_submit: "Pretplatite se",
    newsletter_title: "Ostanite inspirirani.",
    no_questions: "Još nema pitanja.",
    no_reviews: "Još nema recenzija.",
    order_number: "Broj narudžbe",
    order_status_cancelled: "Otkazano",
    order_status_delivered: "Dostavljeno",
    order_status_paid: "Plaćeno",
    order_status_pending: "Na čekanju",
    order_status_processing: "U obradi",
    order_status_refunded: "Vraćeno",
    order_status_shipped: "Poslano",
    order_tracking_email: "E-mail adresa",
    order_tracking_intro: "Unesite broj narudžbe i e-poštu.",
    order_tracking_not_found: "Narudžba nije pronađena.",
    order_tracking_number: "Broj narudžbe",
    order_tracking_submit: "Prati",
    order_tracking_title: "Praćenje narudžbe",
    otp_expires_hint: "Kod vrijedi 10 minuta. Po potrebi provjerite mapu neželjene pošte.",
    otp_heading: "Unesite svoj kod",
    otp_invalid: "Pogrešan kod. Molimo pokušajte ponovno.",
    otp_resend: "Pošalji kod ponovno",
    otp_resent: "Novi kod je poslan.",
    otp_sent: "Poslali smo vam kod putem e-maila.",
    otp_sent_to: "Poslali smo 6-znamenkasti kod na:",
    otp_title: "Potvrda e-mail adrese",
    otp_verified: "E-mail potvrđen – dobrodošli!",
    otp_verify: "Potvrdi",
    out_of_stock: "Rasprodano",
    password: "Lozinka",
    payment_cancel: "Plaćanje otkazano",
    payment_cancel_msg: "Plaćanje je otkazano. Možete pokušati ponovno.",
    payment_success: "Uspješno plaćanje",
    payment_success_msg: "Hvala na narudžbi!",
    payments_title: "Informacije o plaćanju",
    phone_label: "Telefon",
    price: "Cijena",
    qa_disclaimer: "Mišljenja su osobna iskustva i ne zamjenjuju medicinski savjet.",
    qa_login_required: "Prijavite se za pitanja i odgovore.",
    quantity: "Količina",
    question_pending: "Vaše pitanje se pregledava.",
    questions_title: "Pitanja i odgovori",
    reason_natural: "Prirodni sastojci",
    reason_natural_desc: "Svako ulje biramo s pažnjom.",
    reason_secure: "Sigurno plaćanje",
    reason_secure_desc: "Šifrirano putem Stripe.",
    reason_shipping: "Dostava u cijeli svijet",
    reason_shipping_desc: "Besplatna dostava od CHF 100.",
    reason_swiss: "Švicarski brend",
    reason_swiss_desc: "Osnovano u Glarusu – zanat koji se osjeća.",
    register: "Registracija",
    related_products: "Slični proizvodi",
    report_content: "Prijavi",
    reset_link_sent: "Ako račun postoji, poveznica je stvorena.",
    reset_password: "Resetiraj lozinku",
    reset_success: "Lozinka resetirana.",
    ret_created: "Vaš zahtjev za povrat je kreiran.",
    ret_error: "Zahtjev nije mogao biti kreiran.",
    ret_existing_hint: "Javit ćemo vam se sa sljedećim koracima.",
    ret_existing_title: "Status povrata",
    ret_info_inspected: "Pregledano",
    ret_info_order: "Broj narudžbe",
    ret_info_products: "Vraćeni proizvodi",
    ret_info_products_all: "Cijela narudžba",
    ret_info_received: "Primljeno",
    ret_info_refunded: "Refundirano",
    ret_info_requested: "Zatraženo",
    ret_inspection_failed_hint: "Nakon pregleda nažalost nismo mogli prihvatiti vaš povrat. Molimo kontaktirajte nas ako imate pitanja.",
    ret_modal_intro: "Kako bi vaš proizvod bio prihvatljiv za povrat, ne smije biti otvoren niti korišten.",
    ret_modal_title: "Vraćanje proizvoda",
    ret_only_delivered: "Povrat dostupan nakon dostave narudžbe.",
    ret_pledge_label: "Potvrđujem da proizvod nije otvoren niti korišten i da ga vraćam u stanju u kojem sam ga primio.",
    ret_pledge_required: "Molimo potvrdite obvezu za povrat.",
    ret_reason_changed_mind: "Predomislio/la sam se",
    ret_reason_damaged: "Proizvod je oštećen",
    ret_reason_group_customer: "Osobni razlog",
    ret_reason_group_product: "Problem s proizvodom ili narudžbom",
    ret_reason_no_longer_needed: "Više mi nije potreban",
    ret_reason_order_error: "Greška u narudžbi",
    ret_reason_other: "Drugi razlog",
    ret_reason_other_issue: "Drugi problem s proizvodom",
    ret_reason_placeholder: "Molimo opišite razlog…",
    ret_reason_shipping_damage: "Stigao je oštećen",
    ret_reason_wrong_choice: "Slučajno sam odabrao/la pogrešan proizvod",
    ret_reason_wrong_item: "Dostavljeni proizvod ne odgovara narudžbi",
    ret_refund_amount: "Iznos povrata novca",
    ret_refund_bank_note: "Koliko dugo će iznos biti vidljiv na vašem računu ovisi o vašoj banci ili izdavatelju kartice i može potrajati nekoliko radnih dana.",
    ret_refund_issue_body: "Povrat novca još nije mogao biti dovršen i nastavlja se obrađivati. Ne morate ništa poduzimati – za pitanja smo dostupni na info@01co.ch.",
    ret_refund_status_failed: "Povrat novca još se obrađuje",
    ret_refund_status_processing: "Povrat novca u obradi",
    ret_refund_status_succeeded: "Povrat novca izvršen",
    ret_request_btn: "Zatraži povrat",
    ret_resolution_free: "Besplatan povrat · Dostavu snosi salon",
    ret_resolution_paid: "Kupac plaća povrat · Dostava na vaš trošak",
    ret_rma_code: "RMA kod",
    ret_status_approved: "Povrat odobren",
    ret_status_rejected: "Povrat odbijen",
    ret_status_requested: "Povrat zatražen",
    ret_status_under_review: "U pregledu",
    ret_step_inspected: "Proizvod pregledan",
    ret_step_received: "Povrat primljen",
    ret_step_refund_complete: "Povrat novca dovršen",
    ret_step_refund_initiated: "Povrat novca pokrenut",
    ret_step_refund_issue: "Povrat novca – problem",
    ret_step_rejected: "Povrat odbijen",
    ret_step_requested: "Povrat zatražen",
    ret_submit: "Pošalji zahtjev",
    review_body: "Vaše iskustvo",
    review_pending: "Vaša recenzija je poslana i bit će pregledana.",
    review_rating: "Ocjena",
    review_title: "Naslov",
    reviews: "Recenzije",
    sale_badge: "Popust",
    save: "Spremi",
    saved: "Spremljeno",
    search_placeholder: "Pretraži proizvode…",
    section_bestsellers: "Najprodavanije",
    section_featured: "Izdvojeno",
    section_new: "Noviteti",
    section_oils: "Prirodna ulja",
    section_why_title: "Zašto Coiffeur Tattoo 01&Co.",
    since_2011: "Od 2011.",
    size: "Veličina",
    stock_in: "Na skladištu",
    stock_low: "Ograničena dostupnost",
    stock_low_1: "Skoro rasprodano — samo 1 komad dostupan",
    stock_low_2: "Skoro rasprodano — samo 2 komada dostupna",
    stock_low_3: "Skoro rasprodano — samo 3 komada dostupna",
    stock_low_4: "Skoro rasprodano — samo 4 komada dostupna",
    stock_out: "Rasprodano",
    stock_setup: "Trenutno nedostupno",
    submit_answer: "Pošalji odgovor",
    submit_question: "Pošalji pitanje",
    submit_review: "Pošalji recenziju",
    suitable_bart: "Brada",
    suitable_for: "Prikladno za",
    suitable_gesicht: "Lice",
    suitable_haare: "Kosa",
    suitable_haut: "Koža",
    suitable_koerper: "Tijelo",
    time_remaining_label: "Preostalo vrijeme",
    tracking_carrier: "Dostavljač",
    tracking_link: "Prati kod dostavljača",
    tracking_number: "Broj praćenja",
    usage: "Primjena",
    variant: "Varijanta",
    verified_purchase: "Potvrđena kupnja",
    view_all: "Pogledaj sve",
    view_details: "Pogledaj detalje",
    warnings: "Upozorenja",
    welcome: "Dobrodošli",
    wishlist_add: "Dodaj na popis želja",
    wishlist_empty: "Vaša lista želja je prazna.",
    wishlist_login: "Prijavite se za korištenje popisa želja.",
    wishlist_remove: "Ukloni s liste želja",
    wishlist_title: "Popis želja",
    write_review: "Napiši recenziju",
      cat_bartpflege: "Njega brade",
    cat_haarpflege: "Njega kose",
    cat_sets_bundles: "Setovi i paketi",
},
  sr: {
    about_address: "Kirchweg 20, 8750 Glarus, Švajcarska",
    about_founder: "Osnivač: Sajjad Al-Daghir",
    about_intro: "Švajcarski brend iz Glarusa – stil i kvalitet od 2011.",
    about_philosophy_body: "Verujemo da su prirodni proizvodi više od proizvoda – oni su veza između ljudi, prirode i tradicionalnog znanja.",
    about_philosophy_title: "Naša filozofija",
    about_title: "Coiffeur Tattoo 01&Co.",
    about_values_title: "Prirodno. Autentično. Pažljivo odabrano.",
    add_to_cart: "Dodaj u korpu",
    address_label: "Adresa",
    admin_analytics: "Analitika",
    admin_avg: "Ø Vrednost narudžbine",
    admin_consultations: "Zahtevi za konsultacije",
    admin_customers: "Kupci",
    admin_discounts: "Popusti",
    admin_orders: "Narudžbine",
    admin_products: "Proizvodi",
    admin_questions: "Pitanja",
    admin_revenue: "Prihod",
    admin_reviews: "Recenzije",
    admin_title: "Admin panel",
    admin_total_orders: "Ukupno narudžbina",
    answer_placeholder: "Odgovori…",
    aria_account: "Nalog",
    aria_basra: "Basra asistent",
    aria_cart: "Korpa",
    aria_close: "Zatvori",
    aria_loading: "Učitavanje…",
    aria_logo_home: "Coiffeur Tattoo 01&Co. početna stranica",
    aria_menu: "Meni",
    aria_remove: "Ukloni",
    aria_send: "Pošalji",
    aria_wishlist: "Lista želja",
    ask_placeholder: "Vaše pitanje…",
    ask_question: "Postavi pitanje",
    auth_error: "Greška pri prijavljivanju.",
    auth_or: "ili",
    benefits: "Prednosti",
    bestseller_badge: "Bestseler",
    book_add: "Dodaj",
    book_added_to_cart: "Dodato u rezervaciju",
    book_appointment_nr: "Broj termina",
    book_appointment_time: "Termin",
    book_autofilled: "Automatski popunjeno",
    book_back: "Nazad",
    book_booking_confirmed: "Termin potvrđen",
    book_booking_processing: "Rezerviše se…",
    book_cancel_policy: "Uslovi otkazivanja",
    book_cart_empty: "Još uvek nije izabrana nijedna usluga.",
    book_cat_kids: "Deca i omladina",
    book_cat_men: "Muškarci",
    book_cat_tattoo: "Tattoo",
    book_cat_unisex: "Unisex",
    book_cat_women: "Dame",
    book_colors: "Boje",
    book_customer_eyebrow: "Vaši podaci",
    book_customer_hint: "Molimo popunite jednokratno — pri sledećoj poseti vaši podaci će biti automatski preuzeti.",
    book_datetime: "Vreme",
    book_deposit_note_body: "Depozit se zadržava u skladu sa našom politikom otkazivanja i kašnjenja: pri otkazivanju manje od 24 sata pre termina, kod rezervacija istog dana, u slučaju nedolaska kao i pri kašnjenju dužem od 5 minuta bez blagovremene telefonske najave. Kod blagovremenog otkazivanja (≥ 24 h) depozit se u potpunosti vraća.",
    book_deposit_note_title: "Važna napomena o depozitu (50%)",
    book_deposit_required: "Za usluge je potrebna online uplata depozita. Nastavite na Stripe …",
    book_description: "Opis",
    book_edit: "Izmeni",
    book_email_confirmation: "Poslali smo vam potvrdu putem e-pošte.",
    book_error_booking: "Greška pri rezervaciji",
    book_error_generic: "Greška",
    book_fill_required: "Molimo popunite sva obavezna polja.",
    book_full_name: "Puno ime",
    book_lines: "Linije",
    book_loading_details: "Učitavanje detalja …",
    book_login_hint: "Savet: Prijavite se kako bismo automatski preuzeli vaše podatke pri sledećoj poseti.",
    book_multi_hint: "Izaberite proizvoljan broj usluga iz svake kategorije. Datum i vreme određujete u sledećem koraku.",
    book_next: "Dalje",
    book_no_slots: "Nema slobodnih termina za ovaj dan.",
    book_payment_breakdown: "Pregled uplate",
    book_phone_num: "Telefon",
    book_pick_date: "Izaberi datum",
    book_pick_length: "Izaberi dužinu",
    book_pick_time: "Izaberite vreme",
    book_placeholder_colors: "Boje (npr. crna, u boji …)",
    book_placeholder_desc: "Opis motiva …",
    book_placeholder_lines: "Linije (npr. fine, debele…)",
    book_policy_5min: "Kod kašnjenja dužeg od 5 minuta bez prethodne telefonske najave naplaćuje se naknada (50 %). Ako nas pozovete u okviru 5 minuta, termin se može produžiti bez dodatnih troškova.",
    book_policy_free_6h: "Besplatno otkazivanje do 6 sati pre termina kod frizera (tetovaža: 24 sata).",
    book_policy_late_fee: "U slučaju kasnijeg otkazivanja naplaćuje se 50 % cene kao naknada.",
    book_policy_within_6h: "Termini u narednih 6 sati više se ne mogu otkazati.",
    book_preferred_time: "Željeni termin (opciono)",
    book_price: "Cena",
    book_price_from: "od",
    book_price_on_request: "Cena na upit",
    book_remove: "Ukloni",
    book_request_sent: "Upit poslat",
    book_reservation: "Rezervacija",
    book_review_add_product: "Dodaj proizvod",
    book_review_add_service: "Dodatna usluga",
    book_review_continue_pay: "Nastavi na plaćanje",
    book_review_continue_schedule: "Nastavi na izbor termina",
    book_review_deposit_now: "Depozit sada",
    book_review_due_now: "Ukupan iznos sada",
    book_review_eyebrow: "Pregled rezervacije",
    book_review_products_total: "Ukupno proizvodi",
    book_review_question: "Želite li dodati još jednu uslugu ili proizvod, ili direktno preći na izbor termina?",
    book_review_rest_at_salon: "Preostali iznos u salonu",
    book_review_services_total: "Ukupno usluge",
    book_review_split_note: "Za usluge plaćate sada 50 % kao depozit, ostatak udobno u salonu. Proizvodi se plaćaju u potpunosti online.",
    book_review_summary: "Pregled",
    book_review_title: "Skoro gotovo — želite li još nešto dodati?",
    book_review_your_products: "Vaši proizvodi",
    book_review_your_services: "Vaše usluge",
    book_schedule_hint: "Ukupno trajanje:",
    book_selected_service: "Izabrana usluga",
    book_send_request: "Pošalji upit",
    book_sending: "Šalje se…",
    book_size: "Veličina",
    book_size_large: "Veliko (preko 20 cm)",
    book_size_medium: "Srednje (10–20 cm)",
    book_size_small: "Malo (do 10 cm)",
    book_state_blocked_hover: "⚫ Nije dostupno — zatvoreno ili blokirano",
    book_state_booked_hover: "🔴 Zauzeto — već rezervisano",
    book_state_free_hover: "🟢 Slobodno — može se rezervisati",
    book_state_mine_hover: "🔵 Vaš termin",
    book_state_needs_conf_hover: "🟠 Čeka potvrdu",
    book_state_pending_hover: "🟡 U toku — rezervacija u obradi",
    book_state_too_soon_hover: "⚫ Prerano — najmanje 30 min unapred",
    book_status_blocked: "Blokirano",
    book_status_booked: "Zauzeto",
    book_status_free: "Slobodno",
    book_status_mine: "Vaš termin",
    book_status_needs_conf: "Čeka potvrdu",
    book_status_pending: "U obradi",
    book_step_done: "Gotovo",
    book_step_info: "Podaci",
    book_step_service: "Usluga",
    book_step_time: "Termin",
    book_submit_booking: "Potvrdi rezervaciju",
    book_tattoo_no_price: "Nema fiksne cene. Opišite željeni motiv – kontaktiraćemo vas za cenu i termin.",
    book_tattoo_title: "Upit za tetovažu",
    book_termin_agreement: "Po dogovoru",
    book_visit_hint: "Radujemo se vašoj poseti. Preostali iznos se plaća u salonu.",
    book_will_contact: "Kontaktiraćemo vas uskoro za cenu i termin.",
    book_your_cart: "Vaš izbor",
    book_your_info: "Vaši podaci",
    book_your_visit: "Vaša poseta",
    booking_eyebrow: "Zakazivanje termina",
    booking_title: "Rezervišite svoj termin",
    brand_tagline: "Kosa i lepota od 2011.",
    buy_now: "Kupite sada",
    cart_added: "Dodato",
    cart_apply: "Primeni",
    cart_checkout: "Na naplatu",
    cart_continue: "Nastavite kupovinu",
    cart_discount: "Popust",
    cart_discount_applied: "Popust primenjen",
    cart_discount_code: "Kod za popust",
    cart_discount_invalid: "Kod za popust nije važeći",
    cart_empty: "Vaša korpa je prazna.",
    cart_remove: "Uklonite",
    cart_shipping: "Dostava",
    cart_subtotal: "Međuzbir",
    cart_tax_note: "PDV se obračunava pri plaćanju",
    cart_title: "Korpa",
    cart_total: "Ukupno",
    cat_miswak: "Miswak",
    change_password: "Promenite lozinku",
    channel_email: "E-mail",
    channel_phone: "Telefon",
    channel_whatsapp: "WhatsApp",
    checkout_address: "Ulica i broj",
    checkout_apartment: "Stan / sprat (opciono)",
    checkout_billing: "Adresa za naplatu",
    checkout_billing_same: "Adresa za račun ista kao dostava",
    checkout_city: "Grad",
    checkout_contact: "Kontakt",
    checkout_country: "Država",
    checkout_email: "E-mail",
    checkout_first_name: "Ime",
    checkout_hold_expired_action: "Izaberite novi termin",
    checkout_hold_expired_body: "Termin je oslobođen i možda ga je neko drugi u međuvremenu izabrao. Molimo izaberite novi termin.",
    checkout_hold_expired_title: "Vaša rezervacija je istekla",
    checkout_hold_expiring: "Rezervacija uskoro ističe",
    checkout_hold_hint: "Vaš izabrani termin je rezervisan za vas. Molimo završite plaćanje pre isteka roka.",
    checkout_hold_title: "Vaša rezervacija",
    checkout_last_name: "Prezime",
    checkout_name: "Puno ime",
    checkout_notes: "Napomene uz porudžbinu (opciono)",
    checkout_pay_in_store: "Platite u salonu",
    checkout_pay_in_store_deposit_hint: "Za termine je potrebna online uplata depozita. Preostali iznos se plaća u salonu.",
    checkout_pay_in_store_hint: "Rezervišite sada, platite gotovinom ili karticom pri preuzimanju u salonu (Kirchweg 20, Glarus).",
    checkout_pay_online: "Platite online",
    checkout_pay_online_hint: "Kartica, TWINT, Apple Pay, Klarna – sigurno preko Stripe.",
    checkout_payment: "Plaćanje",
    checkout_phone: "Telefon (opciono)",
    checkout_place_order: "Nastavi na plaćanje",
    checkout_postal: "Poštanski broj",
    checkout_return_pledge_label: "Obavezujem se da neću otvoriti niti koristiti proizvod ukoliko želim da ga vratim.",
    checkout_return_pledge_required: "Molimo potvrdite obavezu o vraćanju kako biste nastavili.",
    checkout_return_policy_body: "Prema pravilima naše prodavnice, proizvod koji je otvoren ili korišćen ne može biti vraćen.",
    checkout_return_policy_title: "Pravo na povraćaj – molimo pročitajte",
    checkout_review: "Pregled",
    checkout_secure_note: "Bezbedno Stripe plaćanje.",
    checkout_shipping: "Adresa za dostavu",
    checkout_street: "Ulica i kućni broj",
    checkout_title: "Naplata",
    consultation_intro: "Rado ćemo vas savetovati.",
    consultation_msg: "Vaše pitanje / želja",
    consultation_preferred: "Preferirani kontakt",
    consultation_preferred_time: "Željeni termin",
    consultation_subject: "Tema",
    consultation_submit: "Pošalji upit",
    consultation_thanks: "Hvala – kontaktiraćemo vas uskoro.",
    consultation_title: "Zatraži konsultaciju",
    contact_address: "Adresa",
    contact_email: "E-mail",
    contact_form_title: "Pišite nam",
    contact_hours: "Radno vreme",
    contact_message: "Vaša poruka",
    contact_phone: "Telefon",
    contact_send: "Pošaljite poruku",
    contact_thanks: "Hvala – javićemo vam se uskoro.",
    contact_title: "Kontakt",
    cookie_accept: "Prihvatam",
    cookie_decline: "Samo neophodne",
    cookie_msg: "Ovaj sajt koristi samo tehničke kolačiće i, uz vaš pristanak, anonimne statistike.",
    copyright: "Sva prava zadržana.",
    current_password: "Trenutna lozinka",
    delete_account: "Obriši nalog",
    delete_confirm: "Zaista želite da trajno izbrišete nalog?",
    email: "E-mail",
    footer_agb: "Uslovi poslovanja",
    footer_brand: "Brend",
    footer_cookies: "Kolačići",
    footer_datenschutz: "Privatnost",
    footer_faq: "Česta pitanja",
    footer_help: "Pomoć",
    footer_impressum: "Impresum",
    footer_legal: "Pravne informacije",
    footer_returns: "Povraćaj",
    footer_shipping: "Dostava",
    footer_shop: "Prodavnica",
    forgot_password: "Zaboravili ste lozinku?",
    founder_label: "Osnivač",
    free_shipping_over: "Besplatna dostava iznad CHF 100",
    hero_cta: "Istražite kolekciju",
    hero_secondary: "Naša priča",
    hero_subtitle: "Premium nega za kosu, bradu i kožu, prirodna ulja, Aleppo sapun, miswak, kana i više – izbor tima Coiffeur Tattoo 01&Co. u Glarusu.",
    hero_title: "Švajcarski zanat. Prirodna nega.",
    home_studio_alt: "Coiffeur Tattoo 01&Co. studio u Glarusu",
    ingredients: "Sastojci",
    login: "Prijava",
    login_with_google: "Prijavite se preko Google",
    logout: "Odjavi se",
    medical_disclaimer: "Naši proizvodi ne zamenjuju stručan medicinski savet.",
    missing_token_error: "Token nedostaje.",
    my_orders: "Moje porudžbine",
    my_profile: "Moj profil",
    nav_about: "O nama",
    nav_account: "Nalog",
    nav_admin: "Admin",
    nav_cart: "Korpa",
    nav_consultation: "Konsultacije",
    nav_contact: "Kontakt",
    nav_home: "Početna",
    nav_shop: "Prodavnica",
    nav_tracking: "Praćenje porudžbine",
    nav_wishlist: "Lista želja",
    new_badge: "Novo",
    new_password: "Nova lozinka",
    newsletter_desc: "Novosti i ekskluzivne ponude.",
    newsletter_label: "Bilten",
    newsletter_placeholder: "Vaš e-mail",
    newsletter_submit: "Pretplati se",
    newsletter_title: "Ostanite inspirisani.",
    no_questions: "Još nema pitanja.",
    no_reviews: "Još nema recenzija.",
    order_number: "Broj porudžbine",
    order_status_cancelled: "Otkazano",
    order_status_delivered: "Isporučeno",
    order_status_paid: "Plaćeno",
    order_status_pending: "Na čekanju",
    order_status_processing: "U obradi",
    order_status_refunded: "Refundirano",
    order_status_shipped: "Poslato",
    order_tracking_email: "E-mail adresa",
    order_tracking_intro: "Unesite broj porudžbine i e-mail.",
    order_tracking_not_found: "Porudžbina nije pronađena.",
    order_tracking_number: "Broj porudžbine",
    order_tracking_submit: "Prati",
    order_tracking_title: "Praćenje porudžbine",
    otp_expires_hint: "Kod važi 10 minuta. Proverite spam folder ukoliko je potrebno.",
    otp_heading: "Unesite svoj kod",
    otp_invalid: "Netačan kod. Molimo pokušajte ponovo.",
    otp_resend: "Pošalji kod ponovo",
    otp_resent: "Novi kod je poslat.",
    otp_sent: "Poslali smo vam kod putem e-maila.",
    otp_sent_to: "Poslali smo 6-cifreni kod na:",
    otp_title: "Potvrda e-mail adrese",
    otp_verified: "E-mail potvrđen – dobrodošli!",
    otp_verify: "Potvrdi",
    out_of_stock: "Rasprodato",
    password: "Lozinka",
    payment_cancel: "Plaćanje otkazano",
    payment_cancel_msg: "Plaćanje otkazano. Možete pokušati ponovo.",
    payment_success: "Plaćanje uspešno",
    payment_success_msg: "Hvala na porudžbini!",
    payments_title: "Informacije o plaćanju",
    phone_label: "Telefon",
    price: "Cena",
    qa_disclaimer: "Mišljenja su lična iskustva i ne zamenjuju medicinski savet.",
    qa_login_required: "Prijavite se za pitanja i odgovore.",
    quantity: "Količina",
    question_pending: "Vaše pitanje se pregleda.",
    questions_title: "Pitanja i odgovori",
    reason_natural: "Prirodni sastojci",
    reason_natural_desc: "Svako ulje biramo s pažnjom.",
    reason_secure: "Bezbedno plaćanje",
    reason_secure_desc: "Šifrovano putem Stripe.",
    reason_shipping: "Dostava širom sveta",
    reason_shipping_desc: "Besplatna dostava za iznose preko CHF 100.",
    reason_swiss: "Švajcarski brend",
    reason_swiss_desc: "Osnovano u Glarus – zanatstvo koje se oseća.",
    register: "Registruj se",
    related_products: "Slični proizvodi",
    report_content: "Prijavi",
    reset_link_sent: "Ako nalog postoji, link je kreiran.",
    reset_password: "Resetuj lozinku",
    reset_success: "Lozinka resetovana.",
    ret_created: "Vaš zahtev za povraćaj je kreiran.",
    ret_error: "Zahtev nije mogao biti kreiran.",
    ret_existing_hint: "Javićemo vam se sa sledećim koracima.",
    ret_existing_title: "Status povraćaja",
    ret_info_inspected: "Provereno",
    ret_info_order: "Broj porudžbine",
    ret_info_products: "Vraćeni proizvodi",
    ret_info_products_all: "Kompletna porudžbina",
    ret_info_received: "Primljeno",
    ret_info_refunded: "Refundirano",
    ret_info_requested: "Zatraženo",
    ret_inspection_failed_hint: "Nakon provere nismo mogli prihvatiti vašu povratnu pošiljku. Molimo kontaktirajte nas ukoliko imate pitanja.",
    ret_modal_intro: "Da bi proizvod bio prihvatljiv za povraćaj, ne sme biti otvoren niti korišćen.",
    ret_modal_title: "Vratite proizvod",
    ret_only_delivered: "Povraćaj je dostupan nakon što je porudžbina isporučena.",
    ret_pledge_label: "Potvrđujem da proizvod nije otvoren niti korišćen i da ga vraćam u stanju u kom sam ga primio.",
    ret_pledge_required: "Molimo potvrdite obavezu o vraćanju.",
    ret_reason_changed_mind: "Predomislio sam se",
    ret_reason_damaged: "Proizvod je oštećen",
    ret_reason_group_customer: "Lični razlog",
    ret_reason_group_product: "Problem sa proizvodom ili porudžbinom",
    ret_reason_no_longer_needed: "Više mi ne treba",
    ret_reason_order_error: "Greška u porudžbini",
    ret_reason_other: "Drugi razlog",
    ret_reason_other_issue: "Drugi problem sa proizvodom",
    ret_reason_placeholder: "Molimo opišite razlog…",
    ret_reason_shipping_damage: "Stigao je oštećen",
    ret_reason_wrong_choice: "Slučajno sam izabrao pogrešan proizvod",
    ret_reason_wrong_item: "Isporučeni proizvod ne odgovara porudžbini",
    ret_refund_amount: "Iznos povraćaja",
    ret_refund_bank_note: "Koliko će vremena biti potrebno da se iznos pojavi na vašem računu zavisi od vaše banke ili izdavaoca kartice i može trajati nekoliko radnih dana.",
    ret_refund_issue_body: "Povraćaj još uvek nije mogao biti završen i nastavlja se sa obradom. Ne morate ništa da preduzmete — u slučaju pitanja kontaktirajte nas na info@01co.ch.",
    ret_refund_status_failed: "Povraćaj još uvek u obradi",
    ret_refund_status_processing: "Povraćaj se obrađuje",
    ret_refund_status_succeeded: "Povraćaj izvršen",
    ret_request_btn: "Zahtevaj povraćaj",
    ret_resolution_free: "Besplatan povraćaj · Dostavu plaća salon",
    ret_resolution_paid: "Povraćaj plaća kupac · Dostava na vaš trošak",
    ret_rma_code: "RMA kod",
    ret_status_approved: "Povraćaj odobren",
    ret_status_rejected: "Povraćaj odbijen",
    ret_status_requested: "Povraćaj zatražen",
    ret_status_under_review: "Na proveri",
    ret_step_inspected: "Proizvod proveren",
    ret_step_received: "Povratna pošiljka primljena",
    ret_step_refund_complete: "Povraćaj završen",
    ret_step_refund_initiated: "Povraćaj pokrenut",
    ret_step_refund_issue: "Povraćaj — problem",
    ret_step_rejected: "Povraćaj odbijen",
    ret_step_requested: "Povraćaj zatražen",
    ret_submit: "Pošalji zahtev",
    review_body: "Vaše iskustvo",
    review_pending: "Vaša recenzija je poslata i biće razmotrena.",
    review_rating: "Ocena",
    review_title: "Naslov",
    reviews: "Recenzije",
    sale_badge: "Akcija",
    save: "Sačuvaj",
    saved: "Sačuvano",
    search_placeholder: "Pretraga proizvoda…",
    section_bestsellers: "Bestseleri",
    section_featured: "Izdvojeno",
    section_new: "Noviteti",
    section_oils: "Prirodna ulja",
    section_why_title: "Zašto Coiffeur Tattoo 01&Co.",
    since_2011: "Od 2011.",
    size: "Veličina",
    stock_in: "Na stanju",
    stock_low: "Ograničena dostupnost",
    stock_low_1: "Skoro rasprodata — dostupan samo 1 komad",
    stock_low_2: "Skoro rasprodata — dostupna samo 2 komada",
    stock_low_3: "Skoro rasprodata — dostupna samo 3 komada",
    stock_low_4: "Skoro rasprodata — dostupna samo 4 komada",
    stock_out: "Rasprodato",
    stock_setup: "Trenutno nedostupno",
    submit_answer: "Pošalji odgovor",
    submit_question: "Pošalji pitanje",
    submit_review: "Pošalji recenziju",
    suitable_bart: "Brada",
    suitable_for: "Pogodno za",
    suitable_gesicht: "Lice",
    suitable_haare: "Kosa",
    suitable_haut: "Koža",
    suitable_koerper: "Telo",
    time_remaining_label: "Preostalo vreme",
    tracking_carrier: "Kurirska služba",
    tracking_link: "Praćenje kod dostavljača",
    tracking_number: "Broj praćenja",
    usage: "Primena",
    variant: "Varijanta",
    verified_purchase: "Verifikovana kupovina",
    view_all: "Prikaži sve",
    view_details: "Pogledaj detalje",
    warnings: "Napomene",
    welcome: "Dobrodošli",
    wishlist_add: "Dodaj na listu želja",
    wishlist_empty: "Vaša lista želja je prazna.",
    wishlist_login: "Prijavite se za korišćenje liste želja.",
    wishlist_remove: "Ukloni sa liste želja",
    wishlist_title: "Lista želja",
    write_review: "Napiši recenziju",
      cat_bartpflege: "Nega brade",
    cat_haarpflege: "Nega kose",
    cat_sets_bundles: "Setovi i paketi",
},
  bs: {
    about_address: "Kirchweg 20, 8750 Glarus, Švicarska",
    about_founder: "Osnivač: Sajjad Al-Daghir",
    about_intro: "Švicarski brend iz Glarusa – stil i kvalitet od 2011.",
    about_philosophy_body: "Vjerujemo da su prirodni proizvodi više od proizvoda – oni su veza između ljudi, prirode i tradicionalnog znanja.",
    about_philosophy_title: "Naša filozofija",
    about_title: "Coiffeur Tattoo 01&Co.",
    about_values_title: "Prirodno. Autentično. Pažljivo odabrano.",
    add_to_cart: "Dodaj u korpu",
    address_label: "Adresa",
    admin_analytics: "Analitika",
    admin_avg: "Ø Prosječna vrijednost narudžbe",
    admin_consultations: "Zahtjevi za konsultacije",
    admin_customers: "Kupci",
    admin_discounts: "Popusti",
    admin_orders: "Narudžbe",
    admin_products: "Proizvodi",
    admin_questions: "Pitanja",
    admin_revenue: "Prihod",
    admin_reviews: "Recenzije",
    admin_title: "Admin panel",
    admin_total_orders: "Ukupno narudžbi",
    answer_placeholder: "Odgovorite…",
    aria_account: "Račun",
    aria_basra: "Basra asistent",
    aria_cart: "Korpa",
    aria_close: "Zatvori",
    aria_loading: "Učitavanje…",
    aria_logo_home: "Coiffeur Tattoo 01&Co. početna stranica",
    aria_menu: "Meni",
    aria_remove: "Ukloni",
    aria_send: "Pošalji",
    aria_wishlist: "Lista želja",
    ask_placeholder: "Vaše pitanje …",
    ask_question: "Postavite pitanje",
    auth_error: "Greška pri prijavi.",
    auth_or: "ili",
    benefits: "Prednosti",
    bestseller_badge: "Najprodavanije",
    book_add: "Dodaj",
    book_added_to_cart: "Dodano u rezervaciju",
    book_appointment_nr: "Broj termina",
    book_appointment_time: "Termin",
    book_autofilled: "Automatski popunjeno",
    book_back: "Nazad",
    book_booking_confirmed: "Termin potvrđen",
    book_booking_processing: "Rezervacija u toku…",
    book_cancel_policy: "Uslovi otkazivanja",
    book_cart_empty: "Još nijedna usluga nije odabrana.",
    book_cat_kids: "Djeca i omladina",
    book_cat_men: "Muškarci",
    book_cat_tattoo: "Tattoo",
    book_cat_unisex: "Unisex",
    book_cat_women: "Dame",
    book_colors: "Boje",
    book_customer_eyebrow: "Vaši podaci",
    book_customer_hint: "Molimo popunite jednom — pri sljedećoj posjeti vaši podaci će biti automatski preuzeti.",
    book_datetime: "Datum i vrijeme",
    book_deposit_note_body: "Kapara se zadržava u skladu s našom politikom otkazivanja i kašnjenja: kod otkazivanja manje od 24 sata prije termina, kod rezervacija na isti dan, kod neopravdanog izostanka te kod kašnjenja dužeg od 5 minuta bez pravovremene telefonske najave. Kod pravovremenog otkazivanja (≥ 24 h) kapara se u potpunosti vraća.",
    book_deposit_note_title: "Važna napomena o kapari (50%)",
    book_deposit_required: "Za usluge je potrebna online kapara. Nastavite na Stripe …",
    book_description: "Opis",
    book_edit: "Promijeni",
    book_email_confirmation: "Poslali smo vam potvrdu putem e-maila.",
    book_error_booking: "Greška pri rezervaciji",
    book_error_generic: "Greška",
    book_fill_required: "Molimo popunite sva obavezna polja.",
    book_full_name: "Puno ime",
    book_lines: "Linije",
    book_loading_details: "Učitavanje detalja …",
    book_login_hint: "Savjet: Prijavite se kako bismo automatski preuzeli vaše podatke sljedeći put.",
    book_multi_hint: "Odaberite koliko god želite usluga iz svake kategorije. Datum i vrijeme određujete u sljedećem koraku.",
    book_next: "Dalje",
    book_no_slots: "Nema slobodnih termina za ovaj dan.",
    book_payment_breakdown: "Pregled plaćanja",
    book_phone_num: "Telefon",
    book_pick_date: "Odaberi datum",
    book_pick_length: "Odaberi dužinu",
    book_pick_time: "Odaberite vrijeme",
    book_placeholder_colors: "Boje (npr. crna, u boji …)",
    book_placeholder_desc: "Opis motiva …",
    book_placeholder_lines: "Linije (npr. fine, krupne …)",
    book_policy_5min: "Kod kašnjenja dužeg od 5 minuta bez prethodne telefonske najave naplaćuje se naknada (50 %). Ako nas pozovete u okviru 5 minuta, termin se može produžiti bez dodatnih troškova.",
    book_policy_free_6h: "Besplatno otkazivanje do 6 sati prije termina kod frizera (tetovaža: 24 sata).",
    book_policy_late_fee: "U slučaju kasnijeg otkazivanja naplaćuje se 50 % cijene kao naknada.",
    book_policy_within_6h: "Termini u narednih 6 sati više se ne mogu otkazati.",
    book_preferred_time: "Željeni termin (opciono)",
    book_price: "Cijena",
    book_price_from: "od",
    book_price_on_request: "Cijena na upit",
    book_remove: "Ukloni",
    book_request_sent: "Upit poslan",
    book_reservation: "Rezervacija",
    book_review_add_product: "Dodaj proizvod",
    book_review_add_service: "Dodatna usluga",
    book_review_continue_pay: "Nastavite na plaćanje",
    book_review_continue_schedule: "Nastavite na odabir termina",
    book_review_deposit_now: "Kapara sada",
    book_review_due_now: "Ukupan iznos sada",
    book_review_eyebrow: "Pregled rezervacije",
    book_review_products_total: "Proizvodi ukupno",
    book_review_question: "Želite li dodati dodatnu uslugu ili proizvod, ili ići direktno na odabir termina?",
    book_review_rest_at_salon: "Preostali iznos u salonu",
    book_review_services_total: "Usluge ukupno",
    book_review_split_note: "Za usluge plaćate sada 50&nbsp;% kao kaparu, ostatak u salonu. Proizvodi se plaćaju u potpunosti online.",
    book_review_summary: "Pregled",
    book_review_title: "Skoro gotovo — želite li još nešto dodati?",
    book_review_your_products: "Vaši proizvodi",
    book_review_your_services: "Vaše usluge",
    book_schedule_hint: "Ukupno trajanje:",
    book_selected_service: "Odabrana usluga",
    book_send_request: "Pošalji upit",
    book_sending: "Šalje se…",
    book_size: "Veličina",
    book_size_large: "Veliko (preko 20 cm)",
    book_size_medium: "Srednje (10–20 cm)",
    book_size_small: "Malo (do 10 cm)",
    book_state_blocked_hover: "⚫ Nije dostupno — zatvoreno ili blokirano",
    book_state_booked_hover: "🔴 Zauzeto — već rezervisano",
    book_state_free_hover: "🟢 Slobodno — može se rezervisati",
    book_state_mine_hover: "🔵 Vaš termin",
    book_state_needs_conf_hover: "🟠 Čeka potvrdu",
    book_state_pending_hover: "🟡 U toku — rezervacija u obradi",
    book_state_too_soon_hover: "⚫ Prerano — najmanje 30 min unaprijed",
    book_status_blocked: "Blokirano",
    book_status_booked: "Zauzeto",
    book_status_free: "Slobodno",
    book_status_mine: "Vaš termin",
    book_status_needs_conf: "Čeka potvrdu",
    book_status_pending: "U obradi",
    book_step_done: "Gotovo",
    book_step_info: "Podaci",
    book_step_service: "Usluga",
    book_step_time: "Termin",
    book_submit_booking: "Potvrdi rezervaciju",
    book_tattoo_no_price: "Nema fiksne cijene. Opišite željeni motiv – kontaktiraćemo vas za cijenu i termin.",
    book_tattoo_title: "Upit za tetovažu",
    book_termin_agreement: "Po dogovoru",
    book_visit_hint: "Radujemo se vašoj posjeti. Preostali iznos plaća se u salonu.",
    book_will_contact: "Kontaktiraćemo vas uskoro za cijenu i termin.",
    book_your_cart: "Vaš odabir",
    book_your_info: "Vaši podaci",
    book_your_visit: "Vaša posjeta",
    booking_eyebrow: "Rezervacija termina",
    booking_title: "Rezervišite svoj termin",
    brand_tagline: "Kosa i ljepota od 2011.",
    buy_now: "Kupi sada",
    cart_added: "Dodano",
    cart_apply: "Primijeni",
    cart_checkout: "Na naplatu",
    cart_continue: "Nastavi kupovinu",
    cart_discount: "Popust",
    cart_discount_applied: "Popust primijenjen",
    cart_discount_code: "Kod za popust",
    cart_discount_invalid: "Kod za popust nije valjan",
    cart_empty: "Vaša korpa je prazna.",
    cart_remove: "Ukloni",
    cart_shipping: "Dostava",
    cart_subtotal: "Međuzbir",
    cart_tax_note: "PDV se obračunava pri plaćanju",
    cart_title: "Korpa",
    cart_total: "Ukupno",
    cat_miswak: "Miswak",
    change_password: "Promijeni lozinku",
    channel_email: "E-pošta",
    channel_phone: "Telefon",
    channel_whatsapp: "WhatsApp",
    checkout_address: "Ulica i broj",
    checkout_apartment: "Stan / sprat (opciono)",
    checkout_billing: "Adresa za račun",
    checkout_billing_same: "Adresa za račun ista kao dostava",
    checkout_city: "Grad",
    checkout_contact: "Kontakt",
    checkout_country: "Zemlja",
    checkout_email: "E-pošta",
    checkout_first_name: "Ime",
    checkout_hold_expired_action: "Odaberite novi termin",
    checkout_hold_expired_body: "Termin je oslobođen i mogao je biti u međuvremenu odabran od strane nekog drugog. Molimo odaberite novo vrijeme.",
    checkout_hold_expired_title: "Vaša rezervacija je istekla",
    checkout_hold_expiring: "Rezervacija uskoro ističe",
    checkout_hold_hint: "Vaš odabrani termin je rezervisan za vas. Molimo završite plaćanje prije isteka roka.",
    checkout_hold_title: "Vaša rezervacija",
    checkout_last_name: "Prezime",
    checkout_name: "Puno ime",
    checkout_notes: "Napomene uz narudžbu (opcionalno)",
    checkout_pay_in_store: "Platite u salonu",
    checkout_pay_in_store_deposit_hint: "Za termine je potrebna online kapara. Preostali iznos se plaća u salonu.",
    checkout_pay_in_store_hint: "Rezervišite sada, platite gotovinom ili karticom pri preuzimanju u salonu (Kirchweg 20, Glarus).",
    checkout_pay_online: "Platite online",
    checkout_pay_online_hint: "Kartica, TWINT, Apple Pay, Klarna – sigurno putem Stripe.",
    checkout_payment: "Plaćanje",
    checkout_phone: "Telefon (opcionalno)",
    checkout_place_order: "Nastavi na plaćanje",
    checkout_postal: "Poštanski broj",
    checkout_return_pledge_label: "Obavezujem se da neću otvarati niti koristiti proizvod ako ga želim vratiti.",
    checkout_return_pledge_required: "Molimo potvrdite obećanje o vraćanju kako biste nastavili.",
    checkout_return_policy_body: "Prema pravilima naše trgovine, proizvod koji je otvoren ili korišten ne može se vratiti.",
    checkout_return_policy_title: "Pravo na povrat – molimo pročitajte",
    checkout_review: "Pregled",
    checkout_secure_note: "Sigurno Stripe plaćanje.",
    checkout_shipping: "Adresa za dostavu",
    checkout_street: "Ulica i kućni broj",
    checkout_title: "Naplata",
    consultation_intro: "Rado ćemo vas posavjetovati.",
    consultation_msg: "Vaše pitanje / zahtjev",
    consultation_preferred: "Preferirani kontakt",
    consultation_preferred_time: "Željeni termin",
    consultation_subject: "Tema",
    consultation_submit: "Pošalji upit",
    consultation_thanks: "Hvala – kontaktiraćemo vas uskoro.",
    consultation_title: "Zatražite savjetovanje",
    contact_address: "Adresa",
    contact_email: "E-mail",
    contact_form_title: "Pišite nam",
    contact_hours: "Radno vrijeme",
    contact_message: "Vaša poruka",
    contact_phone: "Telefon",
    contact_send: "Pošalji poruku",
    contact_thanks: "Hvala – javit ćemo vam se uskoro.",
    contact_title: "Kontakt",
    cookie_accept: "Prihvatam",
    cookie_decline: "Samo neophodne",
    cookie_msg: "Ova stranica koristi samo tehničke kolačiće i, uz vašu saglasnost, anonimne statistike.",
    copyright: "Sva prava zadržana.",
    current_password: "Trenutna lozinka",
    delete_account: "Obriši račun",
    delete_confirm: "Zaista trajno izbrisati račun?",
    email: "E-mail",
    footer_agb: "Opći uvjeti poslovanja",
    footer_brand: "Brend",
    footer_cookies: "Kolačići",
    footer_datenschutz: "Privatnost",
    footer_faq: "Često postavljana pitanja",
    footer_help: "Pomoć",
    footer_impressum: "Impresum",
    footer_legal: "Pravne informacije",
    footer_returns: "Povrat",
    footer_shipping: "Dostava",
    footer_shop: "Prodavnica",
    forgot_password: "Zaboravili ste lozinku?",
    founder_label: "Osnivač",
    free_shipping_over: "Besplatna dostava iznad CHF 100",
    hero_cta: "Istražite kolekciju",
    hero_secondary: "Naša priča",
    hero_subtitle: "Premium njega za kosu, bradu i kožu, prirodna ulja, Aleppo sapun, miswak, kana i više – odabir tima Coiffeur Tattoo 01&Co. u Glarusu.",
    hero_title: "Švicarski zanat. Prirodna njega.",
    home_studio_alt: "Coiffeur Tattoo 01&Co. studio u Glarusu",
    ingredients: "Sastojci",
    login: "Prijava",
    login_with_google: "Prijavite se putem Google",
    logout: "Odjavi se",
    medical_disclaimer: "Naši proizvodi ne zamjenjuju stručan medicinski savjet.",
    missing_token_error: "Token nedostaje.",
    my_orders: "Moje narudžbe",
    my_profile: "Moj profil",
    nav_about: "O nama",
    nav_account: "Račun",
    nav_admin: "Admin",
    nav_cart: "Korpa",
    nav_consultation: "Konsultacije",
    nav_contact: "Kontakt",
    nav_home: "Početna",
    nav_shop: "Prodavnica",
    nav_tracking: "Praćenje narudžbe",
    nav_wishlist: "Lista želja",
    new_badge: "Novo",
    new_password: "Nova lozinka",
    newsletter_desc: "Novosti i ekskluzivne ponude.",
    newsletter_label: "Newsletter",
    newsletter_placeholder: "Vaša e-pošta",
    newsletter_submit: "Pretplati se",
    newsletter_title: "Ostanite inspirisani.",
    no_questions: "Još nema pitanja.",
    no_reviews: "Još nema recenzija.",
    order_number: "Broj narudžbe",
    order_status_cancelled: "Otkazano",
    order_status_delivered: "Dostavljeno",
    order_status_paid: "Plaćeno",
    order_status_pending: "Na čekanju",
    order_status_processing: "U obradi",
    order_status_refunded: "Refundirano",
    order_status_shipped: "Poslano",
    order_tracking_email: "E-mail adresa",
    order_tracking_intro: "Unesite broj narudžbe i e-poštu.",
    order_tracking_not_found: "Narudžba nije pronađena.",
    order_tracking_number: "Broj narudžbe",
    order_tracking_submit: "Prati",
    order_tracking_title: "Praćenje narudžbe",
    otp_expires_hint: "Kod važi 10 minuta. Provjerite spam folder ako je potrebno.",
    otp_heading: "Unesite vaš kod",
    otp_invalid: "Pogrešan kod. Molimo pokušajte ponovo.",
    otp_resend: "Pošalji kod ponovo",
    otp_resent: "Novi kod je poslan.",
    otp_sent: "Poslali smo vam kod putem e-maila.",
    otp_sent_to: "Poslali smo 6-cifreni kod na:",
    otp_title: "Potvrda e-maila",
    otp_verified: "E-mail potvrđen – dobrodošli!",
    otp_verify: "Potvrdi",
    out_of_stock: "Rasprodato",
    password: "Lozinka",
    payment_cancel: "Plaćanje otkazano",
    payment_cancel_msg: "Plaćanje je otkazano. Možete pokušati ponovo.",
    payment_success: "Plaćanje uspješno",
    payment_success_msg: "Hvala na narudžbi!",
    payments_title: "Informacije o plaćanju",
    phone_label: "Telefon",
    price: "Cijena",
    qa_disclaimer: "Mišljenja su lična iskustva i ne zamjenjuju medicinski savjet.",
    qa_login_required: "Prijavite se za pitanja i odgovore.",
    quantity: "Količina",
    question_pending: "Vaše pitanje se pregleda.",
    questions_title: "Pitanja i odgovori",
    reason_natural: "Prirodni sastojci",
    reason_natural_desc: "Svako ulje biramo s pažnjom.",
    reason_secure: "Sigurno plaćanje",
    reason_secure_desc: "Šifrovano putem Stripe.",
    reason_shipping: "Dostava širom svijeta",
    reason_shipping_desc: "Besplatna dostava od CHF 100.",
    reason_swiss: "Švicarski brend",
    reason_swiss_desc: "Osnovano u Glarus – zanat koji se osjeća.",
    register: "Registruj se",
    related_products: "Slični proizvodi",
    report_content: "Prijavi",
    reset_link_sent: "Ako račun postoji, link je kreiran.",
    reset_password: "Resetuj lozinku",
    reset_success: "Lozinka resetovana.",
    ret_created: "Vaš zahtjev za povrat je kreiran.",
    ret_error: "Zahtjev nije mogao biti kreiran.",
    ret_existing_hint: "Javit ćemo vam se sa sljedećim koracima.",
    ret_existing_title: "Status povrata",
    ret_info_inspected: "Pregledano dana",
    ret_info_order: "Broj narudžbe",
    ret_info_products: "Vraćeni proizvodi",
    ret_info_products_all: "Kompletna narudžba",
    ret_info_received: "Primljeno dana",
    ret_info_refunded: "Refundirano dana",
    ret_info_requested: "Zatraženo dana",
    ret_inspection_failed_hint: "Nakon provjere nismo mogli prihvatiti vaš povrat. Molimo kontaktirajte nas ako imate pitanja.",
    ret_modal_intro: "Kako bi proizvod bio podoban za povrat, ne smije biti otvoren niti korišten.",
    ret_modal_title: "Vrati proizvod",
    ret_only_delivered: "Povrat dostupan nakon što je narudžba isporučena.",
    ret_pledge_label: "Potvrđujem da proizvod nije otvoren niti korišten i da ga vraćam u stanju u kojem sam ga primio/la.",
    ret_pledge_required: "Molimo potvrdite obećanje o vraćanju.",
    ret_reason_changed_mind: "Predomislio/la sam se",
    ret_reason_damaged: "Proizvod je oštećen",
    ret_reason_group_customer: "Lični razlog",
    ret_reason_group_product: "Problem sa proizvodom ili narudžbom",
    ret_reason_no_longer_needed: "Više mi ne treba",
    ret_reason_order_error: "Greška u narudžbi",
    ret_reason_other: "Drugi razlog",
    ret_reason_other_issue: "Drugi problem sa proizvodom",
    ret_reason_placeholder: "Molimo opišite razlog…",
    ret_reason_shipping_damage: "Stigao je oštećen",
    ret_reason_wrong_choice: "Greškom sam odabrao/la pogrešan proizvod",
    ret_reason_wrong_item: "Isporučeni proizvod ne odgovara narudžbi",
    ret_refund_amount: "Iznos povrata novca",
    ret_refund_bank_note: "Koliko dugo će iznos biti vidljiv na vašem računu zavisi od vaše banke ili izdavača kartice i može potrajati nekoliko radnih dana.",
    ret_refund_issue_body: "Povrat novca još nije mogao biti završen i dalje se obrađuje. Ne morate ništa preduzeti — za pitanja nas možete kontaktirati na info@01co.ch.",
    ret_refund_status_failed: "Povrat novca još u obradi",
    ret_refund_status_processing: "Povrat novca se obrađuje",
    ret_refund_status_succeeded: "Povrat novca izvršen",
    ret_request_btn: "Zatraži povrat",
    ret_resolution_free: "Besplatan povrat · dostavu pokriva salon",
    ret_resolution_paid: "Kupac plaća povrat · dostava na vaš trošak",
    ret_rma_code: "RMA kod",
    ret_status_approved: "Povrat odobren",
    ret_status_rejected: "Povrat odbijen",
    ret_status_requested: "Povrat zatražen",
    ret_status_under_review: "Na provjeri",
    ret_step_inspected: "Proizvod pregledan",
    ret_step_received: "Povrat primljen",
    ret_step_refund_complete: "Povrat novca završen",
    ret_step_refund_initiated: "Povrat novca pokrenut",
    ret_step_refund_issue: "Povrat novca – problem",
    ret_step_rejected: "Povrat odbijen",
    ret_step_requested: "Povrat zatražen",
    ret_submit: "Pošalji zahtjev",
    review_body: "Vaše iskustvo",
    review_pending: "Vaša recenzija je poslana i biće pregledana.",
    review_rating: "Ocjena",
    review_title: "Naslov",
    reviews: "Recenzije",
    sale_badge: "Akcija",
    save: "Sačuvaj",
    saved: "Sačuvano",
    search_placeholder: "Pretraga proizvoda…",
    section_bestsellers: "Najprodavanije",
    section_featured: "Izdvojeno",
    section_new: "Noviteti",
    section_oils: "Prirodna ulja",
    section_why_title: "Zašto Coiffeur Tattoo 01&Co.",
    since_2011: "Od 2011.",
    size: "Veličina",
    stock_in: "Na stanju",
    stock_low: "Ograničena dostupnost",
    stock_low_1: "Gotovo rasprodano — samo 1 komad dostupan",
    stock_low_2: "Gotovo rasprodano — samo 2 komada dostupna",
    stock_low_3: "Gotovo rasprodano — samo 3 komada dostupna",
    stock_low_4: "Gotovo rasprodano — samo 4 komada dostupna",
    stock_out: "Rasprodano",
    stock_setup: "Trenutno nedostupno",
    submit_answer: "Pošalji odgovor",
    submit_question: "Pošalji pitanje",
    submit_review: "Pošalji recenziju",
    suitable_bart: "Brada",
    suitable_for: "Pogodno za",
    suitable_gesicht: "Lice",
    suitable_haare: "Kosa",
    suitable_haut: "Koža",
    suitable_koerper: "Tijelo",
    time_remaining_label: "Preostalo vrijeme",
    tracking_carrier: "Kurirska služba",
    tracking_link: "Pratite kod dostavljača",
    tracking_number: "Broj praćenja",
    usage: "Primjena",
    variant: "Varijanta",
    verified_purchase: "Verificirana kupovina",
    view_all: "Prikaži sve",
    view_details: "Pogledajte detalje",
    warnings: "Napomene",
    welcome: "Dobrodošli",
    wishlist_add: "Dodaj na listu želja",
    wishlist_empty: "Vaša lista želja je prazna.",
    wishlist_login: "Prijavite se za korištenje liste želja.",
    wishlist_remove: "Uklonite sa liste želja",
    wishlist_title: "Lista želja",
    write_review: "Napišite recenziju",
      cat_bartpflege: "Njega brade",
    cat_haarpflege: "Njega kose",
    cat_sets_bundles: "Setovi i paketi",
},
  sq: {
    about_address: "Kirchweg 20, 8750 Glarus, Zvicër",
    about_founder: "Themelues: Sajjad Al-Daghir",
    about_intro: "Një markë zvicerane nga Glarus – stil dhe cilësi që nga 2011.",
    about_philosophy_body: "Ne besojmë se produktet natyrale janë më shumë se produkte – ato janë një lidhje midis njerëzve, natyrës dhe njohurive tradicionale.",
    about_philosophy_title: "Filozofia jonë",
    about_title: "Coiffeur Tattoo 01&Co.",
    about_values_title: "Natyrale. Autentike. E zgjedhur me kujdes.",
    add_to_cart: "Shto në shportë",
    address_label: "Adresa",
    admin_analytics: "Analitika",
    admin_avg: "Ø Vlera e porosisë",
    admin_consultations: "Kërkesa për konsulencë",
    admin_customers: "Klientët",
    admin_discounts: "Zbritjet",
    admin_orders: "Porosi",
    admin_products: "Produktet",
    admin_questions: "Pyetje",
    admin_revenue: "Të ardhurat",
    admin_reviews: "Vlerësime",
    admin_title: "Paneli admin",
    admin_total_orders: "Porosi gjithsej",
    answer_placeholder: "Përgjigju…",
    aria_account: "Llogaria",
    aria_basra: "Asistenti Basra",
    aria_cart: "Shporta",
    aria_close: "Mbyll",
    aria_loading: "Duke u ngarkuar…",
    aria_logo_home: "Coiffeur Tattoo 01&Co. Faqja kryesore",
    aria_menu: "Meny",
    aria_remove: "Hiq",
    aria_send: "Dërgo",
    aria_wishlist: "Lista e dëshirave",
    ask_placeholder: "Pyetja juaj …",
    ask_question: "Bëj një pyetje",
    auth_error: "Gabim gjatë identifikimit.",
    auth_or: "ose",
    benefits: "Përfitimet",
    bestseller_badge: "Më i shituri",
    book_add: "Shto",
    book_added_to_cart: "Shtuar te rezervimi",
    book_appointment_nr: "Nr. i takimit",
    book_appointment_time: "Takim",
    book_autofilled: "Plotësuar automatikisht",
    book_back: "Prapa",
    book_booking_confirmed: "Takimi u konfirmua",
    book_booking_processing: "Po rezervohet…",
    book_cancel_policy: "Kushtet e anulimit",
    book_cart_empty: "Ende nuk është zgjedhur asnjë shërbim.",
    book_cat_kids: "Fëmijë & Adoleshentë",
    book_cat_men: "Meshkuj",
    book_cat_tattoo: "Tattoo",
    book_cat_unisex: "Uniseks",
    book_cat_women: "Zonja",
    book_colors: "Ngjyra",
    book_customer_eyebrow: "Të dhënat tuaja",
    book_customer_hint: "Ju lutemi plotësoni vetëm një herë — në vizitën tuaj të ardhshme të dhënat do të merren automatikisht.",
    book_datetime: "Data dhe ora",
    book_deposit_note_body: "Paradhënia mbahet sipas politikës sonë të anulimit dhe vonesës: në rast anulimi më pak se 24 orë para terminit, për rezervime të ditës, në rast mosprezantimi si dhe në rast vonese më shumë se 5 minuta pa njoftim paraprak telefonik. Në rast anulimi në kohë (≥ 24 h) paradhënia rimbursohet plotësisht.",
    book_deposit_note_title: "Shënim i rëndësishëm për paradhënien (50%)",
    book_deposit_required: "Për shërbimet kërkohet një paradhënie online. Vazhdo te Stripe …",
    book_description: "Përshkrimi",
    book_edit: "Ndrysho",
    book_email_confirmation: "Ju kemi dërguar një konfirmim me email.",
    book_error_booking: "Gabim gjatë rezervimit",
    book_error_generic: "Gabim",
    book_fill_required: "Ju lutemi plotësoni të gjitha fushat e detyrueshme.",
    book_full_name: "Emri i plotë",
    book_lines: "Vija",
    book_loading_details: "Detajet po ngarkohen …",
    book_login_hint: "Këshillë: Identifikohuni që të dhënat tuaja të merren automatikisht herën tjetër.",
    book_multi_hint: "Zgjidhni sa të dëshironi shërbime nga çdo kategori. Datën dhe orën do t'i caktoni në hapin tjetër.",
    book_next: "Vazhdo",
    book_no_slots: "Nuk ka orare të lira këtë ditë.",
    book_payment_breakdown: "Përmbledhje e pagesës",
    book_phone_num: "Telefon",
    book_pick_date: "Zgjidhni datën",
    book_pick_length: "Zgjidhni gjatësinë",
    book_pick_time: "Zgjidhni orën",
    book_placeholder_colors: "Ngjyra (p.sh. e zezë, me ngjyra …)",
    book_placeholder_desc: "Përshkrimi i motivit …",
    book_placeholder_lines: "Vija (p.sh. të holla, të trasha …)",
    book_policy_5min: "Në rast vonese më shumë se 5 minuta pa njoftim telefonik, tarifohet penaliteti (50 %). Nëse na telefononi brenda 5 minutave, takimi mund të zgjatet pa kosto shtesë.",
    book_policy_free_6h: "Anulim falas deri 6 orë para takimit të parukerisë (tatuazh: 24 orë).",
    book_policy_late_fee: "Në rast anulimi më të vonshëm, tarifohet 50 % e çmimit si penalitet.",
    book_policy_within_6h: "Takimet brenda 6 orëve në vijim nuk mund të anulohen më.",
    book_preferred_time: "Ora e preferuar (opsionale)",
    book_price: "Çmimi",
    book_price_from: "nga",
    book_price_on_request: "Çmimi sipas kërkesës",
    book_remove: "Hiq",
    book_request_sent: "Kërkesa u dërgua",
    book_reservation: "Rezervim",
    book_review_add_product: "Shto produkt",
    book_review_add_service: "Shërbim shtesë",
    book_review_continue_pay: "Vazhdo te pagesa",
    book_review_continue_schedule: "Vazhdo te zgjedhja e terminit",
    book_review_deposit_now: "Paradhënie tani",
    book_review_due_now: "Shuma totale tani",
    book_review_eyebrow: "Përmbledhje e rezervimit",
    book_review_products_total: "Produkte gjithsej",
    book_review_question: "Dëshironi të shtoni një shërbim shtesë ose një produkt, apo të kaloni direkt te zgjedhja e terminit?",
    book_review_rest_at_salon: "Shuma e mbetur në salon",
    book_review_services_total: "Shërbime gjithsej",
    book_review_split_note: "Për shërbimet paguani tani 50% si paradhënie, pjesën tjetër rehatisht në salon. Produktet paguhen plotësisht online.",
    book_review_summary: "Përmbledhje",
    book_review_title: "Gati thuajse — dëshironi të shtoni diçka?",
    book_review_your_products: "Produktet tuaja",
    book_review_your_services: "Shërbimet tuaja",
    book_schedule_hint: "Kohëzgjatja totale:",
    book_selected_service: "Shërbimi i zgjedhur",
    book_send_request: "Dërgo kërkesën",
    book_sending: "Po dërgohet…",
    book_size: "Madhësia",
    book_size_large: "I madh (mbi 20 cm)",
    book_size_medium: "Mesatar (10–20 cm)",
    book_size_small: "I vogël (deri në 10 cm)",
    book_state_blocked_hover: "⚫ I padisponueshëm — mbyllur ose bllokuar",
    book_state_booked_hover: "🔴 I zënë — tashmë i rezervuar",
    book_state_free_hover: "🟢 I lirë — i rezervueshëm tani",
    book_state_mine_hover: "🔵 Takimi juaj",
    book_state_needs_conf_hover: "🟠 Në pritje të konfirmimit",
    book_state_pending_hover: "🟡 Në proces — rezervimi po realizohet",
    book_state_too_soon_hover: "⚫ Shumë herët — minimum 30 min paraprakisht",
    book_status_blocked: "I bllokuar",
    book_status_booked: "I zënë",
    book_status_free: "I lirë",
    book_status_mine: "Takimi juaj",
    book_status_needs_conf: "Në pritje të konfirmimit",
    book_status_pending: "Në përpunim",
    book_step_done: "Përfunduar",
    book_step_info: "Të dhëna",
    book_step_service: "Shërbimi",
    book_step_time: "Termin",
    book_submit_booking: "Konfirmo rezervimin",
    book_tattoo_no_price: "Nuk ka çmim të përcaktuar. Përshkruani motivin tuaj të dëshiruar – ne do t'ju kontaktojmë për çmimin dhe terminin.",
    book_tattoo_title: "Kërkesë për tatuazh",
    book_termin_agreement: "Me takim",
    book_visit_hint: "Ju presim me kënaqësi. Shuma e mbetur paguhet në salon.",
    book_will_contact: "Do t'ju kontaktojmë së shpejti për çmimin dhe terminin.",
    book_your_cart: "Zgjedhja juaj",
    book_your_info: "Të dhënat tuaja",
    book_your_visit: "Vizita juaj",
    booking_eyebrow: "Rezervim termini",
    booking_title: "Rezervoni takimin tuaj",
    brand_tagline: "Flokë & Bukuri që nga 2011",
    buy_now: "Blej tani",
    cart_added: "Shtuar",
    cart_apply: "Apliko",
    cart_checkout: "Në arkë",
    cart_continue: "Vazhdo blerjet",
    cart_discount: "Zbritje",
    cart_discount_applied: "Zbritja u aplikua",
    cart_discount_code: "Kodi i zbritjes",
    cart_discount_invalid: "Kodi i zbritjes është i pavlefshëm",
    cart_empty: "Shporta juaj është bosh.",
    cart_remove: "Hiq",
    cart_shipping: "Dërgesa",
    cart_subtotal: "Nëntotali",
    cart_tax_note: "TVSH llogaritet në arkë",
    cart_title: "Shporta",
    cart_total: "Totali",
    cat_miswak: "Miswak",
    change_password: "Ndrysho fjalëkalimin",
    channel_email: "E-mail",
    channel_phone: "Telefon",
    channel_whatsapp: "WhatsApp",
    checkout_address: "Rruga & nr.",
    checkout_apartment: "Apartament / Kat (opsionale)",
    checkout_billing: "Adresa e faturimit",
    checkout_billing_same: "Adresa e faturimit njësoj si dërgesa",
    checkout_city: "Qyteti",
    checkout_contact: "Kontakt",
    checkout_country: "Shteti",
    checkout_email: "E-mail",
    checkout_first_name: "Emri",
    checkout_hold_expired_action: "Zgjidh termin e ri",
    checkout_hold_expired_body: "Termini është liruar dhe mund të jetë zgjedhur tashmë nga dikush tjetër. Ju lutemi zgjidhni një kohë të re.",
    checkout_hold_expired_title: "Rezervimi juaj ka skaduar",
    checkout_hold_expiring: "Rezervimi po skadon së shpejti",
    checkout_hold_hint: "Termini juaj i zgjedhur është rezervuar për ju. Ju lutemi përfundoni pagesën para skadimit.",
    checkout_hold_title: "Rezervimi juaj",
    checkout_last_name: "Mbiemri",
    checkout_name: "Emri i plotë",
    checkout_notes: "Shënime për porosinë (opsionale)",
    checkout_pay_in_store: "Paguaj në salon",
    checkout_pay_in_store_deposit_hint: "Për termine kërkohet një paradhënie online. Shuma e mbetur paguhet në salon.",
    checkout_pay_in_store_hint: "Rezervoni tani, paguani në para ose me kartë gjatë marrjes në salon (Kirchweg 20, Glarus).",
    checkout_pay_online: "Paguaj online",
    checkout_pay_online_hint: "Kartë, TWINT, Apple Pay, Klarna – në mënyrë të sigurt përmes Stripe.",
    checkout_payment: "Pagesa",
    checkout_phone: "Telefon (opsional)",
    checkout_place_order: "Vazhdo në pagesë",
    checkout_postal: "Kodi postar",
    checkout_return_pledge_label: "Unë angazhohem të mos e hap dhe të mos e përdor produktin, nëse dëshiroj ta kthej.",
    checkout_return_pledge_required: "Ju lutemi konfirmoni premtimin e kthimit për të vazhduar.",
    checkout_return_policy_body: "Sipas rregullave tona të dyqanit, një produkt që është hapur ose përdorur nuk mund të kthehet.",
    checkout_return_policy_title: "E drejta e kthimit — ju lutemi lexoni",
    checkout_review: "Shqyrtim",
    checkout_secure_note: "Pagesë e sigurt Stripe.",
    checkout_shipping: "Adresa e dërgesës",
    checkout_street: "Rruga & numri",
    checkout_title: "Arka",
    consultation_intro: "Do t'ju këshillojmë me kënaqësi.",
    consultation_msg: "Pyetja / Kërkesa juaj",
    consultation_preferred: "Kontakti i preferuar",
    consultation_preferred_time: "Termini i preferuar",
    consultation_subject: "Tema",
    consultation_submit: "Dërgo kërkesën",
    consultation_thanks: "Faleminderit – do t'ju kontaktojmë së shpejti.",
    consultation_title: "Kërko konsultim",
    contact_address: "Adresa",
    contact_email: "E-Mail",
    contact_form_title: "Na shkruani",
    contact_hours: "Orari i punës",
    contact_message: "Mesazhi juaj",
    contact_phone: "Telefon",
    contact_send: "Dërgo mesazhin",
    contact_thanks: "Faleminderit – do t'ju kontaktojmë së shpejti.",
    contact_title: "Kontakti",
    cookie_accept: "Prano",
    cookie_decline: "Vetëm të nevojshmet",
    cookie_msg: "Ky sajt përdor vetëm cookie teknike dhe, me pëlqimin tuaj, statistika anonime.",
    copyright: "Të gjitha të drejtat e rezervuara.",
    current_password: "Fjalëkalimi aktual",
    delete_account: "Fshij llogarinë",
    delete_confirm: "Jeni i sigurt që dëshironi ta fshini llogarinë përgjithmonë?",
    email: "E-Mail",
    footer_agb: "Kushtet e Përgjithshme",
    footer_brand: "Marka",
    footer_cookies: "Cookies",
    footer_datenschutz: "Privatësia",
    footer_faq: "Pyetje të shpeshta",
    footer_help: "Ndihmë",
    footer_impressum: "Impresum",
    footer_legal: "Kushtet ligjore",
    footer_returns: "Kthime",
    footer_shipping: "Dërgesa",
    footer_shop: "Dyqani",
    forgot_password: "Harruat fjalëkalimin?",
    founder_label: "Themelues",
    free_shipping_over: "Dërgesa falas mbi CHF 100",
    hero_cta: "Zbulo koleksionin",
    hero_secondary: "Historia jonë",
    hero_subtitle: "Kujdes premium për flokët, mjekrën dhe lëkurën, vajra natyrale, sapun Aleppo, miswak, kanë dhe më shumë – të zgjedhura nga ekipi Coiffeur Tattoo 01&Co. në Glarus.",
    hero_title: "Zanat zviceran. Kujdes natyror.",
    home_studio_alt: "Coiffeur Tattoo 01&Co. Studio në Glarus",
    ingredients: "Përbërësit",
    login: "Hyr",
    login_with_google: "Identifikohu me Google",
    logout: "Dil",
    medical_disclaimer: "Produktet tona nuk zëvendësojnë këshillën profesionale mjekësore.",
    missing_token_error: "Mungon token.",
    my_orders: "Porositë e mia",
    my_profile: "Profili im",
    nav_about: "Rreth nesh",
    nav_account: "Llogaria",
    nav_admin: "Admin",
    nav_cart: "Shporta",
    nav_consultation: "Konsulencë",
    nav_contact: "Kontakt",
    nav_home: "Ballina",
    nav_shop: "Dyqani",
    nav_tracking: "Ndjekja e porosisë",
    nav_wishlist: "Lista e dëshirave",
    new_badge: "E re",
    new_password: "Fjalëkalimi i ri",
    newsletter_desc: "Të reja dhe oferta ekskluzive.",
    newsletter_label: "Newsletter",
    newsletter_placeholder: "E-maili juaj",
    newsletter_submit: "Abonohu",
    newsletter_title: "Qëndroni të frymëzuar.",
    no_questions: "Ende s'ka pyetje.",
    no_reviews: "Ende s'ka vlerësime.",
    order_number: "Numri i porosisë",
    order_status_cancelled: "E anuluar",
    order_status_delivered: "Dorëzuar",
    order_status_paid: "Paguar",
    order_status_pending: "Në pritje",
    order_status_processing: "Në përpunim",
    order_status_refunded: "Rimbursuar",
    order_status_shipped: "E dërguar",
    order_tracking_email: "Adresa e email-it",
    order_tracking_intro: "Fut numrin dhe e-mailin.",
    order_tracking_not_found: "Porosia nuk u gjet.",
    order_tracking_number: "Numri i porosisë",
    order_tracking_submit: "Ndiq",
    order_tracking_title: "Ndjek porosinë",
    otp_expires_hint: "Kodi është i vlefshëm për 10 minuta. Kontrolloni dosjen tuaj të spam-it nëse është e nevojshme.",
    otp_heading: "Vendosni kodin tuaj",
    otp_invalid: "Kod i gabuar. Ju lutemi provoni përsëri.",
    otp_resend: "Dërgo kodin përsëri",
    otp_resent: "Kodi i ri u dërgua.",
    otp_sent: "Ju kemi dërguar një kod përmes email-it.",
    otp_sent_to: "Kemi dërguar një kod 6-shifror te:",
    otp_title: "Konfirmim email-i",
    otp_verified: "Email-i u konfirmua — mirë se vini!",
    otp_verify: "Konfirmo",
    out_of_stock: "I shitur",
    password: "Fjalëkalimi",
    payment_cancel: "Pagesa u anulua",
    payment_cancel_msg: "Pagesa u anulua. Mund të provoni sërish.",
    payment_success: "Pagesa u krye",
    payment_success_msg: "Faleminderit për porosinë!",
    payments_title: "Informacione për pagesën",
    phone_label: "Telefon",
    price: "Çmimi",
    qa_disclaimer: "Mendimet janë përvoja personale dhe nuk zëvendësojnë këshillën mjekësore.",
    qa_login_required: "Ju lutem hyni për të pyetur ose përgjigjur.",
    quantity: "Sasia",
    question_pending: "Pyetja juaj po shqyrtohet.",
    questions_title: "Pyetje & Përgjigje",
    reason_natural: "Përbërës natyrorë",
    reason_natural_desc: "Çdo vaj zgjedhet me kujdes të veçantë.",
    reason_secure: "Pagesë e sigurt",
    reason_secure_desc: "I enkriptuar me Stripe.",
    reason_shipping: "Dërgesa në mbarë botën",
    reason_shipping_desc: "Transport falas për porosi mbi CHF 100.",
    reason_swiss: "Markë zvicerane",
    reason_swiss_desc: "Themeluar në Glarus – zanat që ndihet.",
    register: "Regjistrohu",
    related_products: "Produkte të ngjashme",
    report_content: "Raporto",
    reset_link_sent: "Nëse llogaria ekziston, u krijua një link.",
    reset_password: "Rivendos fjalëkalimin",
    reset_success: "Fjalëkalimi u rivendos.",
    ret_created: "Kërkesa juaj e kthimit u krijua.",
    ret_error: "Kërkesa nuk mund të krijohej.",
    ret_existing_hint: "Do t'ju kontaktojmë me hapat e ardhshëm.",
    ret_existing_title: "Statusi i kthimit",
    ret_info_inspected: "Kontrolluar më",
    ret_info_order: "Numri i porosisë",
    ret_info_products: "Produkte të kthyera",
    ret_info_products_all: "Porosia e plotë",
    ret_info_received: "Marrë më",
    ret_info_refunded: "Rimbursuar më",
    ret_info_requested: "Kërkuar më",
    ret_inspection_failed_hint: "Pas kontrollit, fatkeqësisht nuk mundëm ta pranojmë kthimin tuaj. Ju lutemi na kontaktoni nëse keni pyetje.",
    ret_modal_intro: "Që produkti juaj të kualifikohet për kthim, nuk duhet të jetë as hapur as përdorur.",
    ret_modal_title: "Kthe produktin",
    ret_only_delivered: "Kthimi disponohet pasi porosia të jetë dorëzuar.",
    ret_pledge_label: "Unë konfirmoj se produkti nuk është hapur dhe nuk është përdorur dhe se po e kthej në gjendjen në të cilën e kam marrë.",
    ret_pledge_required: "Ju lutemi konfirmoni premtimin e kthimit.",
    ret_reason_changed_mind: "Kam ndryshuar mendim",
    ret_reason_damaged: "Produkti është i dëmtuar",
    ret_reason_group_customer: "Arsye personale",
    ret_reason_group_product: "Problem me produktin ose porosinë",
    ret_reason_no_longer_needed: "Nuk më duhet më",
    ret_reason_order_error: "Gabim në porosi",
    ret_reason_other: "Arsye tjetër",
    ret_reason_other_issue: "Një problem tjetër me produktin",
    ret_reason_placeholder: "Ju lutemi përshkruani arsyen…",
    ret_reason_shipping_damage: "Erdhi i dëmtuar",
    ret_reason_wrong_choice: "Kam zgjedhur gabimisht produktin e gabuar",
    ret_reason_wrong_item: "Produkti i dorëzuar nuk përputhet me porosinë",
    ret_refund_amount: "Shuma e rimbursimit",
    ret_refund_bank_note: "Sa kohë do të duhet që shuma të jetë e dukshme në llogarinë tuaj varet nga banka ose ofruesit tuaj të kartës dhe mund të zgjasë disa ditë pune.",
    ret_refund_issue_body: "Rimbursimi nuk mund të përfundohej ende dhe vazhdon të përpunohet. Nuk ju duhet të ndërmerrni asgjë — për pyetje na kontaktoni te info@01co.ch.",
    ret_refund_status_failed: "Rimbursimi ende në përpunim",
    ret_refund_status_processing: "Rimbursimi po përpunohet",
    ret_refund_status_succeeded: "Rimbursimi u krye",
    ret_request_btn: "Kërko kthim",
    ret_resolution_free: "Kthim falas · Dërgimi mbulohet nga saloni",
    ret_resolution_paid: "Kthim i paguar nga klienti · Dërgimi në ngarkim tuajin",
    ret_rma_code: "Kodi RMA",
    ret_status_approved: "Kthimi u miratua",
    ret_status_rejected: "Kthimi u refuzua",
    ret_status_requested: "Kthimi u kërkua",
    ret_status_under_review: "Në shqyrtim",
    ret_step_inspected: "Produkti u kontrollua",
    ret_step_received: "Kthimi u mor",
    ret_step_refund_complete: "Rimbursimi u përfundua",
    ret_step_refund_initiated: "Rimbursimi u fillua",
    ret_step_refund_issue: "Rimbursimi — problem",
    ret_step_rejected: "Kthimi u refuzua",
    ret_step_requested: "Kthimi u kërkua",
    ret_submit: "Dërgo kërkesën",
    review_body: "Përvoja juaj",
    review_pending: "Vlerësimi juaj është dërguar dhe do të shqyrtohet.",
    review_rating: "Vlerësim",
    review_title: "Titulli",
    reviews: "Vlerësimet",
    sale_badge: "Shitje",
    save: "Ruaj",
    saved: "Ruajtur",
    search_placeholder: "Kërko produkte…",
    section_bestsellers: "Më të shitura",
    section_featured: "Të veçuara",
    section_new: "Të reja",
    section_oils: "Vajra natyrale",
    section_why_title: "Pse Coiffeur Tattoo 01&Co.",
    since_2011: "Që nga viti 2011",
    size: "Madhësia",
    stock_in: "Në stok",
    stock_low: "Të pakta në dispozicion",
    stock_low_1: "Pothuajse i shitur — vetëm 1 copë e disponueshme",
    stock_low_2: "Pothuajse i shitur — vetëm 2 copë të disponueshme",
    stock_low_3: "Pothuajse i shitur — vetëm 3 copë të disponueshme",
    stock_low_4: "Pothuajse i shitur — vetëm 4 copë të disponueshme",
    stock_out: "I shitur",
    stock_setup: "Aktualisht i padisponueshëm",
    submit_answer: "Dërgo përgjigjen",
    submit_question: "Dërgo pyetjen",
    submit_review: "Dërgo vlerësimin",
    suitable_bart: "Mjekër",
    suitable_for: "I përshtatshëm për",
    suitable_gesicht: "Fytyrë",
    suitable_haare: "Flokë",
    suitable_haut: "Lëkurë",
    suitable_koerper: "Trup",
    time_remaining_label: "Koha e mbetur",
    tracking_carrier: "Shërbimi i transportit",
    tracking_link: "Gjurmo te ofruesi",
    tracking_number: "Nr. i ndjekjes",
    usage: "Përdorimi",
    variant: "Varianti",
    verified_purchase: "Blerje e verifikuar",
    view_all: "Shiko të gjitha",
    view_details: "Shiko detajet",
    warnings: "Paralajmërime",
    welcome: "Mirë se vini",
    wishlist_add: "Shto te të preferuarat",
    wishlist_empty: "Lista juaj e dëshirave është bosh.",
    wishlist_login: "Ju lutem hyni për të përdorur listën.",
    wishlist_remove: "Hiq nga lista e dëshirave",
    wishlist_title: "Të preferuarat",
    write_review: "Shkruaj një vlerësim",
      cat_bartpflege: "Kujdesi për mjekrën",
    cat_haarpflege: "Kujdesi për flokët",
    cat_sets_bundles: "Sete dhe Paketa",
},
  tr: {
    about_address: "Kirchweg 20, 8750 Glarus, İsviçre",
    about_founder: "Kurucu: Sajjad Al-Daghir",
    about_intro: "Glarus'tan bir İsviçre markası – 2011'den beri stil ve kalite.",
    about_philosophy_body: "Doğal ürünler; insanlar, doğa ve geleneksel bilgi arasında bir bağdır.",
    about_philosophy_title: "Felsefemiz",
    about_title: "Coiffeur Tattoo 01&Co.",
    about_values_title: "Doğal. Otantik. Özenle seçilmiş.",
    add_to_cart: "Sepete ekle",
    address_label: "Adres",
    admin_analytics: "Analitik",
    admin_avg: "Ø Sipariş Değeri",
    admin_consultations: "Danışma Talepleri",
    admin_customers: "Müşteriler",
    admin_discounts: "İndirimler",
    admin_orders: "Siparişler",
    admin_products: "Ürünler",
    admin_questions: "Sorular",
    admin_revenue: "Ciro",
    admin_reviews: "Değerlendirmeler",
    admin_title: "Admin Panel",
    admin_total_orders: "Toplam Sipariş",
    answer_placeholder: "Cevaplayın…",
    aria_account: "Hesap",
    aria_basra: "Basra Asistan",
    aria_cart: "Sepet",
    aria_close: "Kapat",
    aria_loading: "Yükleniyor…",
    aria_logo_home: "Coiffeur Tattoo 01&Co. Ana Sayfa",
    aria_menu: "Menü",
    aria_remove: "Kaldır",
    aria_send: "Gönder",
    aria_wishlist: "İstek Listesi",
    ask_placeholder: "Sorunuz …",
    ask_question: "Soru sor",
    auth_error: "Giriş sırasında hata oluştu.",
    auth_or: "veya",
    benefits: "Avantajlar",
    bestseller_badge: "En Çok Satan",
    book_add: "Ekle",
    book_added_to_cart: "Rezervasyona eklendi",
    book_appointment_nr: "Randevu no.",
    book_appointment_time: "Randevu",
    book_autofilled: "Otomatik dolduruldu",
    book_back: "Geri",
    book_booking_confirmed: "Randevu onaylandı",
    book_booking_processing: "Rezervasyon yapılıyor…",
    book_cancel_policy: "İptal Koşulları",
    book_cart_empty: "Henüz hizmet seçilmedi.",
    book_cat_kids: "Çocuk & Genç",
    book_cat_men: "Erkek",
    book_cat_tattoo: "Dövme",
    book_cat_unisex: "Unisex",
    book_cat_women: "Kadın",
    book_colors: "Renkler",
    book_customer_eyebrow: "Bilgileriniz",
    book_customer_hint: "Lütfen bir kereye mahsus doldurun — bir sonraki ziyaretinizde bilgileriniz otomatik olarak aktarılacaktır.",
    book_datetime: "Tarih & Saat",
    book_deposit_note_body: "Kapora, iptal ve geç kalma politikamız gereğince alıkonulur: randevudan 24 saatten az bir süre önce iptal durumunda, aynı gün rezervasyonlarında, gelmeme durumunda ve zamanında telefon bildirimi yapılmaksızın 5 dakikadan fazla gecikilmesi halinde. Süresi içinde yapılan iptallerde (≥ 24 sa) kapora tam olarak iade edilir.",
    book_deposit_note_title: "Kapora İçin Önemli Not (%50)",
    book_deposit_required: "Hizmetler için online kapora ödemesi gereklidir. Stripe'a devam et …",
    book_description: "Açıklama",
    book_edit: "Değiştir",
    book_email_confirmation: "Size e-posta ile bir onay gönderdik.",
    book_error_booking: "Rezervasyon hatası",
    book_error_generic: "Hata",
    book_fill_required: "Lütfen tüm zorunlu alanları doldurun.",
    book_full_name: "Ad soyad",
    book_lines: "Çizgiler",
    book_loading_details: "Detaylar yükleniyor …",
    book_login_hint: "İpucu: Giriş yapın, bir sonraki seferde bilgilerinizi otomatik olarak aktaralım.",
    book_multi_hint: "Her kategoriden istediğiniz kadar hizmet seçin. Tarih ve saati bir sonraki adımda belirlersiniz.",
    book_next: "İleri",
    book_no_slots: "Bu gün için uygun saat yok.",
    book_payment_breakdown: "Ödeme Dökümü",
    book_phone_num: "Telefon",
    book_pick_date: "Tarih seçin",
    book_pick_length: "Uzunluk seçin",
    book_pick_time: "Saat seçin",
    book_placeholder_colors: "Renkler (ör. siyah, renkli …)",
    book_placeholder_desc: "Motif açıklaması …",
    book_placeholder_lines: "Çizgiler (örn. ince, kalın …)",
    book_policy_5min: "Önceden telefonla haber verilmeden 5 dakikadan uzun gecikmelerde cezai bedel (%50) uygulanır. 5 dakika içinde ararsanız, randevu ek ücret olmadan uzatılabilir.",
    book_policy_free_6h: "Kuaför randevusundan 6 saat öncesine kadar ücretsiz iptal (dövme: 24 saat).",
    book_policy_late_fee: "Daha geç iptallerde fiyatın %50'si cezai bedel olarak alınır.",
    book_policy_within_6h: "Önümüzdeki 6 saat içindeki randevular artık iptal edilemez.",
    book_preferred_time: "Tercih edilen saat (isteğe bağlı)",
    book_price: "Fiyat",
    book_price_from: "başlangıç",
    book_price_on_request: "Fiyat talep üzerine",
    book_remove: "Kaldır",
    book_request_sent: "Talep gönderildi",
    book_reservation: "Rezervasyon",
    book_review_add_product: "Ürün ekle",
    book_review_add_service: "Başka hizmet",
    book_review_continue_pay: "Ödemeye devam et",
    book_review_continue_schedule: "Randevu seçimine devam et",
    book_review_deposit_now: "Kapora şimdi",
    book_review_due_now: "Toplam tutar şimdi",
    book_review_eyebrow: "Rezervasyon Özeti",
    book_review_products_total: "Ürünler toplam",
    book_review_question: "Başka bir hizmet veya ürün eklemek mi istersiniz, yoksa doğrudan randevu seçimine mi geçmek istersiniz?",
    book_review_rest_at_salon: "Kalan tutar salonda",
    book_review_services_total: "Hizmetler toplam",
    book_review_split_note: "Hizmetler için şimdi %50 kapora ödersiniz, kalanını salonda rahatça ödeyebilirsiniz. Ürünler tamamen online ödenir.",
    book_review_summary: "Özet",
    book_review_title: "Neredeyse tamam — bir şey daha eklemek ister misiniz?",
    book_review_your_products: "Ürünleriniz",
    book_review_your_services: "Hizmetleriniz",
    book_schedule_hint: "Toplam süre:",
    book_selected_service: "Seçilen hizmet",
    book_send_request: "Talep gönder",
    book_sending: "Gönderiliyor…",
    book_size: "Boyut",
    book_size_large: "Büyük (20 cm üzeri)",
    book_size_medium: "Orta (10–20 cm)",
    book_size_small: "Küçük (10 cm'e kadar)",
    book_state_blocked_hover: "⚫ Uygun değil — kapalı veya bloke",
    book_state_booked_hover: "🔴 Dolu — zaten rezerve edildi",
    book_state_free_hover: "🟢 Uygun — şimdi rezerve edilebilir",
    book_state_mine_hover: "🔵 Randevunuz",
    book_state_needs_conf_hover: "🟠 Onay bekliyor",
    book_state_pending_hover: "🟡 İşlemde — rezervasyon sürüyor",
    book_state_too_soon_hover: "⚫ Çok erken — en az 30 dk öncesinden",
    book_status_blocked: "Kapalı",
    book_status_booked: "Dolu",
    book_status_free: "Uygun",
    book_status_mine: "Randevunuz",
    book_status_needs_conf: "Onay Bekleniyor",
    book_status_pending: "İşleniyor",
    book_step_done: "Tamamlandı",
    book_step_info: "Bilgiler",
    book_step_service: "Hizmet",
    book_step_time: "Randevu",
    book_submit_booking: "Randevuyu onayla",
    book_tattoo_no_price: "Sabit fiyat yok. İstediğiniz motifi açıklayın – fiyat ve randevu için sizinle iletişime geçeceğiz.",
    book_tattoo_title: "Dövme talebi",
    book_termin_agreement: "Randevu ile",
    book_visit_hint: "Sizi bekliyoruz. Kalan tutar salonda ödenecektir.",
    book_will_contact: "Fiyat ve randevu için kısa süre içinde sizinle iletişime geçeceğiz.",
    book_your_cart: "Seçimleriniz",
    book_your_info: "Bilgileriniz",
    book_your_visit: "Ziyaretiniz",
    booking_eyebrow: "Randevu Rezervasyonu",
    booking_title: "Randevunuzu ayırtın",
    brand_tagline: "2011'den beri Saç ve Güzellik",
    buy_now: "Şimdi satın al",
    cart_added: "Eklendi",
    cart_apply: "Uygula",
    cart_checkout: "Ödemeye geç",
    cart_continue: "Alışverişe devam et",
    cart_discount: "İndirim",
    cart_discount_applied: "İndirim uygulandı",
    cart_discount_code: "İndirim kodu",
    cart_discount_invalid: "İndirim kodu geçersiz",
    cart_empty: "Sepetiniz boş.",
    cart_remove: "Kaldır",
    cart_shipping: "Kargo",
    cart_subtotal: "Ara toplam",
    cart_tax_note: "KDV ödeme sayfasında hesaplanır",
    cart_title: "Sepet",
    cart_total: "Toplam",
    change_password: "Şifre değiştir",
    channel_email: "E-posta",
    channel_phone: "Telefon",
    channel_whatsapp: "WhatsApp",
    checkout_address: "Sokak & no.",
    checkout_apartment: "Daire / Kat (isteğe bağlı)",
    checkout_billing: "Fatura adresi",
    checkout_billing_same: "Fatura adresi teslimat ile aynı",
    checkout_city: "Şehir",
    checkout_contact: "İletişim",
    checkout_country: "Ülke",
    checkout_email: "E-posta",
    checkout_first_name: "Ad",
    checkout_hold_expired_action: "Yeni randevu seç",
    checkout_hold_expired_body: "Randevu serbest bırakıldı ve bu arada başka biri tarafından seçilmiş olabilir. Lütfen yeni bir zaman seçin.",
    checkout_hold_expired_title: "Rezervasyonunuzun süresi doldu",
    checkout_hold_expiring: "Rezervasyon süresi dolmak üzere",
    checkout_hold_hint: "Seçtiğiniz randevu sizin için ayrıldı. Lütfen süre dolmadan ödemeyi tamamlayın.",
    checkout_hold_title: "Rezervasyonunuz",
    checkout_last_name: "Soyad",
    checkout_name: "Ad Soyad",
    checkout_notes: "Sipariş notları (opsiyonel)",
    checkout_pay_in_store: "Salonda ödeme yapın",
    checkout_pay_in_store_deposit_hint: "Randevular için online kapora ödemesi gereklidir. Kalan tutar salonda ödenir.",
    checkout_pay_in_store_hint: "Şimdi rezerve edin, salonda teslim alırken nakit veya kart ile ödeyin (Kirchweg 20, Glarus).",
    checkout_pay_online: "Online ödeme yapın",
    checkout_pay_online_hint: "Kart, TWINT, Apple Pay, Klarna – Stripe ile güvenli.",
    checkout_payment: "Ödeme",
    checkout_phone: "Telefon (opsiyonel)",
    checkout_place_order: "Ödemeye devam et",
    checkout_postal: "Posta kodu",
    checkout_return_pledge_label: "İade etmek istediğim takdirde ürünü açmamayı ve kullanmamayı taahhüt ediyorum.",
    checkout_return_pledge_required: "Devam etmek için lütfen iade taahhüdünü onaylayın.",
    checkout_return_policy_body: "Mağaza politikamıza göre açılmış veya kullanılmış bir ürün iade edilemez.",
    checkout_return_policy_title: "İade hakkı — lütfen okuyun",
    checkout_review: "İnceleme",
    checkout_secure_note: "Güvenli Stripe ödemesi.",
    checkout_shipping: "Teslimat adresi",
    checkout_street: "Sokak ve Kapı No",
    checkout_title: "Ödeme",
    consultation_intro: "Size seve seve danışmanlık yapabiliriz.",
    consultation_msg: "Sorunuz / Talebiniz",
    consultation_preferred: "Tercih edilen iletişim",
    consultation_preferred_time: "Tercih edilen randevu",
    consultation_subject: "Konu",
    consultation_submit: "Talebi gönder",
    consultation_thanks: "Teşekkürler – kısa süre içinde sizinle iletişime geçeceğiz.",
    consultation_title: "Danışma talebi",
    contact_address: "Adres",
    contact_email: "E-posta",
    contact_form_title: "Bize yazın",
    contact_hours: "Çalışma saatleri",
    contact_message: "Mesajınız",
    contact_phone: "Telefon",
    contact_send: "Mesaj gönder",
    contact_thanks: "Teşekkürler – kısa süre içinde döneceğiz.",
    contact_title: "İletişim",
    cookie_accept: "Kabul",
    cookie_decline: "Sadece gerekli",
    cookie_msg: "Bu site sadece teknik çerezler ve onayınızla anonim istatistik kullanır.",
    copyright: "Tüm hakları saklıdır.",
    current_password: "Mevcut şifre",
    delete_account: "Hesabı sil",
    delete_confirm: "Hesabı kalıcı olarak silmek istediğinizden emin misiniz?",
    email: "E-posta",
    footer_agb: "Genel Koşullar",
    footer_brand: "Marka",
    footer_cookies: "Çerezler",
    footer_datenschutz: "Gizlilik",
    footer_faq: "SSS",
    footer_help: "Yardım",
    footer_impressum: "Künye",
    footer_legal: "Yasal Bilgiler",
    footer_returns: "İade",
    footer_shipping: "Kargo",
    footer_shop: "Mağaza",
    forgot_password: "Şifrenizi mi unuttunuz?",
    founder_label: "Kurucu",
    free_shipping_over: "100 CHF üzeri ücretsiz kargo",
    hero_cta: "Koleksiyonu keşfet",
    hero_secondary: "Hikayemiz",
    hero_subtitle: "Premium saç, sakal ve cilt bakımı, doğal yağlar, Halep sabunu, misvak, kına ve daha fazlası – Glarus'taki Coiffeur Tattoo 01&Co. ekibinin özenli seçimi.",
    hero_title: "İsviçre ustalığı. Doğal bakım.",
    home_studio_alt: "Glarus'taki Coiffeur Tattoo 01&Co. Stüdyosu",
    ingredients: "İçindekiler",
    login: "Giriş yap",
    login_with_google: "Google ile giriş yapın",
    logout: "Çıkış Yap",
    medical_disclaimer: "Ürünlerimiz profesyonel tıbbi tavsiye yerine geçmez.",
    missing_token_error: "Token eksik.",
    my_orders: "Siparişlerim",
    my_profile: "Profilim",
    nav_about: "Hakkımızda",
    nav_account: "Hesap",
    nav_admin: "Yönetim",
    nav_cart: "Sepet",
    nav_consultation: "Danışmanlık",
    nav_contact: "İletişim",
    nav_home: "Anasayfa",
    nav_shop: "Mağaza",
    nav_tracking: "Sipariş takibi",
    nav_wishlist: "Favori Listem",
    new_badge: "Yeni",
    new_password: "Yeni şifre",
    newsletter_desc: "Yenilikler ve özel teklifler.",
    newsletter_label: "Bülten",
    newsletter_placeholder: "E-postanız",
    newsletter_submit: "Abone Ol",
    newsletter_title: "İlhamlı kalın.",
    no_questions: "Henüz soru yok.",
    no_reviews: "Henüz yorum yok.",
    order_number: "Sipariş no.",
    order_status_cancelled: "İptal edildi",
    order_status_delivered: "Teslim Edildi",
    order_status_paid: "Ödendi",
    order_status_pending: "Beklemede",
    order_status_processing: "İşleniyor",
    order_status_refunded: "İade Edildi",
    order_status_shipped: "Gönderildi",
    order_tracking_email: "E-posta Adresi",
    order_tracking_intro: "Sipariş no. ve e-posta girin.",
    order_tracking_not_found: "Sipariş bulunamadı.",
    order_tracking_number: "Sipariş no.",
    order_tracking_submit: "Takip et",
    order_tracking_title: "Sipariş takibi",
    otp_expires_hint: "Kod 10 dakika geçerlidir. Gerekirse spam klasörünüzü kontrol edin.",
    otp_heading: "Kodunuzu girin",
    otp_invalid: "Yanlış kod. Lütfen tekrar deneyin.",
    otp_resend: "Kodu tekrar gönder",
    otp_resent: "Yeni kod gönderildi.",
    otp_sent: "Size e-posta ile bir kod gönderdik.",
    otp_sent_to: "6 haneli bir kod gönderdik:",
    otp_title: "E-posta Onayı",
    otp_verified: "E-posta onaylandı — hoş geldiniz!",
    otp_verify: "Onayla",
    out_of_stock: "Stokta Yok",
    password: "Şifre",
    payment_cancel: "Ödeme iptal edildi",
    payment_cancel_msg: "Ödeme iptal edildi. Tekrar deneyebilirsiniz.",
    payment_success: "Ödeme başarılı",
    payment_success_msg: "Siparişiniz için teşekkürler!",
    payments_title: "Ödeme bilgileri",
    phone_label: "Telefon",
    price: "Fiyat",
    qa_disclaimer: "Yorumlar kişisel deneyimlerdir, tıbbi tavsiye yerine geçmez.",
    qa_login_required: "Soru sormak/cevaplamak için giriş yapın.",
    quantity: "Adet",
    question_pending: "Sorunuz inceleniyor.",
    questions_title: "Soru & Cevap",
    reason_natural: "Doğal içerikler",
    reason_natural_desc: "Her yağı özenle seçiyoruz.",
    reason_secure: "Güvenli ödeme",
    reason_secure_desc: "Stripe ile şifrelenmiştir.",
    reason_shipping: "Dünya çapında kargo",
    reason_shipping_desc: "CHF 100 ve üzeri siparişlerde ücretsiz kargo.",
    reason_swiss: "İsviçre markası",
    reason_swiss_desc: "Glarus'ta kuruldu – Hissedilen ustalık.",
    register: "Kayıt Ol",
    related_products: "Benzer Ürünler",
    report_content: "Bildir",
    reset_link_sent: "Hesap varsa, sıfırlama bağlantısı oluşturuldu.",
    reset_password: "Şifreyi Sıfırla",
    reset_success: "Şifre sıfırlandı.",
    ret_created: "İade talebiniz oluşturuldu.",
    ret_error: "Talep oluşturulamadı.",
    ret_existing_hint: "Sonraki adımlar için size döneceğiz.",
    ret_existing_title: "İade Durumu",
    ret_info_inspected: "İncelenme tarihi",
    ret_info_order: "Sipariş numarası",
    ret_info_products: "İade edilen ürünler",
    ret_info_products_all: "Tüm sipariş",
    ret_info_received: "Alınma tarihi",
    ret_info_refunded: "İade tarihi",
    ret_info_requested: "Talep tarihi",
    ret_inspection_failed_hint: "İnceleme sonrasında iadenizi maalesef kabul edemedik. Sorularınız için lütfen bizimle iletişime geçin.",
    ret_modal_intro: "Ürününüzün iade için uygun olabilmesi için açılmamış ve kullanılmamış olması gerekmektedir.",
    ret_modal_title: "Ürün iadesi",
    ret_only_delivered: "İade, sipariş teslim edildikten sonra kullanılabilir.",
    ret_pledge_label: "Ürünün açılmadığını ve kullanılmadığını, aldığım haliyle iade ettiğimi onaylıyorum.",
    ret_pledge_required: "Lütfen iade taahhüdünü onaylayın.",
    ret_reason_changed_mind: "Fikrimi değiştirdim",
    ret_reason_damaged: "Ürün hasarlı",
    ret_reason_group_customer: "Kişisel sebep",
    ret_reason_group_product: "Ürün veya sipariş ile ilgili sorun",
    ret_reason_no_longer_needed: "Artık ihtiyacım yok",
    ret_reason_order_error: "Siparişte hata",
    ret_reason_other: "Diğer sebep",
    ret_reason_other_issue: "Ürünle ilgili başka bir sorun",
    ret_reason_placeholder: "Lütfen sebebi açıklayın…",
    ret_reason_shipping_damage: "Hasarlı geldi",
    ret_reason_wrong_choice: "Yanlışlıkla yanlış ürünü seçtim",
    ret_reason_wrong_item: "Teslim edilen ürün siparişe uymuyor",
    ret_refund_amount: "İade tutarı",
    ret_refund_bank_note: "Tutarın hesabınızda görünmesi, bankanıza veya kart sağlayıcınıza bağlıdır ve birkaç iş günü sürebilir.",
    ret_refund_issue_body: "İade henüz tamamlanamadı ve işleme devam ediliyor. Herhangi bir işlem yapmanıza gerek yok — sorularınız için bize info@01co.ch adresinden ulaşabilirsiniz.",
    ret_refund_status_failed: "İade işlemde",
    ret_refund_status_processing: "İade işleniyor",
    ret_refund_status_succeeded: "İade gerçekleştirildi",
    ret_request_btn: "İade talebi",
    ret_resolution_free: "Ücretsiz iade · Kargo salon tarafından karşılanır",
    ret_resolution_paid: "Müşteri ödemeli iade · Kargo tarafınızca karşılanır",
    ret_rma_code: "RMA Kodu",
    ret_status_approved: "İade onaylandı",
    ret_status_rejected: "İade reddedildi",
    ret_status_requested: "İade talep edildi",
    ret_status_under_review: "İnceleniyor",
    ret_step_inspected: "Ürün incelendi",
    ret_step_received: "İade alındı",
    ret_step_refund_complete: "İade tamamlandı",
    ret_step_refund_initiated: "İade başlatıldı",
    ret_step_refund_issue: "İade — Sorun",
    ret_step_rejected: "İade reddedildi",
    ret_step_requested: "İade talep edildi",
    ret_submit: "Talep gönder",
    review_body: "Deneyiminiz",
    review_pending: "Değerlendirmeniz gönderildi ve inceleniyor.",
    review_rating: "Puan",
    review_title: "Başlık",
    reviews: "Yorumlar",
    sale_badge: "İndirim",
    save: "Kaydet",
    saved: "Kaydedildi",
    search_placeholder: "Ürün ara…",
    section_bestsellers: "Çok Satanlar",
    section_featured: "Öne çıkanlar",
    section_new: "Yeni Ürünler",
    section_oils: "Doğal yağlar",
    section_why_title: "Neden Coiffeur Tattoo 01&Co.",
    since_2011: "2011'den beri",
    size: "Beden",
    stock_in: "Stokta",
    stock_low: "Az sayıda mevcut",
    stock_low_1: "Tükenmek üzere — yalnızca 1 adet mevcut",
    stock_low_2: "Tükenmek üzere — yalnızca 2 adet mevcut",
    stock_low_3: "Tükenmek üzere — yalnızca 3 adet mevcut",
    stock_low_4: "Tükenmek üzere — yalnızca 4 adet mevcut",
    stock_out: "Tükendi",
    stock_setup: "Şu anda mevcut değil",
    submit_answer: "Yanıtı gönder",
    submit_question: "Soruyu gönder",
    submit_review: "Değerlendirmeyi gönder",
    suitable_bart: "Sakal",
    suitable_for: "Uygun",
    suitable_gesicht: "Yüz",
    suitable_haare: "Saç",
    suitable_haut: "Cilt",
    suitable_koerper: "Vücut",
    time_remaining_label: "Kalan Süre",
    tracking_carrier: "Kargo şirketi",
    tracking_link: "Sağlayıcıda takip et",
    tracking_number: "Takip no.",
    usage: "Kullanım",
    variant: "Varyant",
    verified_purchase: "Doğrulanmış satın alma",
    view_all: "Tümünü gör",
    view_details: "Detayları görüntüle",
    warnings: "Uyarılar",
    welcome: "Hoş geldiniz",
    wishlist_add: "Favorilere ekle",
    wishlist_empty: "İstek listeniz boş.",
    wishlist_login: "Favori listesini kullanmak için giriş yapın.",
    wishlist_remove: "İstek listesinden çıkar",
    wishlist_title: "Favoriler",
    write_review: "Değerlendirme yaz",
      cat_bartpflege: "Sakal Bakımı",
    cat_haarpflege: "Saç Bakımı",
    cat_sets_bundles: "Set ve Paketler",
},
  ar: {
    about_address: "Kirchweg 20, 8750 Glarus, سويسرا",
    about_founder: "المؤسس: سجاد الداغر",
    about_intro: "علامة سويسرية من غلاروس – الأناقة والجودة منذ 2011.",
    about_philosophy_body: "نؤمن أن المنتجات الطبيعية أكثر من مجرد منتجات — إنها صلة بين الناس والطبيعة والمعرفة التقليدية.",
    about_philosophy_title: "فلسفتنا",
    about_title: "كوافير تاتو 01&Co.",
    about_values_title: "طبيعي. أصيل. مختار بعناية.",
    add_to_cart: "أضف إلى السلة",
    address_label: "العنوان",
    admin_analytics: "التحليلات",
    admin_avg: "متوسط قيمة الطلب",
    admin_consultations: "طلبات الاستشارة",
    admin_customers: "العملاء",
    admin_discounts: "الخصومات",
    admin_orders: "الطلبات",
    admin_products: "المنتجات",
    admin_questions: "الأسئلة",
    admin_revenue: "الإيرادات",
    admin_reviews: "التقييمات",
    admin_title: "لوحة الإدارة",
    admin_total_orders: "إجمالي الطلبات",
    answer_placeholder: "الإجابة…",
    aria_account: "الحساب",
    aria_basra: "مساعد Basra",
    aria_cart: "سلة التسوق",
    aria_close: "إغلاق",
    aria_loading: "جارٍ التحميل…",
    aria_logo_home: "الصفحة الرئيسية لـ Coiffeur Tattoo 01&Co.",
    aria_menu: "القائمة",
    aria_remove: "إزالة",
    aria_send: "إرسال",
    aria_wishlist: "قائمة الأمنيات",
    ask_placeholder: "سؤالك...",
    ask_question: "اطرح سؤالاً",
    benefits: "المزايا",
    bestseller_badge: "الأكثر مبيعاً",
    book_appointment_nr: "رقم الموعد",
    book_appointment_time: "موعد",
    book_back: "رجوع",
    book_booking_confirmed: "تم تأكيد الموعد",
    book_booking_processing: "جارٍ الحجز...",
    book_cancel_policy: "شروط الإلغاء",
    book_cat_kids: "الأطفال والشباب",
    book_cat_men: "رجال",
    book_cat_tattoo: "الوشم",
    book_cat_unisex: "للجنسين",
    book_cat_women: "السيدات",
    book_colors: "الألوان",
    book_datetime: "التاريخ والوقت",
    book_description: "الوصف",
    book_email_confirmation: "لقد أرسلنا لك رسالة تأكيد عبر البريد الإلكتروني.",
    book_error_booking: "فشل الحجز",
    book_error_generic: "خطأ",
    book_full_name: "الاسم الكامل",
    book_lines: "الخطوط",
    book_next: "التالي",
    book_no_slots: "لا توجد مواعيد متاحة في هذا اليوم.",
    book_phone_num: "الهاتف",
    book_pick_date: "اختر التاريخ",
    book_pick_length: "اختر الطول",
    book_pick_time: "اختر الوقت",
    book_placeholder_colors: "الألوان (مثل: أسود، ملوّن …)",
    book_placeholder_desc: "وصف التصميم …",
    book_placeholder_lines: "الخطوط (مثلاً: رفيعة، عريضة...)",
    book_policy_5min: "بعد تأخر 5 دقائق دون اتصال مسبق تُطبق رسوم الإلغاء 50%. إذا اتصلت قبل انتهاء الخمس دقائق يمكن تمديد الموعد دون أي رسوم إضافية.",
    book_policy_free_6h: "إلغاء مجاني حتى 6 ساعات قبل موعد الحلاقة (التاتو: 24 ساعة).",
    book_policy_late_fee: "بعد ذلك تُطبق رسوم 50% من قيمة الخدمة.",
    book_policy_within_6h: "المواعيد خلال 6 ساعات قادمة لا يمكن إلغاؤها.",
    book_preferred_time: "الموعد المفضل (اختياري)",
    book_price: "السعر",
    book_price_from: "من",
    book_price_on_request: "السعر عند الطلب",
    book_request_sent: "تم إرسال الطلب",
    book_selected_service: "الخدمة المختارة",
    book_send_request: "إرسال الطلب",
    book_sending: "جارٍ الإرسال...",
    book_size: "الحجم",
    book_size_large: "كبير (أكثر من 20 سم)",
    book_size_medium: "متوسط (10-20 سم)",
    book_size_small: "صغير (حتى 10 سم)",
    book_state_blocked_hover: "⚫ غير متاح — مغلق أو محظور",
    book_state_booked_hover: "🔴 محجوز — تم الحجز مسبقاً",
    book_state_free_hover: "🟢 متاح — يمكن الحجز الآن",
    book_state_mine_hover: "🔵 موعدك أنت",
    book_state_needs_conf_hover: "🟠 بانتظار تأكيد الإدارة",
    book_state_pending_hover: "🟡 قيد الحجز — عملية جارية",
    book_state_too_soon_hover: "⚫ قريب جداً — يجب 30 دقيقة على الأقل",
    book_status_blocked: "مغلق",
    book_status_booked: "محجوز",
    book_status_free: "متاح",
    book_status_mine: "موعدك",
    book_status_needs_conf: "بانتظار التأكيد",
    book_status_pending: "قيد المعالجة",
    book_step_done: "تم",
    book_step_info: "البيانات",
    book_step_service: "الخدمة",
    book_step_time: "الموعد",
    book_submit_booking: "تأكيد الحجز",
    book_tattoo_no_price: "لا يوجد سعر ثابت. صِف التصميم الذي تريده وسنتواصل معك لتحديد السعر والموعد.",
    book_tattoo_title: "طلب تاتو",
    book_termin_agreement: "موعد بالاتفاق",
    book_will_contact: "سنتواصل معك قريباً لتحديد السعر والموعد.",
    book_your_info: "بياناتك",
    booking_eyebrow: "حجز موعد",
    booking_title: "احجز موعدك",
    brand_tagline: "الشعر والجمال منذ 2011",
    buy_now: "اشترِ الآن",
    cart_added: "أُضيف",
    cart_apply: "تطبيق",
    cart_checkout: "إتمام الشراء",
    cart_continue: "متابعة التسوق",
    cart_discount: "الخصم",
    cart_discount_applied: "تم تطبيق الخصم",
    cart_discount_code: "كود الخصم",
    cart_discount_invalid: "كود الخصم غير صالح",
    cart_empty: "سلة التسوق فارغة.",
    cart_remove: "إزالة",
    cart_shipping: "الشحن",
    cart_subtotal: "المجموع الفرعي",
    cart_tax_note: "يتم احتساب ضريبة القيمة المضافة عند الدفع",
    cart_title: "السلة",
    cart_total: "المجموع",
    change_password: "تغيير كلمة المرور",
    channel_email: "البريد الإلكتروني",
    channel_phone: "الهاتف",
    channel_whatsapp: "WhatsApp",
    checkout_address: "الشارع والرقم",
    checkout_billing: "عنوان الفاتورة",
    checkout_billing_same: "عنوان الفوترة نفس عنوان الشحن",
    checkout_city: "المدينة",
    checkout_contact: "التواصل",
    checkout_country: "الدولة",
    checkout_email: "البريد الإلكتروني",
    checkout_name: "الاسم الكامل",
    checkout_notes: "ملاحظات الطلب (اختياري)",
    checkout_payment: "الدفع",
    checkout_phone: "الهاتف (اختياري)",
    checkout_place_order: "المتابعة إلى الدفع",
    checkout_postal: "الرمز البريدي",
    checkout_review: "المراجعة",
    checkout_secure_note: "دفع آمن عبر Stripe.",
    checkout_shipping: "عنوان التوصيل",
    checkout_title: "الدفع",
    consultation_intro: "يسعدنا تقديم النصح لك.",
    consultation_msg: "سؤالك / طلبك",
    consultation_preferred: "طريقة التواصل المفضلة",
    consultation_preferred_time: "الموعد المفضل",
    consultation_subject: "الموضوع",
    consultation_submit: "إرسال الطلب",
    consultation_thanks: "شكراً – سنتواصل معك قريباً.",
    consultation_title: "طلب استشارة",
    contact_address: "العنوان",
    contact_email: "البريد الإلكتروني",
    contact_form_title: "اكتب لنا",
    contact_hours: "ساعات العمل",
    contact_message: "رسالتك",
    contact_phone: "الهاتف",
    contact_send: "إرسال رسالة",
    contact_thanks: "شكراً – سنعود إليك قريباً.",
    contact_title: "اتصل بنا",
    cookie_accept: "قبول",
    cookie_decline: "الضرورية فقط",
    cookie_msg: "يستخدم هذا الموقع ملفات تعريف ارتباط فنية فقط، وبموافقتك إحصاءات مجهولة.",
    copyright: "جميع الحقوق محفوظة.",
    current_password: "كلمة المرور الحالية",
    delete_account: "حذف الحساب",
    delete_confirm: "هل تريد حقاً حذف الحساب بشكل نهائي؟",
    email: "البريد الإلكتروني",
    footer_agb: "الشروط والأحكام",
    footer_brand: "العلامة التجارية",
    footer_cookies: "ملفات تعريف الارتباط",
    footer_datenschutz: "الخصوصية",
    footer_faq: "الأسئلة الشائعة",
    footer_help: "المساعدة",
    footer_impressum: "معلومات قانونية",
    footer_legal: "الشروط القانونية",
    footer_returns: "الإرجاع",
    footer_shipping: "الشحن",
    footer_shop: "المتجر",
    forgot_password: "هل نسيت كلمة المرور؟",
    founder_label: "المؤسس",
    free_shipping_over: "شحن مجاني فوق 100 فرنك سويسري",
    hero_cta: "اكتشف المجموعة",
    hero_secondary: "قصتنا",
    hero_subtitle: "منتجات فاخرة للشعر واللحية والبشرة، زيوت طبيعية، صابون حلب، سواك، حناء والمزيد — بعناية من فريق كوافير تاتو 01&Co. في غلاروس.",
    hero_title: "حرفية سويسرية. عناية طبيعية.",
    home_studio_alt: "استوديو Coiffeur Tattoo 01&Co. في Glarus",
    ingredients: "المكونات",
    login: "تسجيل الدخول",
    logout: "تسجيل الخروج",
    medical_disclaimer: "منتجاتنا لا تُغني عن الاستشارة الطبية المتخصصة.",
    missing_token_error: "الرمز مفقود.",
    my_orders: "طلباتي",
    my_profile: "ملفي الشخصي",
    nav_about: "عن Coiffeur Tattoo 01&Co.",
    nav_account: "الحساب",
    nav_admin: "لوحة التحكم",
    nav_cart: "سلة التسوق",
    nav_consultation: "الاستشارة",
    nav_contact: "اتصل بنا",
    nav_home: "الرئيسية",
    nav_shop: "المتجر",
    nav_tracking: "تتبع الطلب",
    nav_wishlist: "قائمة الأمنيات",
    new_badge: "جديد",
    new_password: "كلمة مرور جديدة",
    newsletter_desc: "منتجات جديدة وعروض حصرية.",
    newsletter_label: "النشرة الإخبارية",
    newsletter_placeholder: "بريدك الإلكتروني",
    newsletter_submit: "اشترك",
    newsletter_title: "ابقَ ملهماً.",
    no_questions: "لا توجد أسئلة بعد.",
    no_reviews: "لا توجد تقييمات بعد.",
    order_number: "رقم الطلب",
    order_status_cancelled: "ملغى",
    order_status_delivered: "تم التوصيل",
    order_status_paid: "مدفوع",
    order_status_pending: "قيد الانتظار",
    order_status_processing: "قيد المعالجة",
    order_status_refunded: "تم الاسترداد",
    order_status_shipped: "تم الشحن",
    order_tracking_email: "البريد الإلكتروني",
    order_tracking_intro: "أدخل رقم الطلب والبريد الإلكتروني.",
    order_tracking_not_found: "لم يتم العثور على الطلب.",
    order_tracking_number: "رقم الطلب",
    order_tracking_submit: "تتبع",
    order_tracking_title: "تتبع الطلب",
    out_of_stock: "نفدت الكمية",
    password: "كلمة المرور",
    payment_cancel: "تم إلغاء الدفع",
    payment_cancel_msg: "تم إلغاء الدفع، يمكنك المحاولة مجدداً.",
    payment_success: "تم الدفع بنجاح",
    payment_success_msg: "شكراً لطلبك!",
    payments_title: "معلومات الدفع",
    phone_label: "الهاتف",
    price: "السعر",
    qa_disclaimer: "آراء العملاء تجارب شخصية ولا تُغني عن الاستشارة الطبية.",
    qa_login_required: "يرجى تسجيل الدخول لطرح سؤال.",
    quantity: "الكمية",
    question_pending: "تم إرسال سؤالك وهو قيد المراجعة.",
    questions_title: "أسئلة وأجوبة",
    reason_natural: "مكونات طبيعية",
    reason_natural_desc: "نختار كل زيت بعناية فائقة.",
    reason_secure: "دفع آمن",
    reason_secure_desc: "مشفّر عبر Stripe.",
    reason_shipping: "شحن عالمي",
    reason_shipping_desc: "شحن مجاني للطلبات فوق CHF 100.",
    reason_swiss: "علامة سويسرية",
    reason_swiss_desc: "تأسس في Glarus – حرفية تشعر بها.",
    register: "إنشاء حساب",
    related_products: "منتجات مشابهة",
    report_content: "إبلاغ",
    reset_link_sent: "إذا كان الحساب موجوداً، فقد تم إنشاء رابط.",
    reset_password: "إعادة تعيين كلمة المرور",
    reset_success: "تمت إعادة تعيين كلمة المرور.",
    review_body: "تجربتك",
    review_pending: "تم إرسال تقييمك وهو قيد المراجعة.",
    review_rating: "التقييم",
    review_title: "العنوان",
    reviews: "التقييمات",
    sale_badge: "تخفيض",
    save: "حفظ",
    saved: "تم الحفظ",
    search_placeholder: "ابحث عن منتجات…",
    section_bestsellers: "الأكثر مبيعاً",
    section_featured: "مختارات",
    section_new: "المنتجات الجديدة",
    section_oils: "زيوت طبيعية",
    section_why_title: "لماذا كوافير تاتو 01&Co.",
    since_2011: "منذ ٢٠١١",
    size: "المقاس",
    stock_in: "متوفر",
    stock_low: "كمية محدودة متاحة",
    stock_low_1: "أوشك على النفاد — قطعة واحدة فقط متاحة",
    stock_low_2: "أوشك على النفاد — قطعتان فقط متاحتان",
    stock_low_3: "أوشك على النفاد — 3 قطع فقط متاحة",
    stock_low_4: "أوشك على النفاد — 4 قطع فقط متاحة",
    stock_out: "نفد من المخزون",
    stock_setup: "غير متاح حالياً",
    submit_answer: "إرسال الإجابة",
    submit_question: "إرسال السؤال",
    submit_review: "إرسال التقييم",
    suitable_bart: "اللحية",
    suitable_for: "مناسب لـ",
    suitable_gesicht: "الوجه",
    suitable_haare: "الشعر",
    suitable_haut: "البشرة",
    suitable_koerper: "الجسم",
    time_remaining_label: "الوقت المتبقي",
    tracking_carrier: "شركة الشحن",
    tracking_link: "تتبع لدى المزود",
    tracking_number: "رقم التتبع",
    usage: "طريقة الاستخدام",
    variant: "الخيار",
    verified_purchase: "عملية شراء موثقة",
    view_all: "عرض الكل",
    view_details: "عرض التفاصيل",
    warnings: "تنبيهات",
    wishlist_add: "إضافة إلى المفضلة",
    wishlist_empty: "قائمة أمنياتك فارغة.",
    wishlist_login: "يرجى تسجيل الدخول لاستخدام المفضلة.",
    wishlist_remove: "إزالة من قائمة الأمنيات",
    wishlist_title: "المفضلة",
    write_review: "كتابة تقييم",
      cat_bartpflege: "العناية باللحية",
    cat_haarpflege: "العناية بالشعر",
    cat_sets_bundles: "مجموعات وأطقم",
},
  fa: {
    about_address: "Kirchweg 20, 8750 Glarus, سوئیس",
    about_founder: "بنیانگذار: سجاد الداغر",
    about_intro: "یک برند سوئیسی از گلاروس – سبک و کیفیت از سال ۲۰۱۱.",
    about_philosophy_body: "ما باور داریم محصولات طبیعی بیش از یک محصول هستند — پیوندی میان انسان، طبیعت و دانش سنتی.",
    about_philosophy_title: "فلسفه ما",
    about_title: "Coiffeur Tattoo 01&Co.",
    about_values_title: "طبیعی. اصیل. با دقت انتخاب‌شده.",
    add_to_cart: "افزودن به سبد",
    address_label: "آدرس",
    admin_analytics: "تحلیل‌ها",
    admin_avg: "متوسط ارزش سفارش",
    admin_consultations: "درخواست‌های مشاوره",
    admin_customers: "مشتریان",
    admin_discounts: "تخفیف‌ها",
    admin_orders: "سفارشات",
    admin_products: "محصولات",
    admin_questions: "پرسش‌ها",
    admin_revenue: "درآمد",
    admin_reviews: "نظرات",
    admin_title: "پنل مدیریت",
    admin_total_orders: "مجموع سفارشات",
    answer_placeholder: "پاسخ…",
    aria_account: "حساب کاربری",
    aria_basra: "دستیار Basra",
    aria_cart: "سبد خرید",
    aria_close: "بستن",
    aria_loading: "در حال بارگذاری…",
    aria_logo_home: "صفحه اصلی Coiffeur Tattoo 01&Co.",
    aria_menu: "منو",
    aria_remove: "حذف",
    aria_send: "ارسال",
    aria_wishlist: "لیست علاقه‌مندی‌ها",
    ask_placeholder: "پرسش شما …",
    ask_question: "پرسش خود را مطرح کنید",
    auth_error: "خطا در ورود.",
    auth_or: "یا",
    benefits: "مزایا",
    bestseller_badge: "پرفروش‌ترین",
    book_add: "افزودن",
    book_added_to_cart: "به رزرو افزوده شد",
    book_appointment_nr: "شماره نوبت",
    book_appointment_time: "وقت ملاقات",
    book_autofilled: "تکمیل خودکار",
    book_back: "بازگشت",
    book_booking_confirmed: "نوبت تأیید شد",
    book_booking_processing: "در حال رزرو…",
    book_cancel_policy: "شرایط لغو",
    book_cart_empty: "هنوز خدمتی انتخاب نشده است.",
    book_cat_kids: "کودکان و نوجوانان",
    book_cat_men: "آقایان",
    book_cat_tattoo: "تاتو",
    book_cat_unisex: "مخلوط",
    book_cat_women: "بانوان",
    book_colors: "رنگ‌ها",
    book_customer_eyebrow: "اطلاعات شما",
    book_customer_hint: "لطفاً یک‌بار تکمیل کنید — در بازدید بعدی، اطلاعات شما به‌طور خودکار وارد می‌شود.",
    book_datetime: "زمان",
    book_deposit_note_body: "پیش‌پرداخت طبق سیاست لغو و تأخیر ما قابل استرداد نیست: در صورت لغو کمتر از 24 ساعت قبل از وقت ملاقات، رزرو همان‌روز، عدم حضور و همچنین تأخیر بیش از 5 دقیقه بدون اطلاع تلفنی به‌موقع. در صورت لغو به‌موقع (≥ 24 ساعت)، پیش‌پرداخت به‌طور کامل بازگردانده می‌شود.",
    book_deposit_note_title: "نکته مهم درباره پیش‌پرداخت (50%)",
    book_deposit_required: "برای خدمات، پیش‌پرداخت آنلاین الزامی است. ادامه به Stripe …",
    book_description: "توضیحات",
    book_edit: "ویرایش",
    book_email_confirmation: "تأییدیه به ایمیل شما ارسال شد.",
    book_error_booking: "خطا در رزرو",
    book_error_generic: "خطا",
    book_fill_required: "لطفاً تمام فیلدهای الزامی را تکمیل کنید.",
    book_full_name: "نام کامل",
    book_lines: "خطوط",
    book_loading_details: "در حال بارگیری جزئیات …",
    book_login_hint: "نکته: وارد شوید تا اطلاعات شما در دفعه بعد به‌طور خودکار وارد شود.",
    book_multi_hint: "به تعداد دلخواه از هر دسته، خدمات انتخاب کنید. تاریخ و زمان را در مرحله بعد تعیین می‌کنید.",
    book_next: "بعدی",
    book_no_slots: "برای این روز زمان آزادی وجود ندارد.",
    book_payment_breakdown: "جزئیات پرداخت",
    book_phone_num: "تلفن",
    book_pick_date: "انتخاب تاریخ",
    book_pick_length: "انتخاب طول",
    book_pick_time: "انتخاب ساعت",
    book_placeholder_colors: "رنگ‌ها (مثلاً مشکی، رنگی …)",
    book_placeholder_desc: "توضیحات طرح …",
    book_placeholder_lines: "خطوط (مثلاً نازک، ضخیم …)",
    book_policy_5min: "در صورت تأخیر بیش از ۵ دقیقه بدون اطلاع تلفنی، جریمه (۵۰ ٪) اعمال می‌شود. اگر ظرف ۵ دقیقه تماس بگیرید، نوبت بدون هزینه اضافه تمدید می‌شود.",
    book_policy_free_6h: "لغو رایگان تا ۶ ساعت قبل از نوبت آرایشگاه (تتو: ۲۴ ساعت).",
    book_policy_late_fee: "در صورت لغو دیرتر، ۵۰ ٪ از قیمت به‌عنوان جریمه دریافت می‌شود.",
    book_policy_within_6h: "نوبت‌های ۶ ساعت آینده دیگر قابل لغو نیستند.",
    book_preferred_time: "زمان دلخواه (اختیاری)",
    book_price: "قیمت",
    book_price_from: "از",
    book_price_on_request: "قیمت بر اساس درخواست",
    book_remove: "حذف",
    book_request_sent: "درخواست ارسال شد",
    book_reservation: "رزرو",
    book_review_add_product: "افزودن محصول",
    book_review_add_service: "خدمت بیشتر",
    book_review_continue_pay: "ادامه به پرداخت",
    book_review_continue_schedule: "ادامه به انتخاب وقت",
    book_review_deposit_now: "پیش‌پرداخت اکنون",
    book_review_due_now: "مبلغ کل اکنون",
    book_review_eyebrow: "خلاصه رزرو",
    book_review_products_total: "مجموع محصولات",
    book_review_question: "می‌خواهید خدمت یا محصول دیگری اضافه کنید، یا مستقیماً به انتخاب وقت بروید؟",
    book_review_rest_at_salon: "مبلغ باقی‌مانده در سالن",
    book_review_services_total: "مجموع خدمات",
    book_review_split_note: "برای خدمات، اکنون 50% به‌عنوان پیش‌پرداخت می‌پردازید، بقیه را در سالن. محصولات به‌طور کامل آنلاین پرداخت می‌شوند.",
    book_review_summary: "خلاصه",
    book_review_title: "تقریباً تمام — چیزی می‌خواهید اضافه کنید؟",
    book_review_your_products: "محصولات شما",
    book_review_your_services: "خدمات شما",
    book_schedule_hint: "مدت کل:",
    book_selected_service: "خدمت انتخاب‌شده",
    book_send_request: "ارسال درخواست",
    book_sending: "در حال ارسال…",
    book_size: "اندازه",
    book_size_large: "بزرگ (بیش از ۲۰ سانتی‌متر)",
    book_size_medium: "متوسط (۱۰–۲۰ سانتی‌متر)",
    book_size_small: "کوچک (تا ۱۰ سانتی‌متر)",
    book_state_blocked_hover: "⚫ در دسترس نیست — بسته یا مسدود",
    book_state_booked_hover: "🔴 رزرو شده — قبلاً رزرو شده است",
    book_state_free_hover: "🟢 آزاد — قابل رزرو",
    book_state_mine_hover: "🔵 نوبت شما",
    book_state_needs_conf_hover: "🟠 در انتظار تأیید",
    book_state_pending_hover: "🟡 در حال انجام — رزرو در جریان",
    book_state_too_soon_hover: "⚫ خیلی زود — حداقل ۳۰ دقیقه از قبل",
    book_status_blocked: "مسدود",
    book_status_booked: "رزرو شده",
    book_status_free: "آزاد",
    book_status_mine: "وقت ملاقات شما",
    book_status_needs_conf: "در انتظار تأیید",
    book_status_pending: "در حال بررسی",
    book_step_done: "تمام",
    book_step_info: "اطلاعات",
    book_step_service: "خدمت",
    book_step_time: "زمان ملاقات",
    book_submit_booking: "تأیید رزرو",
    book_tattoo_no_price: "بدون قیمت ثابت. طرح مورد نظر خود را توضیح دهید – ما برای قیمت و زمان ملاقات با شما تماس خواهیم گرفت.",
    book_tattoo_title: "درخواست تتو",
    book_termin_agreement: "با تعیین وقت قبلی",
    book_visit_hint: "منتظر دیدار شما هستیم. مبلغ باقی‌مانده در سالن پرداخت می‌شود.",
    book_will_contact: "به زودی برای قیمت و زمان ملاقات با شما تماس می‌گیریم.",
    book_your_cart: "انتخاب شما",
    book_your_info: "اطلاعات شما",
    book_your_visit: "بازدید شما",
    booking_eyebrow: "رزرو وقت ملاقات",
    booking_title: "نوبت خود را رزرو کنید",
    brand_tagline: "مو و زیبایی از سال ۲۰۱۱",
    buy_now: "خرید فوری",
    cart_added: "افزوده شد",
    cart_apply: "اعمال",
    cart_checkout: "پرداخت",
    cart_continue: "ادامه خرید",
    cart_discount: "تخفیف",
    cart_discount_applied: "تخفیف اعمال شد",
    cart_discount_code: "کد تخفیف",
    cart_discount_invalid: "کد تخفیف نامعتبر است",
    cart_empty: "سبد خرید شما خالی است.",
    cart_remove: "حذف",
    cart_shipping: "حمل و نقل",
    cart_subtotal: "جمع جزء",
    cart_tax_note: "مالیات در هنگام پرداخت محاسبه می‌شود",
    cart_title: "سبد خرید",
    cart_total: "جمع کل",
    change_password: "تغییر رمز عبور",
    channel_email: "ایمیل",
    channel_phone: "تلفن",
    channel_whatsapp: "WhatsApp",
    checkout_address: "خیابان و پلاک",
    checkout_apartment: "آپارتمان / طبقه (اختیاری)",
    checkout_billing: "آدرس صورتحساب",
    checkout_billing_same: "آدرس صورتحساب همانند ارسال",
    checkout_city: "شهر",
    checkout_contact: "تماس",
    checkout_country: "کشور",
    checkout_email: "ایمیل",
    checkout_first_name: "نام",
    checkout_hold_expired_action: "انتخاب وقت جدید",
    checkout_hold_expired_body: "وقت ملاقات آزاد شد و ممکن است توسط شخص دیگری انتخاب شده باشد. لطفاً زمان جدیدی انتخاب کنید.",
    checkout_hold_expired_title: "رزرو شما منقضی شده است",
    checkout_hold_expiring: "رزرو به‌زودی منقضی می‌شود",
    checkout_hold_hint: "وقت انتخابی شما برای شما رزرو شده است. لطفاً پرداخت را پیش از پایان مهلت تکمیل کنید.",
    checkout_hold_title: "رزرو شما",
    checkout_last_name: "نام خانوادگی",
    checkout_name: "نام کامل",
    checkout_notes: "یادداشت سفارش (اختیاری)",
    checkout_pay_in_store: "پرداخت حضوری در سالن",
    checkout_pay_in_store_deposit_hint: "برای وقت ملاقات، پیش‌پرداخت آنلاین الزامی است. مبلغ باقی‌مانده در سالن پرداخت می‌شود.",
    checkout_pay_in_store_hint: "اکنون رزرو کنید، هنگام دریافت در سالن نقدی یا با کارت بپردازید (Kirchweg 20, Glarus).",
    checkout_pay_online: "پرداخت آنلاین",
    checkout_pay_online_hint: "کارت، TWINT، Apple Pay، Klarna – امن از طریق Stripe.",
    checkout_payment: "پرداخت",
    checkout_phone: "تلفن (اختیاری)",
    checkout_place_order: "ادامه به پرداخت",
    checkout_postal: "کد پستی",
    checkout_return_pledge_label: "متعهد می‌شوم که در صورت تمایل به بازگرداندن، محصول را باز یا استفاده نکنم.",
    checkout_return_pledge_required: "لطفاً تعهد بازگشت را برای ادامه تأیید کنید.",
    checkout_return_policy_body: "طبق سیاست فروشگاه ما، محصول بازشده یا استفاده‌شده قابل بازگشت نیست.",
    checkout_return_policy_title: "حق بازگشت — لطفاً بخوانید",
    checkout_review: "بررسی نهایی",
    checkout_secure_note: "پرداخت امن با Stripe.",
    checkout_shipping: "آدرس تحویل",
    checkout_street: "خیابان و پلاک",
    checkout_title: "پرداخت",
    consultation_intro: "با کمال میل به شما مشاوره می‌دهیم.",
    consultation_msg: "سوال / درخواست شما",
    consultation_preferred: "روش تماس ترجیحی",
    consultation_preferred_time: "زمان دلخواه ملاقات",
    consultation_subject: "موضوع",
    consultation_submit: "ارسال درخواست",
    consultation_thanks: "متشکریم – به زودی با شما تماس می‌گیریم.",
    consultation_title: "درخواست مشاوره",
    contact_address: "آدرس",
    contact_email: "ایمیل",
    contact_form_title: "برای ما بنویسید",
    contact_hours: "ساعات کاری",
    contact_message: "پیام شما",
    contact_phone: "تلفن",
    contact_send: "ارسال پیام",
    contact_thanks: "سپاس – به‌زودی با شما تماس می‌گیریم.",
    contact_title: "تماس",
    cookie_accept: "پذیرفتن",
    cookie_decline: "فقط ضروری",
    cookie_msg: "این سایت فقط از کوکی‌های فنی و — با اجازه شما — آمار بی‌نام استفاده می‌کند.",
    copyright: "کلیه حقوق محفوظ است.",
    current_password: "رمز عبور فعلی",
    delete_account: "حذف حساب",
    delete_confirm: "آیا واقعاً می‌خواهید حساب کاربری را برای همیشه حذف کنید؟",
    email: "ایمیل",
    footer_agb: "شرایط و ضوابط",
    footer_brand: "برند",
    footer_cookies: "کوکی‌ها",
    footer_datenschutz: "حریم خصوصی",
    footer_faq: "سوالات متداول",
    footer_help: "راهنما",
    footer_impressum: "اطلاعات حقوقی",
    footer_legal: "قوانین",
    footer_returns: "مرجوعی",
    footer_shipping: "ارسال",
    footer_shop: "فروشگاه",
    forgot_password: "رمز عبور را فراموش کرده‌اید؟",
    founder_label: "بنیانگذار",
    free_shipping_over: "ارسال رایگان برای خرید بیش از ۱۰۰ فرانک سوئیس",
    hero_cta: "کاوش مجموعه",
    hero_secondary: "داستان ما",
    hero_subtitle: "محصولات ممتاز مراقبت از مو، ریش و پوست، روغن‌های طبیعی، صابون حلب، مسواک، حنا و بیشتر — انتخاب تیم Coiffeur Tattoo 01&Co. در گلاروس.",
    hero_title: "صنعت‌گری سوئیسی. مراقبت طبیعی.",
    home_studio_alt: "استودیو Coiffeur Tattoo 01&Co. در Glarus",
    ingredients: "ترکیبات",
    login: "ورود",
    login_with_google: "ورود با Google",
    logout: "خروج",
    medical_disclaimer: "محصولات ما جایگزین مشاوره پزشکی حرفه‌ای نیستند.",
    missing_token_error: "توکن موجود نیست.",
    my_orders: "سفارش‌های من",
    my_profile: "پروفایل من",
    nav_about: "درباره ما",
    nav_account: "حساب کاربری",
    nav_admin: "مدیریت",
    nav_cart: "سبد خرید",
    nav_consultation: "مشاوره",
    nav_contact: "تماس",
    nav_home: "خانه",
    nav_shop: "فروشگاه",
    nav_tracking: "پیگیری سفارش",
    nav_wishlist: "لیست علاقه‌مندی‌ها",
    new_badge: "جدید",
    new_password: "رمز عبور جدید",
    newsletter_desc: "محصولات تازه و پیشنهادهای ویژه.",
    newsletter_label: "خبرنامه",
    newsletter_placeholder: "ایمیل شما",
    newsletter_submit: "عضویت",
    newsletter_title: "الهام‌بخش بمانید.",
    no_questions: "هنوز پرسشی مطرح نشده.",
    no_reviews: "هنوز دیدگاهی ثبت نشده.",
    order_number: "شماره سفارش",
    order_status_cancelled: "لغوشده",
    order_status_delivered: "تحویل داده شده",
    order_status_paid: "پرداخت شده",
    order_status_pending: "در انتظار",
    order_status_processing: "در حال پردازش",
    order_status_refunded: "بازپرداخت شده",
    order_status_shipped: "ارسال‌شده",
    order_tracking_email: "آدرس ایمیل",
    order_tracking_intro: "شماره سفارش و ایمیل خود را وارد کنید.",
    order_tracking_not_found: "سفارش یافت نشد.",
    order_tracking_number: "شماره سفارش",
    order_tracking_submit: "پیگیری",
    order_tracking_title: "پیگیری سفارش",
    otp_expires_hint: "کد برای 10 دقیقه معتبر است. در صورت لزوم پوشه هرزنامه را بررسی کنید.",
    otp_heading: "کد خود را وارد کنید",
    otp_invalid: "کد اشتباه است. لطفاً دوباره تلاش کنید.",
    otp_resend: "ارسال مجدد کد",
    otp_resent: "کد جدید ارسال شد.",
    otp_sent: "کدی از طریق ایمیل برای شما ارسال کردیم.",
    otp_sent_to: "کد 6 رقمی ارسال شد به:",
    otp_title: "تأیید ایمیل",
    otp_verified: "ایمیل تأیید شد — خوش آمدید!",
    otp_verify: "تأیید",
    out_of_stock: "ناموجود",
    password: "رمز عبور",
    payment_cancel: "پرداخت لغو شد",
    payment_cancel_msg: "پرداخت لغو شد. می‌توانید دوباره تلاش کنید.",
    payment_success: "پرداخت موفق",
    payment_success_msg: "از سفارش شما سپاسگزاریم!",
    payments_title: "اطلاعات پرداخت",
    phone_label: "تلفن",
    price: "قیمت",
    qa_disclaimer: "نظرات، تجربه شخصی هستند و جایگزین مشاوره پزشکی نمی‌شوند.",
    qa_login_required: "برای پرسش یا پاسخ وارد شوید.",
    quantity: "تعداد",
    question_pending: "پرسش شما در حال بررسی است.",
    questions_title: "پرسش و پاسخ",
    reason_natural: "مواد طبیعی",
    reason_natural_desc: "ما هر روغن را با دقت انتخاب می‌کنیم.",
    reason_secure: "پرداخت امن",
    reason_secure_desc: "رمزگذاری شده با Stripe.",
    reason_shipping: "ارسال جهانی",
    reason_shipping_desc: "ارسال رایگان بالای CHF 100.",
    reason_swiss: "برند سوئیسی",
    reason_swiss_desc: "تأسیس شده در Glarus – هنری که حس می‌شود.",
    register: "ثبت‌نام",
    related_products: "محصولات مشابه",
    report_content: "گزارش",
    reset_link_sent: "اگر حساب وجود داشته باشد، لینک ساخته شده.",
    reset_password: "بازنشانی رمز عبور",
    reset_success: "رمز عبور بازنشانی شد.",
    ret_created: "درخواست بازگشت شما ایجاد شد.",
    ret_error: "درخواست ایجاد نشد.",
    ret_existing_hint: "مراحل بعدی را برای شما اطلاع‌رسانی می‌کنیم.",
    ret_existing_title: "وضعیت بازگشت",
    ret_info_inspected: "بررسی شده در",
    ret_info_order: "شماره سفارش",
    ret_info_products: "محصولات بازگشتی",
    ret_info_products_all: "کل سفارش",
    ret_info_received: "دریافت شده در",
    ret_info_refunded: "بازپرداخت شده در",
    ret_info_requested: "درخواست شده در",
    ret_inspection_failed_hint: "متأسفانه پس از بررسی، نتوانستیم بازگشت شما را بپذیریم. در صورت سؤال با ما تماس بگیرید.",
    ret_modal_intro: "برای واجد شرایط بودن محصول برای بازگشت، نباید باز یا استفاده شده باشد.",
    ret_modal_title: "بازگشت محصول",
    ret_only_delivered: "بازگشت پس از تحویل سفارش امکان‌پذیر است.",
    ret_pledge_label: "تأیید می‌کنم که محصول باز یا استفاده نشده و آن را به همان وضعیتی که دریافت کردم بازمی‌گردانم.",
    ret_pledge_required: "لطفاً تعهد بازگشت را تأیید کنید.",
    ret_reason_changed_mind: "نظرم عوض شد",
    ret_reason_damaged: "محصول آسیب دیده است",
    ret_reason_group_customer: "دلیل شخصی",
    ret_reason_group_product: "مشکل در محصول یا سفارش",
    ret_reason_no_longer_needed: "دیگر به آن نیاز ندارم",
    ret_reason_order_error: "خطا در سفارش",
    ret_reason_other: "دلیل دیگر",
    ret_reason_other_issue: "مشکل دیگری با محصول",
    ret_reason_placeholder: "لطفاً دلیل را شرح دهید…",
    ret_reason_shipping_damage: "آسیب‌دیده رسید",
    ret_reason_wrong_choice: "اشتباهاً محصول اشتباه انتخاب کردم",
    ret_reason_wrong_item: "محصول تحویلی با سفارش مطابقت ندارد",
    ret_refund_amount: "مبلغ بازپرداخت",
    ret_refund_bank_note: "مدت زمان نمایش مبلغ در حساب شما به بانک یا ارائه‌دهنده کارت شما بستگی دارد و ممکن است چند روز کاری طول بکشد.",
    ret_refund_issue_body: "بازپرداخت هنوز تکمیل نشده و در حال پردازش است. نیازی به اقدام ندارید — در صورت سؤال از طریق info@01co.ch با ما تماس بگیرید.",
    ret_refund_status_failed: "بازپرداخت هنوز در حال پردازش",
    ret_refund_status_processing: "بازپرداخت در حال انجام",
    ret_refund_status_succeeded: "بازپرداخت انجام شد",
    ret_request_btn: "درخواست بازگشت",
    ret_resolution_free: "بازگشت رایگان · هزینه ارسال توسط سالن پرداخت می‌شود",
    ret_resolution_paid: "بازگشت به هزینه مشتری · هزینه ارسال به عهده شما",
    ret_rma_code: "کد RMA",
    ret_status_approved: "بازگشت تأیید شد",
    ret_status_rejected: "بازگشت رد شد",
    ret_status_requested: "بازگشت درخواست شد",
    ret_status_under_review: "در حال بررسی",
    ret_step_inspected: "محصول بررسی شد",
    ret_step_received: "مرجوعه دریافت شد",
    ret_step_refund_complete: "بازپرداخت کامل شد",
    ret_step_refund_initiated: "بازپرداخت آغاز شد",
    ret_step_refund_issue: "بازپرداخت — مشکل",
    ret_step_rejected: "بازگشت رد شد",
    ret_step_requested: "بازگشت درخواست شد",
    ret_submit: "ارسال درخواست",
    review_body: "تجربه شما",
    review_pending: "نظر شما ارسال شد و در حال بررسی است.",
    review_rating: "امتیاز",
    review_title: "عنوان",
    reviews: "دیدگاه‌ها",
    sale_badge: "حراج",
    save: "ذخیره",
    saved: "ذخیره شد",
    search_placeholder: "جستجوی محصول…",
    section_bestsellers: "پرفروش‌ترین‌ها",
    section_featured: "منتخب",
    section_new: "تازه‌ها",
    section_oils: "روغن‌های طبیعی",
    section_why_title: "چرا Coiffeur Tattoo 01&Co.",
    since_2011: "از سال ۲۰۱۱",
    size: "اندازه",
    stock_in: "موجود",
    stock_low: "موجودی محدود",
    stock_low_1: "تقریباً تمام شده — فقط ۱ عدد موجود",
    stock_low_2: "تقریباً تمام شده — فقط ۲ عدد موجود",
    stock_low_3: "تقریباً تمام شده — فقط ۳ عدد موجود",
    stock_low_4: "تقریباً تمام شده — فقط ۴ عدد موجود",
    stock_out: "تمام شده",
    stock_setup: "در حال حاضر موجود نیست",
    submit_answer: "ارسال پاسخ",
    submit_question: "ارسال پرسش",
    submit_review: "ثبت نظر",
    suitable_bart: "ریش",
    suitable_for: "مناسب برای",
    suitable_gesicht: "صورت",
    suitable_haare: "مو",
    suitable_haut: "پوست",
    suitable_koerper: "بدن",
    time_remaining_label: "زمان باقی‌مانده",
    tracking_carrier: "سرویس حمل‌ونقل",
    tracking_link: "پیگیری نزد ارائه‌دهنده",
    tracking_number: "شماره پیگیری",
    usage: "نحوه استفاده",
    variant: "گونه",
    verified_purchase: "خرید تأیید شده",
    view_all: "مشاهده همه",
    view_details: "مشاهده جزئیات",
    warnings: "توجهات",
    welcome: "خوش آمدید",
    wishlist_add: "افزودن به علاقه‌مندی‌ها",
    wishlist_empty: "لیست علاقه‌مندی‌های شما خالی است.",
    wishlist_login: "برای استفاده از فهرست علاقه‌مندی‌ها وارد شوید.",
    wishlist_remove: "حذف از لیست علاقه‌مندی‌ها",
    wishlist_title: "علاقه‌مندی‌ها",
    write_review: "نوشتن نظر",
      cat_bartpflege: "مراقبت از ریش",
    cat_haarpflege: "مراقبت از مو",
    cat_sets_bundles: "مجموعه‌ها و پک‌ها",
},
  ta: {
    about_address: "Kirchweg 20, 8750 Glarus, சுவிட்சர்லாந்து",
    about_founder: "நிறுவனர்: Sajjad Al-Daghir",
    about_intro: "Glarus இருந்து ஒரு சுவிஸ் பிராண்ட் – 2011 முதல் நடை மற்றும் தரம்.",
    about_philosophy_body: "இயற்கை தயாரிப்புகள் வெறும் தயாரிப்புகள் மட்டுமல்ல — அவை மக்கள், இயற்கை மற்றும் பாரம்பரிய அறிவின் இடையிலான பிணைப்பு.",
    about_philosophy_title: "எங்கள் தத்துவம்",
    about_title: "Coiffeur Tattoo 01&Co.",
    about_values_title: "இயற்கை. உண்மை. கவனமாக தேர்ந்தெடுக்கப்பட்டது.",
    add_to_cart: "கூடையில் சேர்க்க",
    address_label: "முகவரி",
    admin_analytics: "பகுப்பாய்வு",
    admin_avg: "Ø ஆர்டர் மதிப்பு",
    admin_consultations: "ஆலோசனை கோரிக்கைகள்",
    admin_customers: "வாடிக்கையாளர்கள்",
    admin_discounts: "தள்ளுபடிகள்",
    admin_orders: "ஆர்டர்கள்",
    admin_products: "பொருட்கள்",
    admin_questions: "கேள்விகள்",
    admin_revenue: "வருவாய்",
    admin_reviews: "மதிப்புரைகள்",
    admin_title: "நிர்வாக டாஷ்போர்டு",
    admin_total_orders: "மொத்த ஆர்டர்கள்",
    answer_placeholder: "பதிலளிக்கவும்…",
    aria_account: "கணக்கு",
    aria_basra: "Basra உதவியாளர்",
    aria_cart: "கூடை",
    aria_close: "மூடு",
    aria_loading: "ஏற்றுகிறது…",
    aria_logo_home: "Coiffeur Tattoo 01&Co. முகப்புப் பக்கம்",
    aria_menu: "பட்டி",
    aria_remove: "நீக்கு",
    aria_send: "அனுப்பு",
    aria_wishlist: "விருப்பப் பட்டியல்",
    ask_placeholder: "உங்கள் கேள்வி…",
    ask_question: "கேள்வி கேட்கவும்",
    auth_error: "உள்நுழைவில் பிழை.",
    auth_or: "அல்லது",
    benefits: "நன்மைகள்",
    bestseller_badge: "அதிகம் விற்பனையானது",
    book_add: "சேர்க்கவும்",
    book_added_to_cart: "பதிவுக்குச் சேர்க்கப்பட்டது",
    book_appointment_nr: "பதிவு எண்.",
    book_appointment_time: "நேரம்",
    book_autofilled: "தானாக நிரப்பப்பட்டது",
    book_back: "பின்செல்",
    book_booking_confirmed: "நேரம் உறுதிப்படுத்தப்பட்டது",
    book_booking_processing: "முன்பதிவு செய்யப்படுகிறது…",
    book_cancel_policy: "ரத்து செய்தல் விதிமுறைகள்",
    book_cart_empty: "இன்னும் எந்த சேவையும் தேர்ந்தெடுக்கப்படவில்லை.",
    book_cat_kids: "குழந்தைகள் & இளைஞர்கள்",
    book_cat_men: "ஆண்கள்",
    book_cat_tattoo: "Tattoo",
    book_cat_unisex: "யூனிசெக்ஸ்",
    book_cat_women: "பெண்கள்",
    book_colors: "வண்ணங்கள்",
    book_customer_eyebrow: "உங்கள் விவரங்கள்",
    book_customer_hint: "தயவுசெய்து ஒரு முறை நிரப்பவும் — அடுத்த முறை வரும்போது உங்கள் தகவல் தானாக பயன்படுத்தப்படும்.",
    book_datetime: "நேரம்",
    book_deposit_note_body: "எங்கள் ரத்து மற்றும் தாமத கொள்கையின்படி முன்பணம் தக்கவைக்கப்படும்: நேரத்திற்கு 24 மணி நேரத்திற்கு குறைவாக ரத்துசெய்தல், அன்றைய பதிவுகள், வராமல் போதல் மற்றும் 5 நிமிடங்களுக்கு மேல் தாமதமாகி முன்கூட்டியே தொலைபேசியில் அறிவிக்காமல் இருத்தல். சரியான நேரத்தில் ரத்துசெய்தால் (≥ 24 h) முன்பணம் முழுமையாக திரும்பச் செலுத்தப்படும்.",
    book_deposit_note_title: "முன்பணம் தொடர்பான முக்கிய குறிப்பு (50%)",
    book_deposit_required: "சேவைகளுக்கு ஆன்லைன் முன்பணம் தேவை. Stripe-க்குச் செல்லவும் …",
    book_description: "விளக்கம்",
    book_edit: "மாற்றவும்",
    book_email_confirmation: "உறுதிப்படுத்தல் மின்னஞ்சலை அனுப்பியுள்ளோம்.",
    book_error_booking: "பதிவில் பிழை",
    book_error_generic: "பிழை",
    book_fill_required: "அனைத்து கட்டாய புலங்களையும் நிரப்பவும்.",
    book_full_name: "முழு பெயர்",
    book_lines: "கோடுகள்",
    book_loading_details: "விவரங்கள் ஏற்றப்படுகின்றன …",
    book_login_hint: "குறிப்பு: உள்நுழையவும், அடுத்த முறை உங்கள் தகவல்களை நாங்கள் தானாக பயன்படுத்துவோம்.",
    book_multi_hint: "ஒவ்வொரு வகையிலிருந்தும் எத்தனை சேவைகள் வேண்டுமானாலும் தேர்ந்தெடுக்கவும். தேதி மற்றும் நேரத்தை அடுத்த கட்டத்தில் தேர்வுசெய்யவும்.",
    book_next: "அடுத்து",
    book_no_slots: "இந்த நாளுக்கு நேரம் கிடைக்கவில்லை.",
    book_payment_breakdown: "கட்டண விவரங்கள்",
    book_phone_num: "தொலைபேசி",
    book_pick_date: "தேதி தேர்வு",
    book_pick_length: "நீளத்தை தேர்வு செய்க",
    book_pick_time: "நேரத்தைத் தேர்ந்தெடுக்கவும்",
    book_placeholder_colors: "வண்ணங்கள் (எ.கா. கருப்பு, வண்ணமிக்க …)",
    book_placeholder_desc: "வடிவமைப்பின் விளக்கம் …",
    book_placeholder_lines: "கோடுகள் (எ.கா. மெல்லிய, தடிமனான…)",
    book_policy_5min: "முன்கூட்டியே தொலைபேசி அறிவிப்பு இல்லாமல் 5 நிமிடங்களுக்கு மேல் தாமதம் ஏற்பட்டால், அபராதம் (50%) விதிக்கப்படும். 5 நிமிடங்களுக்குள் அழைத்தால், கூடுதல் கட்டணமின்றி நேரத்தை நீட்டிக்கலாம்.",
    book_policy_free_6h: "முடிதிருத்த நேரத்திற்கு 6 மணிநேரம் முன்பு வரை இலவச ரத்து (டாட்டூ: 24 மணிநேரம்).",
    book_policy_late_fee: "பிற்பட்ட ரத்து செய்யும் பட்சத்தில் விலையின் 50% கட்டணமாக வசூலிக்கப்படும்.",
    book_policy_within_6h: "அடுத்த 6 மணிநேரத்திற்குள்ளான நேரங்களை இனி ரத்து செய்ய முடியாது.",
    book_preferred_time: "விரும்பிய நேரம் (விருப்பம்)",
    book_price: "விலை",
    book_price_from: "முதல்",
    book_price_on_request: "விலை கோரிக்கையின் பேரில்",
    book_remove: "அகற்று",
    book_request_sent: "கோரிக்கை அனுப்பப்பட்டது",
    book_reservation: "முன்பதிவு",
    book_review_add_product: "தயாரிப்பைச் சேர்க்கவும்",
    book_review_add_service: "மேலும் சேவை",
    book_review_continue_pay: "கட்டணத்திற்குச் செல்லவும்",
    book_review_continue_schedule: "நேரத் தேர்விற்குச் செல்லவும்",
    book_review_deposit_now: "முன்பணம் இப்போது",
    book_review_due_now: "மொத்தத் தொகை இப்போது",
    book_review_eyebrow: "பதிவு விவரம்",
    book_review_products_total: "தயாரிப்புகள் மொத்தம்",
    book_review_question: "மேலும் சேவை அல்லது தயாரிப்பைச் சேர்க்க விரும்புகிறீர்களா, அல்லது நேரடியாக நேரத் தேர்விற்குச் செல்லலாமா?",
    book_review_rest_at_salon: "மீதித் தொகை Coiffeur Tattoo 01&Co. இல்",
    book_review_services_total: "சேவைகள் மொத்தம்",
    book_review_split_note: "சேவைகளுக்கு நீங்கள் இப்போது 50% முன்பணமாகச் செலுத்தவும், மீதியை எங்கள் ஸ்டூடியோவில் வசதியாகச் செலுத்தவும். தயாரிப்புகள் முழுமையாக ஆன்லைனில் செலுத்தப்படும்.",
    book_review_summary: "சுருக்கம்",
    book_review_title: "கிட்டத்தட்ட முடிந்தது — இன்னும் ஏதேனும் சேர்க்கலாமா?",
    book_review_your_products: "உங்கள் தயாரிப்புகள்",
    book_review_your_services: "உங்கள் சேவைகள்",
    book_schedule_hint: "மொத்த நேரம்:",
    book_selected_service: "தேர்ந்தெடுத்த சேவை",
    book_send_request: "கோரிக்கையை அனுப்பு",
    book_sending: "அனுப்பப்படுகிறது…",
    book_size: "அளவு",
    book_size_large: "பெரியது (20 cm க்கு மேல்)",
    book_size_medium: "நடுத்தரம் (10–20 cm)",
    book_size_small: "சிறியது (10 செ.மீ. வரை)",
    book_state_blocked_hover: "⚫ கிடைக்கவில்லை — மூடப்பட்டது அல்லது தடுக்கப்பட்டது",
    book_state_booked_hover: "🔴 முன்பதிவு செய்யப்பட்டுள்ளது — ஏற்கனவே பதிவு செய்யப்பட்டது",
    book_state_free_hover: "🟢 இலவசம் — இப்போது பதிவுசெய்யலாம்",
    book_state_mine_hover: "🔵 உங்கள் நேரம்",
    book_state_needs_conf_hover: "🟠 உறுதிசெய்தலுக்காக காத்திருக்கிறது",
    book_state_pending_hover: "🟡 நடைபெறுகிறது — பதிவு நடைபெறுகிறது",
    book_state_too_soon_hover: "⚫ மிக விரைவு — குறைந்தது 30 நிமிடங்கள் முன்பாக",
    book_status_blocked: "தடுக்கப்பட்டது",
    book_status_booked: "முன்பதிவு செய்யப்பட்டது",
    book_status_free: "இலவசம்",
    book_status_mine: "உங்கள் நேரம்",
    book_status_needs_conf: "உறுதிப்படுத்தல் எதிர்பார்க்கப்படுகிறது",
    book_status_pending: "செயலாக்கத்தில்",
    book_step_done: "முடிந்தது",
    book_step_info: "விவரங்கள்",
    book_step_service: "சேவை",
    book_step_time: "நேரம்",
    book_submit_booking: "பதிவை உறுதிப்படுத்து",
    book_tattoo_no_price: "நிலையான விலை இல்லை. உங்கள் விருப்ப வடிவமைப்பை விவரிக்கவும் – விலை மற்றும் நேரத்திற்காக நாங்கள் உங்களைத் தொடர்பு கொள்வோம்.",
    book_tattoo_title: "டாட்டூ கோரிக்கை",
    book_termin_agreement: "முன்பதிவு மூலம்",
    book_visit_hint: "உங்களை வரவேற்க எதிர்பார்க்கிறோம். மீதித் தொகை எங்கள் ஸ்டூடியோவில் செலுத்தவும்.",
    book_will_contact: "விலை மற்றும் நேரத்திற்காக நாங்கள் விரைவில் உங்களைத் தொடர்பு கொள்வோம்.",
    book_your_cart: "உங்கள் தேர்வு",
    book_your_info: "உங்கள் விவரங்கள்",
    book_your_visit: "உங்கள் வருகை",
    booking_eyebrow: "முன்பதிவு",
    booking_title: "உங்கள் நேரத்தை பதிவு செய்யுங்கள்",
    brand_tagline: "2011 முதல் முடி மற்றும் அழகு",
    buy_now: "இப்போது வாங்கவும்",
    cart_added: "சேர்க்கப்பட்டது",
    cart_apply: "விண்ணப்பி",
    cart_checkout: "கட்டணம் செலுத்த",
    cart_continue: "தொடர்ந்து வாங்கவும்",
    cart_discount: "தள்ளுபடி",
    cart_discount_applied: "தள்ளுபடி பயன்படுத்தப்பட்டது",
    cart_discount_code: "தள்ளுபடி குறியீடு",
    cart_discount_invalid: "தள்ளுபடி குறியீடு தவறானது",
    cart_empty: "உங்கள் கூடை காலியாக உள்ளது.",
    cart_remove: "அகற்று",
    cart_shipping: "அனுப்புதல்",
    cart_subtotal: "துணை மொத்தம்",
    cart_tax_note: "வரி பணம் செலுத்தும்போது கணக்கிடப்படும்",
    cart_title: "கூடை",
    cart_total: "மொத்தம்",
    change_password: "கடவுச்சொல்லை மாற்று",
    channel_email: "மின்னஞ்சல்",
    channel_phone: "தொலைபேசி",
    channel_whatsapp: "WhatsApp",
    checkout_address: "தெரு மற்றும் எண்",
    checkout_apartment: "அபார்ட்மென்ட் / தளம் (விரும்பினால்)",
    checkout_billing: "பில் முகவரி",
    checkout_billing_same: "பில்லிங் மற்றும் கப்பல் ஒரே",
    checkout_city: "நகரம்",
    checkout_contact: "தொடர்பு",
    checkout_country: "நாடு",
    checkout_email: "மின்னஞ்சல்",
    checkout_first_name: "முதல் பெயர்",
    checkout_hold_expired_action: "புதிய நேரத்தைத் தேர்ந்தெடுக்கவும்",
    checkout_hold_expired_body: "நேரம் வெளியிடப்பட்டு, இதற்கிடையில் வேறு யாராலும் தேர்ந்தெடுக்கப்பட்டிருக்கலாம். தயவுசெய்து புதிய நேரத்தைத் தேர்ந்தெடுக்கவும்.",
    checkout_hold_expired_title: "உங்கள் முன்பதிவு காலாவதியாகிவிட்டது",
    checkout_hold_expiring: "முன்பதிவு விரைவில் காலாவதியாகிறது",
    checkout_hold_hint: "தேர்ந்தெடுத்த நேரம் உங்களுக்காக ஒதுக்கப்பட்டுள்ளது. காலாவதியாகும் முன் கட்டணத்தை முடிக்கவும்.",
    checkout_hold_title: "உங்கள் முன்பதிவு",
    checkout_last_name: "கடைசி பெயர்",
    checkout_name: "முழுப் பெயர்",
    checkout_notes: "ஆர்டர் குறிப்புகள் (விருப்பமானது)",
    checkout_pay_in_store: "எங்கள் ஸ்டூடியோவில் செலுத்தவும்",
    checkout_pay_in_store_deposit_hint: "சந்திப்புகளுக்கு ஆன்லைன் முன்பணம் அவசியம். மீதித் தொகை ஸ்டூடியோவில் செலுத்தப்படும்.",
    checkout_pay_in_store_hint: "இப்போது முன்பதிவு செய்யவும், எடுத்துச் செல்லும்போது ஸ்டூடியோவில் (Kirchweg 20, Glarus) ரொக்கமாகவோ அல்லது கார்டு மூலமாகவோ செலுத்தவும்.",
    checkout_pay_online: "ஆன்லைனில் செலுத்தவும்",
    checkout_pay_online_hint: "கார்டு, TWINT, Apple Pay, Klarna – Stripe மூலம் பாதுகாப்பாக.",
    checkout_payment: "கட்டணம்",
    checkout_phone: "தொலைபேசி (விருப்பமானது)",
    checkout_place_order: "கட்டணத்திற்கு தொடர",
    checkout_postal: "அஞ்சல் குறியீடு",
    checkout_return_pledge_label: "திரும்பச் செலுத்த விரும்பினால், தயாரிப்பைத் திறக்கவோ பயன்படுத்தவோ மாட்டேன் என்று உறுதியளிக்கிறேன்.",
    checkout_return_pledge_required: "தொடர, திரும்பப் பெறுதல் உறுதிமொழியை ஏற்கவும்.",
    checkout_return_policy_body: "எங்கள் கடை விதிமுறைகளின்படி, திறக்கப்பட்ட அல்லது பயன்படுத்தப்பட்ட தயாரிப்பை திரும்பப் பெற முடியாது.",
    checkout_return_policy_title: "திரும்பப் பெறும் உரிமை — தயவுசெய்து படிக்கவும்",
    checkout_review: "மதிப்பாய்வு",
    checkout_secure_note: "பாதுகாப்பான Stripe கட்டணம்.",
    checkout_shipping: "டெலிவரி முகவரி",
    checkout_street: "தெரு & வீட்டு எண்",
    checkout_title: "கட்டணம்",
    consultation_intro: "உங்களுக்கு ஆலோசனை வழங்குவதில் மகிழ்ச்சி.",
    consultation_msg: "உங்கள் கேள்வி / தேவை",
    consultation_preferred: "விருப்பமான தொடர்பு",
    consultation_preferred_time: "விருப்ப நேரம்",
    consultation_subject: "தலைப்பு",
    consultation_submit: "கோரிக்கை அனுப்பு",
    consultation_thanks: "நன்றி – நாங்கள் விரைவில் உங்களைத் தொடர்பு கொள்வோம்.",
    consultation_title: "ஆலோசனை கோரிக்கை",
    contact_address: "முகவரி",
    contact_email: "மின்னஞ்சல்",
    contact_form_title: "எங்களுக்கு எழுதுங்கள்",
    contact_hours: "திறந்திருக்கும் நேரம்",
    contact_message: "உங்கள் செய்தி",
    contact_phone: "தொலைபேசி",
    contact_send: "செய்தி அனுப்பவும்",
    contact_thanks: "நன்றி – விரைவில் தொடர்பு கொள்வோம்.",
    contact_title: "தொடர்பு",
    cookie_accept: "ஏற்று",
    cookie_decline: "அவசியமானவை மட்டும்",
    cookie_msg: "இந்த தளம் தொழில்நுட்ப குக்கீகள் மற்றும் உங்கள் ஒப்புதலுடன் அநாமதேய புள்ளிவிவரங்களை மட்டும் பயன்படுத்துகிறது.",
    copyright: "அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.",
    current_password: "தற்போதைய கடவுச்சொல்",
    delete_account: "கணக்கை நீக்கு",
    delete_confirm: "கணக்கை நிரந்தரமாக நீக்க விரும்புகிறீர்களா?",
    email: "மின்னஞ்சல்",
    footer_agb: "விதிமுறைகள்",
    footer_brand: "பிராண்ட்",
    footer_cookies: "குக்கீகள்",
    footer_datenschutz: "தனியுரிமை",
    footer_faq: "அடிக்கடி கேட்கப்படும் கேள்விகள்",
    footer_help: "உதவி",
    footer_impressum: "பதிப்புரிமை",
    footer_legal: "சட்ட விவரங்கள்",
    footer_returns: "திரும்பப் பெறுதல்",
    footer_shipping: "கப்பல்",
    footer_shop: "கடை",
    forgot_password: "கடவுச்சொல் மறந்துவிட்டதா?",
    founder_label: "நிறுவனர்",
    free_shipping_over: "CHF 100 மேல் இலவச கப்பல்",
    hero_cta: "தொகுப்பை ஆராயுங்கள்",
    hero_secondary: "எங்கள் கதை",
    hero_subtitle: "பிரீமியம் முடி, தாடி மற்றும் தோல் பராமரிப்பு, இயற்கை எண்ணெய்கள், அலெப்போ சோப்பு, மிஸ்வாக், மருதாணி மற்றும் மேலும் — Glarus இல் Coiffeur Tattoo 01&Co. குழுவால் தேர்ந்தெடுக்கப்பட்டவை.",
    hero_title: "சுவிஸ் கைவினை. இயற்கை பராமரிப்பு.",
    home_studio_alt: "Glarus இல் உள்ள Coiffeur Tattoo 01&Co. ஸ்டுடியோ",
    ingredients: "கூறுகள்",
    login: "உள்நுழை",
    login_with_google: "Google மூலம் உள்நுழையவும்",
    logout: "வெளியேறு",
    medical_disclaimer: "எங்கள் தயாரிப்புகள் தொழில்முறை மருத்துவ ஆலோசனையை மாற்றாது.",
    missing_token_error: "டோக்கன் இல்லை.",
    my_orders: "எனது ஆர்டர்கள்",
    my_profile: "எனது சுயவிவரம்",
    nav_about: "எங்களைப் பற்றி",
    nav_account: "கணக்கு",
    nav_admin: "நிர்வாகம்",
    nav_cart: "கூடை",
    nav_consultation: "ஆலோசனை",
    nav_contact: "தொடர்பு",
    nav_home: "முகப்பு",
    nav_shop: "கடை",
    nav_tracking: "ஆர்டர் கண்காணிப்பு",
    nav_wishlist: "விருப்பப்பட்டியல்",
    new_badge: "புதிய",
    new_password: "புதிய கடவுச்சொல்",
    newsletter_desc: "புதிய தயாரிப்புகள் மற்றும் சிறப்பு சலுகைகள்.",
    newsletter_label: "செய்திமடல்",
    newsletter_placeholder: "உங்கள் மின்னஞ்சல்",
    newsletter_submit: "குழுசேர்",
    newsletter_title: "உத்வேகத்தில் இருங்கள்.",
    no_questions: "இதுவரை கேள்விகள் இல்லை.",
    no_reviews: "இதுவரை மதிப்புரைகள் இல்லை.",
    order_number: "ஆர்டர் எண்",
    order_status_cancelled: "ரத்து செய்யப்பட்டது",
    order_status_delivered: "வழங்கப்பட்டது",
    order_status_paid: "செலுத்தப்பட்டது",
    order_status_pending: "நிலுவையில்",
    order_status_processing: "செயலாக்கத்தில்",
    order_status_refunded: "திரும்பச் செலுத்தப்பட்டது",
    order_status_shipped: "அனுப்பப்பட்டது",
    order_tracking_email: "மின்னஞ்சல் முகவரி",
    order_tracking_intro: "உங்கள் ஆர்டர் எண் மற்றும் மின்னஞ்சலை உள்ளிடவும்.",
    order_tracking_not_found: "ஆர்டர் கிடைக்கவில்லை.",
    order_tracking_number: "ஆர்டர் எண்",
    order_tracking_submit: "கண்காணி",
    order_tracking_title: "ஆர்டர் கண்காணிப்பு",
    otp_expires_hint: "குறியீடு 10 நிமிடங்களுக்கு செல்லுபடியாகும். தேவையெனில் உங்கள் ஸ்பேம் கோப்புறையைச் சரிபார்க்கவும்.",
    otp_heading: "உங்கள் குறியீட்டை உள்ளிடவும்",
    otp_invalid: "தவறான குறியீடு. மீண்டும் முயற்சிக்கவும்.",
    otp_resend: "குறியீட்டை மீண்டும் அனுப்பவும்",
    otp_resent: "புதிய குறியீடு அனுப்பப்பட்டது.",
    otp_sent: "உங்களுக்கு மின்னஞ்சல் மூலம் குறியீடு அனுப்பியுள்ளோம்.",
    otp_sent_to: "6-இலக்க குறியீடு இங்கு அனுப்பப்பட்டுள்ளது:",
    otp_title: "மின்னஞ்சல் உறுதிப்படுத்தல்",
    otp_verified: "மின்னஞ்சல் உறுதிப்படுத்தப்பட்டது — வரவேற்கிறோம்!",
    otp_verify: "உறுதிப்படுத்து",
    out_of_stock: "கையிருப்பில் இல்லை",
    password: "கடவுச்சொல்",
    payment_cancel: "கட்டணம் ரத்து செய்யப்பட்டது",
    payment_cancel_msg: "கட்டணம் ரத்து செய்யப்பட்டது. மீண்டும் முயற்சிக்கலாம்.",
    payment_success: "கட்டணம் வெற்றி",
    payment_success_msg: "உங்கள் ஆர்டருக்கு நன்றி!",
    payments_title: "கட்டண தகவல்",
    phone_label: "தொலைபேசி",
    price: "விலை",
    qa_disclaimer: "கருத்துகள் தனிப்பட்ட அனுபவங்கள், மருத்துவ ஆலோசனை அல்ல.",
    qa_login_required: "கேட்க அல்லது பதிலளிக்க உள்நுழையவும்.",
    quantity: "அளவு",
    question_pending: "உங்கள் கேள்வி பரிசீலனையில் உள்ளது.",
    questions_title: "கேள்விகள் மற்றும் பதில்கள்",
    reason_natural: "இயற்கை மூலப்பொருட்கள்",
    reason_natural_desc: "ஒவ்வொரு எண்ணெயையும் நாங்கள் கவனமாக தேர்வு செய்கிறோம்.",
    reason_secure: "பாதுகாப்பான கட்டணம்",
    reason_secure_desc: "Stripe மூலம் பாதுகாப்பாக குறியாக்கம் செய்யப்பட்டது.",
    reason_shipping: "உலகளாவிய கப்பல்",
    reason_shipping_desc: "CHF 100க்கு மேல் இலவச டெலிவரி.",
    reason_swiss: "சுவிஸ் பிராண்ட்",
    reason_swiss_desc: "Glarusஇல் நிறுவப்பட்டது – உணரக்கூடிய கைவினைத்திறன்.",
    register: "பதிவு செய்க",
    related_products: "ஒத்த தயாரிப்புகள்",
    report_content: "புகார்",
    reset_link_sent: "கணக்கு இருந்தால், மீட்டமை இணைப்பு உருவாக்கப்பட்டது.",
    reset_password: "கடவுச்சொல்லை மீட்டமைக்க",
    reset_success: "கடவுச்சொல் மீட்டமைக்கப்பட்டது.",
    ret_created: "உங்கள் திரும்பப் பெறுதல் கோரிக்கை உருவாக்கப்பட்டது.",
    ret_error: "கோரிக்கையை உருவாக்க முடியவில்லை.",
    ret_existing_hint: "அடுத்த நடவடிக்கைகளுடன் உங்களைத் தொடர்பு கொள்வோம்.",
    ret_existing_title: "திரும்பப் பெறுதல் நிலை",
    ret_info_inspected: "சரிபார்க்கப்பட்ட தேதி",
    ret_info_order: "ஆர்டர் எண்",
    ret_info_products: "திரும்ப அனுப்பிய தயாரிப்புகள்",
    ret_info_products_all: "முழு ஆர்டர்",
    ret_info_received: "பெறப்பட்ட தேதி",
    ret_info_refunded: "திரும்பச் செலுத்தப்பட்ட தேதி",
    ret_info_requested: "கோரப்பட்ட தேதி",
    ret_inspection_failed_hint: "சரிபார்ப்புக்குப் பிறகு, உங்கள் திரும்ப அனுப்பலை ஏற்க முடியவில்லை. கேள்விகள் இருந்தால் எங்களைத் தொடர்பு கொள்ளவும்.",
    ret_modal_intro: "உங்கள் தயாரிப்பு திரும்பப் பெறுதலுக்கு தகுதி பெற, அது திறக்கப்படாமலும் பயன்படுத்தப்படாமலும் இருக்க வேண்டும்.",
    ret_modal_title: "தயாரிப்பைத் திரும்பப் பெறவும்",
    ret_only_delivered: "ஆர்டர் வழங்கப்பட்டவுடன் திரும்பப் பெறுதல் கிடைக்கும்.",
    ret_pledge_label: "தயாரிப்பு திறக்கப்படவில்லை, பயன்படுத்தப்படவில்லை என்றும், அதைப் பெற்ற நிலையில் திரும்ப அனுப்புகிறேன் என்றும் உறுதிப்படுத்துகிறேன்.",
    ret_pledge_required: "திரும்பப் பெறுதல் உறுதிமொழியை ஏற்கவும்.",
    ret_reason_changed_mind: "என் முடிவை மாற்றிக்கொண்டேன்",
    ret_reason_damaged: "தயாரிப்பு சேதமடைந்துள்ளது",
    ret_reason_group_customer: "தனிப்பட்ட காரணம்",
    ret_reason_group_product: "தயாரிப்பு அல்லது ஆர்டருடன் சிக்கல்",
    ret_reason_no_longer_needed: "எனக்கு இனி தேவையில்லை",
    ret_reason_order_error: "ஆர்டரில் பிழை",
    ret_reason_other: "வேறு காரணம்",
    ret_reason_other_issue: "தயாரிப்புடன் வேறு சிக்கல்",
    ret_reason_placeholder: "காரணத்தை விவரிக்கவும்…",
    ret_reason_shipping_damage: "சேதமடைந்த நிலையில் வந்தது",
    ret_reason_wrong_choice: "தவறுதலாக தவறான தயாரிப்பைத் தேர்ந்தெடுத்தேன்",
    ret_reason_wrong_item: "வழங்கப்பட்ட தயாரிப்பு ஆர்டருக்கு பொருந்தவில்லை",
    ret_refund_amount: "திரும்பச் செலுத்தும் தொகை",
    ret_refund_bank_note: "தொகை உங்கள் கணக்கில் எவ்வளவு நேரத்தில் தெரியும் என்பது உங்கள் வங்கி அல்லது கார்டு வழங்குநரைப் பொறுத்தது, பல வேலை நாட்கள் ஆகலாம்.",
    ret_refund_issue_body: "திரும்பச் செலுத்துதல் இன்னும் முடிக்கப்படவில்லை, தொடர்ந்து செயல்படுத்தப்படுகிறது. நீங்கள் எதுவும் செய்ய வேண்டியதில்லை — கேள்விகள் இருந்தால் info@01co.ch என்ற முகவரியில் எங்களை அணுகவும்.",
    ret_refund_status_failed: "திரும்பச் செலுத்துதல் இன்னும் செயலில் உள்ளது",
    ret_refund_status_processing: "திரும்பச் செலுத்துதல் செயல்படுத்தப்படுகிறது",
    ret_refund_status_succeeded: "திரும்பச் செலுத்துதல் முடிந்தது",
    ret_request_btn: "திரும்பப் பெறுதல் கோரவும்",
    ret_resolution_free: "இலவச திரும்பப் பெறுதல் · அனுப்புதல் Coiffeur Tattoo 01&Co. செலவில்",
    ret_resolution_paid: "வாடிக்கையாளர் செலுத்தும் திரும்பப் பெறுதல் · அனுப்புதல் உங்கள் செலவில்",
    ret_rma_code: "RMA குறியீடு",
    ret_status_approved: "திரும்பப் பெறுதல் அனுமதிக்கப்பட்டது",
    ret_status_rejected: "திரும்பப் பெறுதல் நிராகரிக்கப்பட்டது",
    ret_status_requested: "திரும்பப் பெறுதல் கோரப்பட்டது",
    ret_status_under_review: "பரிசீலனையில்",
    ret_step_inspected: "தயாரிப்பு சரிபார்க்கப்பட்டது",
    ret_step_received: "திரும்ப அனுப்பல் பெறப்பட்டது",
    ret_step_refund_complete: "திரும்பச் செலுத்துதல் முடிந்தது",
    ret_step_refund_initiated: "திரும்பச் செலுத்துதல் தொடங்கப்பட்டது",
    ret_step_refund_issue: "திரும்பச் செலுத்துதல் — சிக்கல்",
    ret_step_rejected: "திரும்பப் பெறுதல் நிராகரிக்கப்பட்டது",
    ret_step_requested: "திரும்பப் பெறுதல் கோரப்பட்டது",
    ret_submit: "கோரிக்கையை அனுப்பவும்",
    review_body: "உங்கள் அனுபவம்",
    review_pending: "உங்கள் மதிப்பாய்வு சமர்ப்பிக்கப்பட்டு சரிபார்க்கப்படுகிறது.",
    review_rating: "மதிப்பீடு",
    review_title: "தலைப்பு",
    reviews: "மதிப்புரைகள்",
    sale_badge: "விற்பனை",
    save: "சேமி",
    saved: "சேமிக்கப்பட்டது",
    search_placeholder: "பொருட்களை தேடு…",
    section_bestsellers: "அதிகம் விற்பனையானவை",
    section_featured: "சிறப்பானவை",
    section_new: "புதியவை",
    section_oils: "இயற்கை எண்ணெய்கள்",
    section_why_title: "ஏன் Coiffeur Tattoo 01&Co.",
    since_2011: "2011 முதல்",
    size: "அளவு",
    stock_in: "இருப்பில்",
    stock_low: "குறைந்த அளவே கிடைக்கிறது",
    stock_low_1: "கிட்டத்தட்ட விற்றுத் தீர்ந்துவிட்டது — 1 மட்டுமே கிடைக்கிறது",
    stock_low_2: "கிட்டத்தட்ட விற்றுத் தீர்ந்துவிட்டது — 2 மட்டுமே கிடைக்கிறது",
    stock_low_3: "கிட்டத்தட்ட விற்றுத் தீர்ந்துவிட்டது — 3 மட்டுமே கிடைக்கிறது",
    stock_low_4: "கிட்டத்தட்ட விற்றுத் தீர்ந்துவிட்டது — 4 மட்டுமே கிடைக்கிறது",
    stock_out: "விற்றுத் தீர்ந்துவிட்டது",
    stock_setup: "தற்போது கிடைக்கவில்லை",
    submit_answer: "பதிலை அனுப்பவும்",
    submit_question: "கேள்வியை அனுப்பவும்",
    submit_review: "மதிப்பாய்வை சமர்ப்பிக்கவும்",
    suitable_bart: "தாடி",
    suitable_for: "பொருத்தமானது",
    suitable_gesicht: "முகம்",
    suitable_haare: "முடி",
    suitable_haut: "தோல்",
    suitable_koerper: "உடல்",
    time_remaining_label: "மீதமுள்ள நேரம்",
    tracking_carrier: "விநியோக சேவை",
    tracking_link: "சேவையகத்தில் கண்காணிக்கவும்",
    tracking_number: "கண்காணிப்பு எண்",
    usage: "பயன்பாடு",
    variant: "வகை",
    verified_purchase: "சரிபார்க்கப்பட்ட வாங்குதல்",
    view_all: "எல்லாம் பார்",
    view_details: "விவரங்களைக் காணவும்",
    warnings: "குறிப்புகள்",
    welcome: "வரவேற்கிறோம்",
    wishlist_add: "விருப்பப்பட்டியலில் சேர்",
    wishlist_empty: "உங்கள் விருப்பப் பட்டியல் காலியாக உள்ளது.",
    wishlist_login: "விருப்பப்பட்டியலை பயன்படுத்த உள்நுழையவும்.",
    wishlist_remove: "விருப்பப் பட்டியலிலிருந்து நீக்கவும்",
    wishlist_title: "விருப்பப்பட்டியல்",
    write_review: "மதிப்பாய்வு எழுதவும்",
      cat_bartpflege: "தாடி பராமரிப்பு",
    cat_haarpflege: "முடி பராமரிப்பு",
    cat_sets_bundles: "செட்கள் மற்றும் பேக்குகள்",
},
};

// EXTRA_I18N — category names, story section, page title.
// Added centrally so all 16 languages get translated shop-category, homepage-story and document-title strings.
const EXTRA_I18N = {
  de: { cat_natuerliche_oele:"Natürliche Öle", cat_aleppo_seife:"Aleppo-Seife", cat_henna:"Henna", cat_miswak:"Miswak", cat_weihrauch:"Weihrauch", story_since_2011:"Seit 2011", story_title:"Ein Schweizer Handwerk, in Glarus verwurzelt.", story_body:"Coiffeur Tattoo 01&Co. steht seit über einem Jahrzehnt für Stil, Qualität und aufmerksames Handwerk. Aus dem Salon in Glarus bringen wir Ihnen sorgfältig kuratierte Pflegeprodukte für Haar, Bart und Haut.", page_title:"Coiffeur Tattoo 01&Co. — Schweizer Naturpflege & Beauty", contact_short:"Kirchweg 20 · 8750 Glarus · Schweiz", legal_notice_en:"Rechtlich verbindliche Fassung: Deutsch. Englische Übersetzung nur zur Information.", book_added_to_cart:"Zur Buchung hinzugefügt", book_review_eyebrow:"Buchungsübersicht", book_review_title:"Fast fertig — noch etwas hinzufügen?", book_review_question:"Möchten Sie eine weitere Dienstleistung oder ein Produkt hinzufügen, oder direkt zur Terminwahl?", book_review_your_services:"Ihre Dienstleistungen", book_review_your_products:"Ihre Produkte", book_review_add_service:"Weitere Dienstleistung", book_review_add_product:"Produkt hinzufügen", book_review_continue_pay:"Weiter zur Zahlung", book_review_continue_schedule:"Weiter zur Terminwahl", book_review_summary:"Übersicht", book_review_services_total:"Dienstleistungen gesamt", book_review_deposit_now:"Anzahlung jetzt", book_review_rest_at_salon:"Restbetrag im Salon", book_review_products_total:"Produkte gesamt", book_review_due_now:"Gesamtbetrag jetzt", book_review_split_note:"Für Dienstleistungen zahlen Sie jetzt 50 % als Anzahlung, den Rest bequem im Salon. Produkte werden vollständig online bezahlt.", checkout_first_name:"Vorname", checkout_last_name:"Nachname", checkout_street:"Strasse & Hausnummer", checkout_apartment:"Wohnung / Etage (optional)", book_multi_hint:"Wählen Sie beliebig viele Dienstleistungen aus jeder Kategorie. Datum und Uhrzeit legen Sie im nächsten Schritt fest.", book_your_cart:"Ihre Auswahl", book_cart_empty:"Noch keine Dienstleistungen ausgewählt.", book_add:"Hinzufügen", book_remove:"Entfernen", book_schedule_hint:"Gesamtdauer:", book_customer_eyebrow:"Ihre Daten", book_customer_hint:"Bitte einmalig ausfüllen — beim nächsten Besuch werden Ihre Daten automatisch übernommen.", book_autofilled:"Automatisch ausgefüllt", book_fill_required:"Bitte alle Pflichtfelder ausfüllen.", book_login_hint:"Tipp: Melden Sie sich an, damit wir Ihre Daten beim nächsten Mal automatisch übernehmen.", book_edit:"Ändern", book_reservation:"Reservierung", book_payment_breakdown:"Zahlungsübersicht", book_your_visit:"Ihr Besuch", book_visit_hint:"Wir freuen uns auf Sie. Der Restbetrag ist im Salon zu bezahlen.", book_loading_details:"Details werden geladen …", book_deposit_required:"Für Dienstleistungen ist eine Online-Anzahlung erforderlich. Weiter zu Stripe …", checkout_pay_online:"Online bezahlen", checkout_pay_online_hint:"Karte, TWINT, Apple Pay, Klarna – sicher über Stripe.", checkout_pay_in_store:"Vor Ort im Salon zahlen", checkout_pay_in_store_hint:"Reservieren jetzt, bezahlen bar oder mit Karte beim Abholen im Salon (Kirchweg 20, Glarus).", checkout_pay_in_store_deposit_hint:"Für Termine ist eine Anzahlung online erforderlich. Der Restbetrag wird im Salon bezahlt.", book_deposit_note_title:"Wichtiger Hinweis zur Anzahlung (50%)", book_deposit_note_body:"Die Anzahlung wird gemäss unserer Stornierungs- und Verspätungspolitik einbehalten: bei Stornierung weniger als 24 Stunden vor dem Termin, bei Same-Day-Buchungen, bei Nichterscheinen sowie bei Verspätung von mehr als 5 Minuten ohne rechtzeitige telefonische Ankündigung. Bei fristgerechter Stornierung (≥ 24 h) wird die Anzahlung vollständig erstattet.", otp_title:"E-Mail-Bestätigung", otp_heading:"Geben Sie Ihren Code ein", otp_sent:"Wir haben Ihnen einen Code per E-Mail gesendet.", otp_sent_to:"Wir haben einen 6-stelligen Code gesendet an:", otp_verify:"Bestätigen", otp_resend:"Code erneut senden", otp_resent:"Neuer Code wurde gesendet.", otp_verified:"E-Mail bestätigt — willkommen!", otp_invalid:"Falscher Code. Bitte versuchen Sie es erneut.", otp_expires_hint:"Der Code ist 10 Minuten gültig. Prüfen Sie ggf. Ihren Spam-Ordner.", welcome:"Willkommen", auth_error:"Fehler bei der Anmeldung.", login_with_google:"Mit Google anmelden", auth_or:"oder", checkout_hold_title:"Ihre Reservierung", checkout_hold_hint:"Ihr gewählter Termin ist für Sie reserviert. Bitte schliessen Sie die Zahlung vor Ablauf ab.", checkout_hold_expiring:"Reservierung läuft gleich ab", checkout_hold_expired_title:"Ihre Reservierung ist abgelaufen", checkout_hold_expired_body:"Der Termin wurde freigegeben und könnte inzwischen von jemand anderem gewählt worden sein. Bitte wählen Sie einen neuen Zeitpunkt.", checkout_hold_expired_action:"Neuen Termin wählen", checkout_return_policy_title:"Rückgaberecht — bitte lesen", checkout_return_policy_body:"Gemäss unseren Ladenrichtlinien kann ein Produkt, das geöffnet oder benutzt wurde, nicht zurückgegeben werden.", checkout_return_pledge_label:"Ich verpflichte mich, das Produkt nicht zu öffnen und nicht zu benutzen, wenn ich es zurückgeben möchte.", checkout_return_pledge_required:"Bitte bestätigen Sie das Rückgabeversprechen, um fortzufahren.", ret_request_btn:"Rückgabe anfordern", ret_modal_title:"Produkt zurückgeben", ret_modal_intro:"Damit Ihr Produkt für eine Rückgabe in Frage kommt, darf es weder geöffnet noch benutzt worden sein.", ret_pledge_label:"Ich bestätige, dass das Produkt nicht geöffnet und nicht benutzt wurde und ich es im Zustand zurücksende, in dem ich es erhalten habe.", ret_pledge_required:"Bitte bestätigen Sie das Rückgabeversprechen.", ret_reason_group_product:"Problem mit dem Produkt oder der Bestellung", ret_reason_group_customer:"Persönlicher Grund", ret_reason_damaged:"Das Produkt ist beschädigt", ret_reason_shipping_damage:"Es kam beschädigt an", ret_reason_wrong_item:"Das gelieferte Produkt entspricht nicht der Bestellung", ret_reason_order_error:"Fehler in der Bestellung", ret_reason_other_issue:"Ein anderes Problem mit dem Produkt", ret_reason_changed_mind:"Ich habe meine Meinung geändert", ret_reason_no_longer_needed:"Ich brauche es nicht mehr", ret_reason_wrong_choice:"Ich habe versehentlich das falsche Produkt gewählt", ret_reason_other:"Anderer Grund", ret_reason_placeholder:"Bitte beschreiben Sie den Grund…", ret_submit:"Anfrage senden", ret_created:"Ihre Rückgabeanfrage wurde erstellt.", ret_error:"Anfrage konnte nicht erstellt werden.", ret_only_delivered:"Rückgabe verfügbar, sobald die Bestellung geliefert wurde.", ret_status_requested:"Rückgabe angefragt", ret_status_under_review:"In Prüfung", ret_status_approved:"Rückgabe genehmigt", ret_status_rejected:"Rückgabe abgelehnt", ret_existing_title:"Rückgabestatus", ret_existing_hint:"Wir melden uns bei Ihnen mit den nächsten Schritten.", ret_resolution_free:"Kostenlose Rückgabe · Versand vom Salon übernommen", ret_resolution_paid:"Kundengezahlte Rückgabe · Versand zu Ihren Lasten", ret_rma_code:"RMA-Code", ret_refund_amount:"Rückerstattungsbetrag", ret_refund_status_processing:"Rückerstattung wird bearbeitet", ret_refund_status_succeeded:"Rückerstattung ausgeführt", ret_refund_status_failed:"Rückerstattung noch in Bearbeitung", ret_refund_bank_note:"Wie lange der Betrag auf Ihrem Konto sichtbar wird, hängt von Ihrer Bank oder Ihrem Kartenanbieter ab und kann mehrere Werktage dauern.", ret_inspection_failed_hint:"Nach der Prüfung konnten wir Ihre Rücksendung leider nicht annehmen. Bitte kontaktieren Sie uns bei Fragen.", ret_step_requested:"Rückgabe angefragt", ret_step_received:"Rücksendung erhalten", ret_step_inspected:"Produkt geprüft", ret_step_refund_initiated:"Rückerstattung gestartet", ret_step_refund_complete:"Rückerstattung abgeschlossen", ret_step_rejected:"Rückgabe abgelehnt", ret_step_refund_issue:"Rückerstattung — Problem", ret_refund_issue_body:"Die Rückerstattung konnte noch nicht abgeschlossen werden und wird weiter bearbeitet. Sie müssen nichts unternehmen — bei Fragen erreichen Sie uns unter info@01co.ch.", ret_info_order:"Bestellnummer", ret_info_requested:"Angefragt am", ret_info_received:"Erhalten am", ret_info_inspected:"Geprüft am", ret_info_refunded:"Erstattet am", ret_info_products:"Zurückgesendete Produkte", ret_info_products_all:"Gesamte Bestellung" },
  fr: { cat_natuerliche_oele:"Huiles Naturelles", cat_aleppo_seife:"Savon d'Alep", cat_henna:"Henné", cat_miswak:"Miswak", cat_weihrauch:"Encens", story_since_2011:"Depuis 2011", story_title:"Un savoir-faire suisse, enraciné à Glaris.", story_body:"Coiffeur Tattoo 01&Co. incarne depuis plus d'une décennie style, qualité et artisanat attentif. Depuis notre salon à Glaris, nous vous proposons des soins soigneusement sélectionnés pour cheveux, barbe et peau.", page_title:"Coiffeur Tattoo 01&Co. — Soins naturels suisses & beauté", contact_short:"Kirchweg 20 · 8750 Glaris · Suisse", legal_notice_en:"Version juridiquement contraignante : allemand. Traduction anglaise à titre informatif uniquement." },
  it: { cat_natuerliche_oele:"Oli Naturali", cat_aleppo_seife:"Sapone di Aleppo", cat_henna:"Henné", cat_miswak:"Miswak", cat_weihrauch:"Incenso", story_since_2011:"Dal 2011", story_title:"Un artigianato svizzero, radicato a Glarona.", story_body:"Da oltre un decennio, Coiffeur Tattoo 01&Co. rappresenta stile, qualità e artigianato attento. Dal nostro salone di Glarona vi offriamo prodotti selezionati con cura per capelli, barba e pelle.", page_title:"Coiffeur Tattoo 01&Co. — Cura naturale svizzera & Bellezza", contact_short:"Kirchweg 20 · 8750 Glarona · Svizzera", legal_notice_en:"Versione giuridicamente vincolante: tedesco. Traduzione inglese solo a scopo informativo." },
  en: { cat_natuerliche_oele:"Natural Oils", cat_aleppo_seife:"Aleppo Soap", cat_henna:"Henna", cat_miswak:"Miswak", cat_weihrauch:"Incense", story_since_2011:"Since 2011", story_title:"Swiss craftsmanship, rooted in Glarus.", story_body:"For over a decade, Coiffeur Tattoo 01&Co. has stood for style, quality and attentive craftsmanship. From our salon in Glarus we bring you carefully curated care products for hair, beard and skin.", page_title:"Coiffeur Tattoo 01&Co. — Swiss natural care & beauty", contact_short:"Kirchweg 20 · 8750 Glarus · Switzerland", legal_notice_en:"Legally binding version: German. English translation for information only.", book_added_to_cart:"Added to your bookings", book_review_eyebrow:"Booking summary", book_review_title:"Almost there — anything else?", book_review_question:"Would you like to add another service, a product, or continue to time selection?", book_review_your_services:"Your services", book_review_your_products:"Your products", book_review_add_service:"Add another service", book_review_add_product:"Add a product", book_review_continue_pay:"Continue to payment", book_review_continue_schedule:"Continue to time selection", book_review_summary:"Summary", book_review_services_total:"Services total", book_review_deposit_now:"Deposit now", book_review_rest_at_salon:"Rest at the salon", book_review_products_total:"Products total", book_review_due_now:"Total due now", book_review_split_note:"Services: 50% deposit online now, remainder in the salon. Products: paid in full online.", checkout_first_name:"First name", checkout_last_name:"Last name", checkout_street:"Street & house number", checkout_apartment:"Apartment / Floor (optional)", book_multi_hint:"Pick as many services from any category as you like. You'll choose the date and time in the next step.", book_your_cart:"Your selection", book_cart_empty:"No services selected yet.", book_add:"Add", book_remove:"Remove", book_schedule_hint:"Total duration:", book_customer_eyebrow:"Your details", book_customer_hint:"Please fill in once — next time we'll pre-fill your details automatically.", book_autofilled:"Auto-filled", book_fill_required:"Please fill in all required fields.", book_login_hint:"Tip: sign in so we can pre-fill your details next time.", book_edit:"Edit", book_reservation:"Reservation", book_payment_breakdown:"Payment breakdown", book_your_visit:"Your visit", book_visit_hint:"We look forward to seeing you. The remaining balance is due in the salon.", book_loading_details:"Loading details …", book_deposit_required:"Services require an online deposit. Redirecting to Stripe …", checkout_pay_online:"Pay online", checkout_pay_online_hint:"Card, TWINT, Apple Pay, Klarna – secure via Stripe.", checkout_pay_in_store:"Pay at the salon", checkout_pay_in_store_hint:"Reserve now, pay by cash or card when you pick up at the salon (Kirchweg 20, Glarus).", checkout_pay_in_store_deposit_hint:"Appointments require an online deposit. The remaining balance is paid at the salon.", book_deposit_note_title:"Important note about the deposit (50%)", book_deposit_note_body:"The deposit is retained according to our cancellation and lateness policy: cancellations less than 24 h before the appointment, same-day bookings, no-shows, and arriving more than 5 minutes late without calling ahead. Cancellations made ≥ 24 h in advance are fully refunded.", otp_title:"E-mail verification", otp_heading:"Enter your code", otp_sent:"We've e-mailed you a code.", otp_sent_to:"We've sent a 6-digit code to:", otp_verify:"Confirm", otp_resend:"Resend code", otp_resent:"New code sent.", otp_verified:"E-mail verified — welcome!", otp_invalid:"Wrong code. Please try again.", otp_expires_hint:"The code is valid for 10 minutes. Please check your spam folder if needed.", welcome:"Welcome", auth_error:"Sign-in error.", login_with_google:"Continue with Google", auth_or:"or", checkout_hold_title:"Your reservation", checkout_hold_hint:"Your selected slot is being held for you. Please complete payment before the timer runs out.", checkout_hold_expiring:"Hold expiring soon", checkout_hold_expired_title:"Your reservation has expired", checkout_hold_expired_body:"The slot has been released and may have been taken by someone else. Please pick a new time.", checkout_hold_expired_action:"Choose a new time", checkout_return_policy_title:"Return policy — please read", checkout_return_policy_body:"Under our store policy, a product that has been opened or used cannot be returned.", checkout_return_pledge_label:"I pledge not to open or use the product if I intend to return it.", checkout_return_pledge_required:"Please confirm the return pledge to continue.", ret_request_btn:"Request a return", ret_modal_title:"Return the product", ret_modal_intro:"To be eligible for a return, the product must not have been opened or used.", ret_pledge_label:"I confirm the product has not been opened or used and that I will send it back in the condition I received it.", ret_pledge_required:"Please confirm the return pledge.", ret_reason_group_product:"Problem with the product or order", ret_reason_group_customer:"Personal reason", ret_reason_damaged:"The product is damaged", ret_reason_shipping_damage:"It arrived damaged", ret_reason_wrong_item:"The item delivered does not match my order", ret_reason_order_error:"There is a mistake in the order", ret_reason_other_issue:"Another problem with the product", ret_reason_changed_mind:"I changed my mind", ret_reason_no_longer_needed:"I no longer need it", ret_reason_wrong_choice:"I picked the wrong product by mistake", ret_reason_other:"Another reason", ret_reason_placeholder:"Please describe the reason…", ret_submit:"Send request", ret_created:"Your return request has been created.", ret_error:"Could not create the request.", ret_only_delivered:"Returns are available once the order has been delivered.", ret_status_requested:"Return requested", ret_status_under_review:"Under review", ret_status_approved:"Return approved", ret_status_rejected:"Return rejected", ret_existing_title:"Return status", ret_existing_hint:"We'll get back to you with the next steps.", ret_resolution_free:"Free return · shipping covered by the salon", ret_resolution_paid:"Customer-paid return · shipping at your cost", ret_rma_code:"RMA code", ret_refund_amount:"Refund amount", ret_refund_status_processing:"Refund is being processed", ret_refund_status_succeeded:"Refund issued", ret_refund_status_failed:"Refund still being processed", ret_refund_bank_note:"How long the amount takes to appear on your account depends on your bank or card provider and may take several business days.", ret_inspection_failed_hint:"After inspecting your parcel we couldn't accept the return. Please contact us if you have any questions.", ret_step_requested:"Return requested", ret_step_received:"Return received", ret_step_inspected:"Product inspected", ret_step_refund_initiated:"Refund initiated", ret_step_refund_complete:"Refund complete", ret_step_rejected:"Return rejected", ret_step_refund_issue:"Refund — issue", ret_refund_issue_body:"The refund hasn't completed yet and is still being processed. There's nothing you need to do — please contact us at info@01co.ch if you have any questions.", ret_info_order:"Order number", ret_info_requested:"Requested on", ret_info_received:"Received on", ret_info_inspected:"Inspected on", ret_info_refunded:"Refunded on", ret_info_products:"Products returned", ret_info_products_all:"Whole order" },
  es: { cat_natuerliche_oele:"Aceites Naturales", cat_aleppo_seife:"Jabón de Alepo", cat_henna:"Henna", cat_miswak:"Miswak", cat_weihrauch:"Incienso", story_since_2011:"Desde 2011", story_title:"Artesanía suiza, arraigada en Glarus.", story_body:"Durante más de una década, Coiffeur Tattoo 01&Co. representa estilo, calidad y artesanía atenta. Desde nuestro salón en Glarus te ofrecemos productos de cuidado cuidadosamente seleccionados para cabello, barba y piel.", page_title:"Coiffeur Tattoo 01&Co. — Cuidado natural suizo y belleza", contact_short:"Kirchweg 20 · 8750 Glarus · Suiza", legal_notice_en:"Versión jurídicamente vinculante: alemán. Traducción al inglés solo a título informativo." },
  pt: { cat_natuerliche_oele:"Óleos Naturais", cat_aleppo_seife:"Sabonete de Alepo", cat_henna:"Henna", cat_miswak:"Miswak", cat_weihrauch:"Incenso", story_since_2011:"Desde 2011", story_title:"Artesanato suíço, enraizado em Glarus.", story_body:"Há mais de uma década, a Coiffeur Tattoo 01&Co. representa estilo, qualidade e um artesanato atento. Do nosso salão em Glarus oferecemos produtos de cuidado cuidadosamente selecionados para cabelo, barba e pele.", page_title:"Coiffeur Tattoo 01&Co. — Cuidado natural suíço & Beleza", contact_short:"Kirchweg 20 · 8750 Glarus · Suíça", legal_notice_en:"Versão juridicamente vinculativa: alemão. Tradução em inglês apenas para fins informativos." },
  nl: { cat_natuerliche_oele:"Natuurlijke Oliën", cat_aleppo_seife:"Aleppo-Zeep", cat_henna:"Henna", cat_miswak:"Miswak", cat_weihrauch:"Wierook", story_since_2011:"Sinds 2011", story_title:"Zwitsers vakmanschap, geworteld in Glarus.", story_body:"Al meer dan tien jaar staat Coiffeur Tattoo 01&Co. voor stijl, kwaliteit en aandachtig vakmanschap. Vanuit onze salon in Glarus bieden we u zorgvuldig samengestelde verzorgingsproducten voor haar, baard en huid.", page_title:"Coiffeur Tattoo 01&Co. — Zwitserse natuurlijke verzorging & Beauty", contact_short:"Kirchweg 20 · 8750 Glarus · Zwitserland", legal_notice_en:"Juridisch bindende versie: Duits. Engelse vertaling uitsluitend ter informatie." },
  sv: { cat_natuerliche_oele:"Naturliga Oljor", cat_aleppo_seife:"Aleppo-Tvål", cat_henna:"Henna", cat_miswak:"Miswak", cat_weihrauch:"Rökelse", story_since_2011:"Sedan 2011", story_title:"Schweiziskt hantverk, rotat i Glarus.", story_body:"I mer än ett decennium har Coiffeur Tattoo 01&Co. stått för stil, kvalitet och omsorgsfullt hantverk. Från vår salong i Glarus erbjuder vi noggrant utvalda hår-, skägg- och hudvårdsprodukter.", page_title:"Coiffeur Tattoo 01&Co. — Schweizisk naturlig omvårdnad & Skönhet", contact_short:"Kirchweg 20 · 8750 Glarus · Schweiz", legal_notice_en:"Juridiskt bindande version: tyska. Engelsk översättning endast i informationssyfte." },
  hr: { cat_natuerliche_oele:"Prirodna Ulja", cat_aleppo_seife:"Aleppo Sapun", cat_henna:"Kana", cat_miswak:"Miswak", cat_weihrauch:"Tamjan", story_since_2011:"Od 2011.", story_title:"Švicarski zanat, ukorijenjen u Glarusu.", story_body:"Već više od desetljeća Coiffeur Tattoo 01&Co. znači stil, kvalitetu i pažljiv zanat. Iz našeg salona u Glarusu donosimo vam pažljivo odabrane proizvode za kosu, bradu i kožu.", page_title:"Coiffeur Tattoo 01&Co. — Švicarska prirodna njega & Ljepota", contact_short:"Kirchweg 20 · 8750 Glarus · Švicarska", legal_notice_en:"Pravno obvezujuća verzija: njemački. Engleski prijevod samo u informativne svrhe." },
  sr: { cat_natuerliche_oele:"Prirodna Ulja", cat_aleppo_seife:"Aleppo Sapun", cat_henna:"Kana", cat_miswak:"Miswak", cat_weihrauch:"Tamjan", story_since_2011:"Od 2011.", story_title:"Švajcarski zanat, ukorenjen u Glarusu.", story_body:"Više od decenije Coiffeur Tattoo 01&Co. predstavlja stil, kvalitet i pažljiv zanat. Iz našeg salona u Glarusu donosimo vam pažljivo odabrane proizvode za kosu, bradu i kožu.", page_title:"Coiffeur Tattoo 01&Co. — Švajcarska prirodna nega & Lepota", contact_short:"Kirchweg 20 · 8750 Glarus · Švajcarska", legal_notice_en:"Pravno obavezujuća verzija: nemački. Engleski prevod samo u informativne svrhe." },
  bs: { cat_natuerliche_oele:"Prirodna Ulja", cat_aleppo_seife:"Aleppo Sapun", cat_henna:"Kana", cat_miswak:"Miswak", cat_weihrauch:"Tamjan", story_since_2011:"Od 2011.", story_title:"Švicarski zanat, ukorijenjen u Glarusu.", story_body:"Više od jedne decenije Coiffeur Tattoo 01&Co. predstavlja stil, kvalitet i pažljiv zanat. Iz našeg salona u Glarusu donosimo vam pažljivo odabrane proizvode za kosu, bradu i kožu.", page_title:"Coiffeur Tattoo 01&Co. — Švicarska prirodna njega & Ljepota", contact_short:"Kirchweg 20 · 8750 Glarus · Švicarska", legal_notice_en:"Pravno obavezujuća verzija: njemački. Engleski prijevod samo u informativne svrhe." },
  sq: { cat_natuerliche_oele:"Vajra Natyrore", cat_aleppo_seife:"Sapun Aleppo", cat_henna:"Kanë", cat_miswak:"Miswak", cat_weihrauch:"Temjan", story_since_2011:"Që nga 2011", story_title:"Zanat zviceran, i rrënjosur në Glarus.", story_body:"Prej më shumë se një dekade, Coiffeur Tattoo 01&Co. përfaqëson stil, cilësi dhe zanat të kujdesshëm. Nga sallon jonë në Glarus ju sjellim produkte kujdesi të zgjedhura me kujdes për flokë, mjekër dhe lëkurë.", page_title:"Coiffeur Tattoo 01&Co. — Kujdes natyror zviceran & Bukuri", contact_short:"Kirchweg 20 · 8750 Glarus · Zvicër", legal_notice_en:"Versioni ligjërisht i detyrueshëm: gjermanisht. Përkthimi në anglisht vetëm për informim." },
  tr: { cat_natuerliche_oele:"Doğal Yağlar", cat_aleppo_seife:"Halep Sabunu", cat_henna:"Kına", cat_miswak:"Misvak", cat_weihrauch:"Tütsü", story_since_2011:"2011'den beri", story_title:"Glarus'ta kök salmış İsviçre zanaatı.", story_body:"On yılı aşkın süredir Coiffeur Tattoo 01&Co. stil, kalite ve özenli zanaatı temsil ediyor. Glarus'taki salonumuzdan saç, sakal ve cilt için özenle seçilmiş ürünler sunuyoruz.", page_title:"Coiffeur Tattoo 01&Co. — İsviçre doğal bakım & Güzellik", contact_short:"Kirchweg 20 · 8750 Glarus · İsviçre", legal_notice_en:"Hukuken bağlayıcı sürüm: Almanca. İngilizce çeviri yalnızca bilgi amaçlıdır." },
  ar: { cat_natuerliche_oele:"الزيوت الطبيعية", cat_aleppo_seife:"صابون حلب", cat_henna:"حنّة", cat_miswak:"سواك", cat_weihrauch:"بخور", story_since_2011:"منذ 2011", story_title:"حرفة سويسرية متجذّرة في غلاروس.", story_body:"منذ أكثر من عقد، تجسّد Coiffeur Tattoo 01&Co. الأناقة والجودة والحرفية الدقيقة. من صالوننا في غلاروس نقدّم لكم منتجات عناية مختارة بعناية للشعر واللحية والبشرة.", page_title:"Coiffeur Tattoo 01&Co. — العناية الطبيعية السويسرية والجمال", contact_short:"Kirchweg 20 · 8750 غلاروس · سويسرا", legal_notice_en:"النسخة الملزمة قانونياً: الألمانية. الترجمة الإنجليزية للاطلاع فقط.", book_added_to_cart:"تمت الإضافة إلى الحجز", book_review_eyebrow:"ملخص الحجز", book_review_title:"اقتربنا — هل تريد إضافة شيء آخر؟", book_review_question:"هل تريد إضافة خدمة أخرى، منتجاً، أم المتابعة لاختيار الموعد؟", book_review_your_services:"خدماتك", book_review_your_products:"منتجاتك", book_review_add_service:"إضافة خدمة أخرى", book_review_add_product:"إضافة منتج", book_review_continue_pay:"المتابعة للدفع", book_review_continue_schedule:"المتابعة لاختيار الموعد", book_review_summary:"الملخص", book_review_services_total:"إجمالي الخدمات", book_review_deposit_now:"العربون الآن", book_review_rest_at_salon:"الباقي في الصالون", book_review_products_total:"إجمالي المنتجات", book_review_due_now:"الإجمالي المستحق الآن", book_review_split_note:"الخدمات: 50٪ عربون أونلاين الآن، والباقي في الصالون. المنتجات: تُدفع كاملة أونلاين.", checkout_first_name:"الاسم الأول", checkout_last_name:"اسم العائلة", checkout_street:"الشارع ورقم المبنى", checkout_apartment:"رقم الشقة / الطابق (اختياري)", book_multi_hint:"اختر أي عدد من الخدمات من أي فئة. سيتم اختيار التاريخ والوقت في الخطوة التالية.", book_your_cart:"اختيارك", book_cart_empty:"لم يتم اختيار أي خدمات بعد.", book_add:"إضافة", book_remove:"إزالة", book_schedule_hint:"المدة الإجمالية:", book_customer_eyebrow:"بياناتك", book_customer_hint:"املأ البيانات مرة واحدة فقط — سنتذكرها لك في المرات القادمة.", book_autofilled:"تم التعبئة تلقائياً", book_fill_required:"الرجاء ملء جميع الحقول المطلوبة.", book_login_hint:"نصيحة: سجّل الدخول لنحفظ بياناتك تلقائياً.", book_edit:"تعديل", book_reservation:"حجز", book_payment_breakdown:"تفاصيل الدفع", book_your_visit:"زيارتك", book_visit_hint:"نتطلع لاستقبالك. المبلغ المتبقي يُدفع في الصالون.", book_loading_details:"جارٍ تحميل التفاصيل …", book_deposit_required:"الخدمات تتطلب عربوناً أونلاين. جارٍ التحويل إلى Stripe …", checkout_pay_online:"الدفع أونلاين", checkout_pay_online_hint:"بطاقة، TWINT، Apple Pay، Klarna — عبر Stripe الآمن.", checkout_pay_in_store:"الدفع في الصالون", checkout_pay_in_store_hint:"احجز الآن وادفع نقداً أو بالبطاقة عند الاستلام في الصالون (Kirchweg 20, Glarus).", checkout_pay_in_store_deposit_hint:"المواعيد تتطلب عربوناً أونلاين. الباقي يُدفع في الصالون.", book_deposit_note_title:"ملاحظة مهمة حول العربون (50٪)", book_deposit_note_body:"يتم الاحتفاظ بالعربون وفقاً لسياسة الإلغاء والتأخير: عند الإلغاء قبل أقل من 24 ساعة من الموعد، عند الحجز في نفس اليوم، عند عدم الحضور، وعند التأخر أكثر من 5 دقائق دون اتصال مسبق. عند الإلغاء المبكر (≥ 24 ساعة) يتم إرجاع العربون بالكامل.", otp_title:"تأكيد البريد الإلكتروني", otp_heading:"أدخل الرمز", otp_sent:"أرسلنا لك رمز التحقق عبر البريد الإلكتروني.", otp_sent_to:"أرسلنا رمزاً من 6 أرقام إلى:", otp_verify:"تأكيد", otp_resend:"إعادة إرسال الرمز", otp_resent:"تم إرسال رمز جديد.", otp_verified:"تم تأكيد البريد الإلكتروني — أهلاً بك!", otp_invalid:"الرمز غير صحيح. يرجى المحاولة مرة أخرى.", otp_expires_hint:"الرمز صالح لمدة 10 دقائق. تحقق من مجلد الرسائل غير المرغوبة إذا لزم الأمر.", welcome:"أهلاً وسهلاً", auth_error:"خطأ في تسجيل الدخول.", login_with_google:"المتابعة عبر Google", auth_or:"أو", checkout_hold_title:"حجزك", checkout_hold_hint:"موعدك محجوز لك مؤقتاً. يُرجى إتمام الدفع قبل انتهاء المهلة.", checkout_hold_expiring:"الحجز على وشك الانتهاء", checkout_hold_expired_title:"انتهت مهلة حجزك", checkout_hold_expired_body:"تم تحرير الموعد وربما قام شخص آخر باختياره. يُرجى اختيار موعد جديد.", checkout_hold_expired_action:"اختيار موعد جديد", checkout_return_policy_title:"سياسة الإرجاع — يُرجى القراءة", checkout_return_policy_body:"وفقاً لسياسة متجرنا، لا يمكن إرجاع أي منتج تم فتحه أو استخدامه.", checkout_return_pledge_label:"أتعهد بأنني لن أفتح أو أستخدم المنتج إذا كنت أرغب في إرجاعه.", checkout_return_pledge_required:"يُرجى الموافقة على تعهد الإرجاع لإكمال الشراء.", ret_request_btn:"طلب إرجاع المنتج", ret_modal_title:"إرجاع المنتج", ret_modal_intro:"لكي يكون المنتج مؤهلاً للإرجاع، يجب أن يكون غير مفتوح وغير مستخدم.", ret_pledge_label:"أتعهد بأن المنتج لم يتم فتحه أو استخدامه، وأنني سأعيده بالحالة التي استلمته بها.", ret_pledge_required:"يُرجى الموافقة على تعهد الإرجاع.", ret_reason_group_product:"مشكلة في المنتج أو الطلب", ret_reason_group_customer:"سبب من العميل", ret_reason_damaged:"المنتج تالف", ret_reason_shipping_damage:"المنتج وصل متضرراً", ret_reason_wrong_item:"المنتج المُستلَم مختلف عن الطلب", ret_reason_order_error:"يوجد خطأ في الطلب", ret_reason_other_issue:"مشكلة أخرى متعلقة بالمنتج", ret_reason_changed_mind:"غيّرتُ رأيي", ret_reason_no_longer_needed:"لم أعد بحاجة إليه", ret_reason_wrong_choice:"اخترتُ المنتج بالخطأ", ret_reason_other:"سبب آخر", ret_reason_placeholder:"يُرجى وصف السبب…", ret_submit:"إرسال الطلب", ret_created:"تم إنشاء طلب الإرجاع الخاص بك.", ret_error:"تعذّر إنشاء الطلب.", ret_only_delivered:"طلبات الإرجاع متاحة بعد تسليم الطلب.", ret_status_requested:"طلب إرجاع مُرسَل", ret_status_under_review:"قيد المراجعة", ret_status_approved:"تمت الموافقة على الإرجاع", ret_status_rejected:"تم رفض الإرجاع", ret_existing_title:"حالة الإرجاع", ret_existing_hint:"سنتواصل معك بالخطوات التالية.", ret_resolution_free:"إرجاع مجاني · تكلفة الشحن على المتجر", ret_resolution_paid:"إرجاع بتكلفة العميل · تكلفة الشحن عليك", ret_rma_code:"رمز RMA", ret_refund_amount:"مبلغ الاسترداد", ret_refund_status_processing:"جاري تنفيذ الاسترداد", ret_refund_status_succeeded:"تم تنفيذ الاسترداد", ret_refund_status_failed:"الاسترداد لا يزال قيد المعالجة", ret_refund_bank_note:"مدة ظهور المبلغ في حسابك تعتمد على البنك أو مزوّد البطاقة الخاص بك، وقد تستغرق عدة أيام عمل.", ret_inspection_failed_hint:"بعد فحص طردك لم نتمكّن من قبول الإرجاع. تواصل معنا في حال وجود أي استفسار.", ret_step_requested:"تم طلب الإرجاع", ret_step_received:"تم استلام المنتج", ret_step_inspected:"تم فحص المنتج", ret_step_refund_initiated:"بدء استرداد المبلغ", ret_step_refund_complete:"اكتمل الاسترداد", ret_step_rejected:"تم رفض الإرجاع", ret_step_refund_issue:"مشكلة في الاسترداد", ret_refund_issue_body:"لم تكتمل عملية الاسترداد بعد وهي لا تزال قيد المعالجة. لا يلزم أي إجراء من طرفك — للاستفسار: info@01co.ch.", ret_info_order:"رقم الطلب", ret_info_requested:"تاريخ الطلب", ret_info_received:"تاريخ الاستلام", ret_info_inspected:"تاريخ الفحص", ret_info_refunded:"تاريخ الاسترداد", ret_info_products:"المنتجات المُرجَعة", ret_info_products_all:"الطلب بالكامل" },
  fa: { cat_natuerliche_oele:"روغن‌های طبیعی", cat_aleppo_seife:"صابون حلب", cat_henna:"حنا", cat_miswak:"مسواک", cat_weihrauch:"عود/بخور", story_since_2011:"از سال ۲۰۱۱", story_title:"صنعت‌گری سوئیسی، ریشه‌دار در گلاروس.", story_body:"بیش از یک دهه است که Coiffeur Tattoo 01&Co. نماد سبک، کیفیت و صنعت‌گری دقیق است. از سالن ما در گلاروس، محصولات مراقبتی گلچین‌شده برای مو، ریش و پوست را برای شما فراهم می‌کنیم.", page_title:"Coiffeur Tattoo 01&Co. — مراقبت طبیعی سوئیسی و زیبایی", contact_short:"Kirchweg 20 · ۸۷۵۰ گلاروس · سوئیس", legal_notice_en:"نسخهٔ الزام‌آور حقوقی: آلمانی. ترجمهٔ انگلیسی صرفاً جهت اطلاع." },
  ta: { cat_natuerliche_oele:"இயற்கை எண்ணெய்கள்", cat_aleppo_seife:"அலெப்போ சோப்பு", cat_henna:"மருதாணி", cat_miswak:"மிஸ்வாக்", cat_weihrauch:"ஊதுவத்தி", story_since_2011:"2011 முதல்", story_title:"Glarus இல் வேரூன்றிய சுவிஸ் கைவினை.", story_body:"ஒரு தசாப்தத்திற்கும் மேலாக Coiffeur Tattoo 01&Co. நடை, தரம் மற்றும் கவனமான கைவினைத்திறனை பிரதிநிதித்துவப்படுத்துகிறது. Glarus இல் உள்ள எங்கள் சலூனில் இருந்து முடி, தாடி மற்றும் தோலுக்கான கவனமாக தேர்ந்தெடுக்கப்பட்ட பராமரிப்பு தயாரிப்புகளை உங்களுக்கு வழங்குகிறோம்.", page_title:"Coiffeur Tattoo 01&Co. — சுவிஸ் இயற்கை பராமரிப்பு & அழகு", contact_short:"Kirchweg 20 · 8750 Glarus · சுவிட்சர்லாந்து", legal_notice_en:"சட்டப்படி பிணைப்பான பதிப்பு: ஜெர்மன். ஆங்கில மொழிபெயர்ப்பு தகவலுக்காக மட்டுமே." },
};

const dict = { de: { ...base, ...(EXTRA_I18N.de || {}) } };
for (const [lang, o] of Object.entries(overrides)) {
  dict[lang] = { ...base, ...(EXTRA_I18N.de || {}), ...(EXTRA_I18N[lang] || {}), ...o }; // fill missing keys with German, then per-lang extras override, then explicit overrides
}

// Missing-key tracker — writes to window.__i18nMissing so tests can assert = 0
// per language. In development we also console.warn to surface gaps loudly.
// In production we NEVER silently fall back to another language — we return the
// KEY itself so the missing string is visible on-screen and impossible to miss.
const IS_DEV = typeof process !== "undefined" && process.env && process.env.NODE_ENV !== "production";
export function t(lang, key) {
  const v = dict[lang]?.[key];
  if (v !== undefined) return v;
  // record the miss
  if (typeof window !== "undefined") {
    window.__i18nMissing = window.__i18nMissing || {};
    (window.__i18nMissing[lang] = window.__i18nMissing[lang] || new Set()).add(key);
  }
  if (IS_DEV && typeof console !== "undefined") {
    console.warn(`[i18n] missing "${key}" for lang="${lang}"`);
  }
  // No silent DE/EN fallback. Show the key so gaps are visible and testable.
  return key;
}

export { KEEP };
export default dict;
